(function () {
  'use strict';

  angular
    .module('app.core', [
    ]);

  angular
    .module('fileUpload', ['ngFileUpload']);

  angular
    .module('app', [
      'app.core',
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ui.router',
      'ui.bootstrap',
      'toastr',
      'daterangepicker',
      'pascalprecht.translate',
      'fileUpload'
    ]);

})();

/*
 Highcharts JS v5.0.14 (2017-07-28)

 (c) 2009-2016 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(x){"object"===typeof module&&module.exports?module.exports=x:x(Highcharts)})(function(x){(function(b){function t(b,a){this.init(b,a)}var u=b.CenteredSeriesMixin,v=b.each,g=b.extend,f=b.merge,k=b.splat;g(t.prototype,{coll:"pane",init:function(b,a){this.chart=a;this.background=[];a.pane.push(this);this.setOptions(b)},setOptions:function(b){this.options=f(this.defaultOptions,this.chart.angular?{background:{}}:void 0,b)},render:function(){var b=this.options,a=this.options.background,c=this.chart.renderer;
this.group||(this.group=c.g("pane-group").attr({zIndex:b.zIndex||0}).add());this.updateCenter();if(a)for(a=k(a),b=Math.max(a.length,this.background.length||0),c=0;c<b;c++)a[c]&&this.axis?this.renderBackground(f(this.defaultBackgroundOptions,a[c]),c):this.background[c]&&(this.background[c]=this.background[c].destroy(),this.background.splice(c,1))},renderBackground:function(b,a){var c="animate";this.background[a]||(this.background[a]=this.chart.renderer.path().add(this.group),c="attr");this.background[a][c]({d:this.axis.getPlotBandPath(b.from,
b.to,b)}).attr({"class":"highcharts-pane "+(b.className||"")})},defaultOptions:{center:["50%","50%"],size:"85%",startAngle:0},defaultBackgroundOptions:{shape:"circle",from:-Number.MAX_VALUE,innerRadius:0,to:Number.MAX_VALUE,outerRadius:"105%"},updateCenter:function(b){this.center=(b||this.axis||{}).center=u.getCenter.call(this)},update:function(b,a){f(!0,this.options,b);this.setOptions(this.options);this.render();v(this.chart.axes,function(c){c.pane===this&&(c.pane=null,c.update({},a))},this)}});
b.Pane=t})(x);(function(b){var t=b.each,u=b.extend,v=b.map,g=b.merge,f=b.noop,k=b.pick,q=b.pInt,a=b.wrap,c,h,l=b.Axis.prototype;b=b.Tick.prototype;c={getOffset:f,redraw:function(){this.isDirty=!1},render:function(){this.isDirty=!1},setScale:f,setCategories:f,setTitle:f};h={defaultRadialGaugeOptions:{labels:{align:"center",x:0,y:null},minorGridLineWidth:0,minorTickInterval:"auto",minorTickLength:10,minorTickPosition:"inside",minorTickWidth:1,tickLength:10,tickPosition:"inside",tickWidth:2,title:{rotation:0},
zIndex:2},defaultRadialXOptions:{gridLineWidth:1,labels:{align:null,distance:15,x:0,y:null},maxPadding:0,minPadding:0,showLastLabel:!1,tickLength:0},defaultRadialYOptions:{gridLineInterpolation:"circle",labels:{align:"right",x:-3,y:-2},showLastLabel:!1,title:{x:4,text:null,rotation:90}},setOptions:function(d){d=this.options=g(this.defaultOptions,this.defaultRadialOptions,d);d.plotBands||(d.plotBands=[])},getOffset:function(){l.getOffset.call(this);this.chart.axisOffset[this.side]=0},getLinePath:function(d,
a){d=this.center;var c=this.chart,e=k(a,d[2]/2-this.offset);this.isCircular||void 0!==a?a=this.chart.renderer.symbols.arc(this.left+d[0],this.top+d[1],e,e,{start:this.startAngleRad,end:this.endAngleRad,open:!0,innerR:0}):(a=this.postTranslate(this.angleRad,e),a=["M",d[0]+c.plotLeft,d[1]+c.plotTop,"L",a.x,a.y]);return a},setAxisTranslation:function(){l.setAxisTranslation.call(this);this.center&&(this.transA=this.isCircular?(this.endAngleRad-this.startAngleRad)/(this.max-this.min||1):this.center[2]/
2/(this.max-this.min||1),this.minPixelPadding=this.isXAxis?this.transA*this.minPointOffset:0)},beforeSetTickPositions:function(){if(this.autoConnect=this.isCircular&&void 0===k(this.userMax,this.options.max)&&this.endAngleRad-this.startAngleRad===2*Math.PI)this.max+=this.categories&&1||this.pointRange||this.closestPointRange||0},setAxisSize:function(){l.setAxisSize.call(this);this.isRadial&&(this.pane.updateCenter(this),this.isCircular&&(this.sector=this.endAngleRad-this.startAngleRad),this.len=this.width=
this.height=this.center[2]*k(this.sector,1)/2)},getPosition:function(d,a){return this.postTranslate(this.isCircular?this.translate(d):this.angleRad,k(this.isCircular?a:this.translate(d),this.center[2]/2)-this.offset)},postTranslate:function(d,a){var c=this.chart,e=this.center;d=this.startAngleRad+d;return{x:c.plotLeft+e[0]+Math.cos(d)*a,y:c.plotTop+e[1]+Math.sin(d)*a}},getPlotBandPath:function(d,a,c){var e=this.center,h=this.startAngleRad,b=e[2]/2,n=[k(c.outerRadius,"100%"),c.innerRadius,k(c.thickness,
10)],l=Math.min(this.offset,0),f=/%$/,y,g=this.isCircular;"polygon"===this.options.gridLineInterpolation?e=this.getPlotLinePath(d).concat(this.getPlotLinePath(a,!0)):(d=Math.max(d,this.min),a=Math.min(a,this.max),g||(n[0]=this.translate(d),n[1]=this.translate(a)),n=v(n,function(a){f.test(a)&&(a=q(a,10)*b/100);return a}),"circle"!==c.shape&&g?(d=h+this.translate(d),a=h+this.translate(a)):(d=-Math.PI/2,a=1.5*Math.PI,y=!0),n[0]-=l,n[2]-=l,e=this.chart.renderer.symbols.arc(this.left+e[0],this.top+e[1],
n[0],n[0],{start:Math.min(d,a),end:Math.max(d,a),innerR:k(n[1],n[0]-n[2]),open:y}));return e},getPlotLinePath:function(a,c){var d=this,e=d.center,h=d.chart,b=d.getPosition(a),l,f,g;d.isCircular?g=["M",e[0]+h.plotLeft,e[1]+h.plotTop,"L",b.x,b.y]:"circle"===d.options.gridLineInterpolation?(a=d.translate(a))&&(g=d.getLinePath(0,a)):(t(h.xAxis,function(a){a.pane===d.pane&&(l=a)}),g=[],a=d.translate(a),e=l.tickPositions,l.autoConnect&&(e=e.concat([e[0]])),c&&(e=[].concat(e).reverse()),t(e,function(d,c){f=
l.getPosition(d,a);g.push(c?"L":"M",f.x,f.y)}));return g},getTitlePosition:function(){var a=this.center,c=this.chart,h=this.options.title;return{x:c.plotLeft+a[0]+(h.x||0),y:c.plotTop+a[1]-{high:.5,middle:.25,low:0}[h.align]*a[2]+(h.y||0)}}};a(l,"init",function(a,e,b){var d=e.angular,l=e.polar,n=b.isX,p=d&&n,f,F=e.options,y=this.pane=e.pane[b.pane||0],q=y.options;if(d){if(u(this,p?c:h),f=!n)this.defaultRadialOptions=this.defaultRadialGaugeOptions}else l&&(u(this,h),this.defaultRadialOptions=(f=n)?
this.defaultRadialXOptions:g(this.defaultYAxisOptions,this.defaultRadialYOptions));d||l?(this.isRadial=!0,e.inverted=!1,F.chart.zoomType=null):this.isRadial=!1;f&&(y.axis=this);a.call(this,e,b);p||!d&&!l||(a=this.options,this.angleRad=(a.angle||0)*Math.PI/180,this.startAngleRad=(q.startAngle-90)*Math.PI/180,this.endAngleRad=(k(q.endAngle,q.startAngle+360)-90)*Math.PI/180,this.offset=a.offset||0,this.isCircular=f)});a(l,"autoLabelAlign",function(a){if(!this.isRadial)return a.apply(this,[].slice.call(arguments,
1))});a(b,"getPosition",function(a,c,h,b,l){var d=this.axis;return d.getPosition?d.getPosition(h):a.call(this,c,h,b,l)});a(b,"getLabelPosition",function(a,c,h,b,l,w,p,f,g){var d=this.axis,e=w.y,n=20,r=w.align,m=(d.translate(this.pos)+d.startAngleRad+Math.PI/2)/Math.PI*180%360;d.isRadial?(a=d.getPosition(this.pos,d.center[2]/2+k(w.distance,-25)),"auto"===w.rotation?b.attr({rotation:m}):null===e&&(e=d.chart.renderer.fontMetrics(b.styles.fontSize).b-b.getBBox().height/2),null===r&&(d.isCircular?(this.label.getBBox().width>
d.len*d.tickInterval/(d.max-d.min)&&(n=0),r=m>n&&m<180-n?"left":m>180+n&&m<360-n?"right":"center"):r="center",b.attr({align:r})),a.x+=w.x,a.y+=e):a=a.call(this,c,h,b,l,w,p,f,g);return a});a(b,"getMarkPath",function(a,c,h,b,l,f,p){var d=this.axis;d.isRadial?(a=d.getPosition(this.pos,d.center[2]/2+b),c=["M",c,h,"L",a.x,a.y]):c=a.call(this,c,h,b,l,f,p);return c})})(x);(function(b){var t=b.each,u=b.pick,v=b.defined,g=b.seriesType,f=b.seriesTypes,k=b.Series.prototype,q=b.Point.prototype;g("arearange",
"area",{threshold:null,tooltip:{pointFormat:'\x3cspan class\x3d"highcharts-color-{series.colorIndex}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.low}\x3c/b\x3e - \x3cb\x3e{point.high}\x3c/b\x3e\x3cbr/\x3e'},trackByArea:!0,dataLabels:{align:null,verticalAlign:null,xLow:0,xHigh:0,yLow:0,yHigh:0}},{pointArrayMap:["low","high"],dataLabelCollections:["dataLabel","dataLabelUpper"],toYData:function(a){return[a.low,a.high]},pointValKey:"low",deferTranslatePolar:!0,highToXY:function(a){var c=this.chart,
h=this.xAxis.postTranslate(a.rectPlotX,this.yAxis.len-a.plotHigh);a.plotHighX=h.x-c.plotLeft;a.plotHigh=h.y-c.plotTop;a.plotLowX=a.plotX},translate:function(){var a=this,c=a.yAxis,h=!!a.modifyValue;f.area.prototype.translate.apply(a);t(a.points,function(b){var d=b.low,e=b.high,l=b.plotY;null===e||null===d?(b.isNull=!0,b.plotY=null):(b.plotLow=l,b.plotHigh=c.translate(h?a.modifyValue(e,b):e,0,1,0,1),h&&(b.yBottom=b.plotHigh))});this.chart.polar&&t(this.points,function(c){a.highToXY(c);c.tooltipPos=
[(c.plotHighX+c.plotLowX)/2,(c.plotHigh+c.plotLow)/2]})},getGraphPath:function(a){var c=[],b=[],l,d=f.area.prototype.getGraphPath,e,n,r;r=this.options;var m=this.chart.polar&&!1!==r.connectEnds,w=r.connectNulls,p=r.step;a=a||this.points;for(l=a.length;l--;)e=a[l],e.isNull||m||w||a[l+1]&&!a[l+1].isNull||b.push({plotX:e.plotX,plotY:e.plotY,doCurve:!1}),n={polarPlotY:e.polarPlotY,rectPlotX:e.rectPlotX,yBottom:e.yBottom,plotX:u(e.plotHighX,e.plotX),plotY:e.plotHigh,isNull:e.isNull},b.push(n),c.push(n),
e.isNull||m||w||a[l-1]&&!a[l-1].isNull||b.push({plotX:e.plotX,plotY:e.plotY,doCurve:!1});a=d.call(this,a);p&&(!0===p&&(p="left"),r.step={left:"right",center:"center",right:"left"}[p]);c=d.call(this,c);b=d.call(this,b);r.step=p;r=[].concat(a,c);this.chart.polar||"M"!==b[0]||(b[0]="L");this.graphPath=r;this.areaPath=this.areaPath.concat(a,b);r.isArea=!0;r.xMap=a.xMap;this.areaPath.xMap=a.xMap;return r},drawDataLabels:function(){var a=this.data,c=a.length,b,l=[],d=this.options.dataLabels,e=d.align,n=
d.verticalAlign,r=d.inside,m,f,p=this.chart.inverted;if(d.enabled||this._hasPointLabels){for(b=c;b--;)if(m=a[b])f=r?m.plotHigh<m.plotLow:m.plotHigh>m.plotLow,m.y=m.high,m._plotY=m.plotY,m.plotY=m.plotHigh,l[b]=m.dataLabel,m.dataLabel=m.dataLabelUpper,m.below=f,p?e||(d.align=f?"right":"left"):n||(d.verticalAlign=f?"top":"bottom"),d.x=d.xHigh,d.y=d.yHigh;k.drawDataLabels&&k.drawDataLabels.apply(this,arguments);for(b=c;b--;)if(m=a[b])f=r?m.plotHigh<m.plotLow:m.plotHigh>m.plotLow,m.dataLabelUpper=m.dataLabel,
m.dataLabel=l[b],m.y=m.low,m.plotY=m._plotY,m.below=!f,p?e||(d.align=f?"left":"right"):n||(d.verticalAlign=f?"bottom":"top"),d.x=d.xLow,d.y=d.yLow;k.drawDataLabels&&k.drawDataLabels.apply(this,arguments)}d.align=e;d.verticalAlign=n},alignDataLabel:function(){f.column.prototype.alignDataLabel.apply(this,arguments)},drawPoints:function(){var a=this.points.length,c,b;k.drawPoints.apply(this,arguments);for(b=0;b<a;)c=this.points[b],c.lowerGraphic=c.graphic,c.graphic=c.upperGraphic,c._plotY=c.plotY,c._plotX=
c.plotX,c.plotY=c.plotHigh,v(c.plotHighX)&&(c.plotX=c.plotHighX),b++;k.drawPoints.apply(this,arguments);for(b=0;b<a;)c=this.points[b],c.upperGraphic=c.graphic,c.graphic=c.lowerGraphic,c.plotY=c._plotY,c.plotX=c._plotX,b++},setStackedPoints:b.noop},{setState:function(){var a=this.state,c=this.series,b=c.chart.polar;v(this.plotHigh)||(this.plotHigh=c.yAxis.toPixels(this.high,!0));v(this.plotLow)||(this.plotLow=this.plotY=c.yAxis.toPixels(this.low,!0));q.setState.apply(this,arguments);this.graphic=this.upperGraphic;
this.plotY=this.plotHigh;b&&(this.plotX=this.plotHighX);this.state=a;c.stateMarkerGraphic&&(c.lowerStateMarkerGraphic=c.stateMarkerGraphic,c.stateMarkerGraphic=c.upperStateMarkerGraphic);q.setState.apply(this,arguments);this.plotY=this.plotLow;this.graphic=this.lowerGraphic;b&&(this.plotX=this.plotLowX);c.stateMarkerGraphic&&(c.upperStateMarkerGraphic=c.stateMarkerGraphic,c.stateMarkerGraphic=c.lowerStateMarkerGraphic)},haloPath:function(){var a=this.series.chart.polar,c;this.plotY=this.plotLow;a&&
(this.plotX=this.plotLowX);c=q.haloPath.apply(this,arguments);this.plotY=this.plotHigh;a&&(this.plotX=this.plotHighX);return c=c.concat(q.haloPath.apply(this,arguments))},destroy:function(){this.upperGraphic&&(this.upperGraphic=this.upperGraphic.destroy());return q.destroy.apply(this,arguments)}})})(x);(function(b){var t=b.seriesType;t("areasplinerange","arearange",null,{getPointSpline:b.seriesTypes.spline.prototype.getPointSpline})})(x);(function(b){var t=b.defaultPlotOptions,u=b.each,v=b.merge,
g=b.noop,f=b.pick,k=b.seriesType,q=b.seriesTypes.column.prototype;k("columnrange","arearange",v(t.column,t.arearange,{lineWidth:1,pointRange:null,marker:null,states:{hover:{halo:!1}}}),{translate:function(){var a=this,c=a.yAxis,b=a.xAxis,l=b.startAngleRad,d,e=a.chart,n=a.xAxis.isRadial,r=Math.max(e.chartWidth,e.chartHeight)+999,m;q.translate.apply(a);u(a.points,function(h){var p=h.shapeArgs,g=a.options.minPointLength,w,k;h.plotHigh=m=Math.min(Math.max(-r,c.translate(h.high,0,1,0,1)),r);h.plotLow=
Math.min(Math.max(-r,h.plotY),r);k=m;w=f(h.rectPlotY,h.plotY)-m;Math.abs(w)<g?(g-=w,w+=g,k-=g/2):0>w&&(w*=-1,k-=w);n?(d=h.barX+l,h.shapeType="path",h.shapeArgs={d:a.polarArc(k+w,k,d,d+h.pointWidth)}):(p.height=w,p.y=k,h.tooltipPos=e.inverted?[c.len+c.pos-e.plotLeft-k-w/2,b.len+b.pos-e.plotTop-p.x-p.width/2,w]:[b.left-e.plotLeft+p.x+p.width/2,c.pos-e.plotTop+k+w/2,w])})},directTouch:!0,trackerGroups:["group","dataLabelsGroup"],drawGraph:g,getSymbol:g,crispCol:q.crispCol,drawPoints:q.drawPoints,drawTracker:q.drawTracker,
getColumnMetrics:q.getColumnMetrics,animate:function(){return q.animate.apply(this,arguments)},polarArc:function(){return q.polarArc.apply(this,arguments)},pointAttribs:q.pointAttribs},{setState:q.pointClass.prototype.setState})})(x);(function(b){var t=b.each,u=b.isNumber,v=b.merge,g=b.pick,f=b.pInt,k=b.Series,q=b.seriesType,a=b.TrackerMixin;q("gauge","line",{dataLabels:{enabled:!0,defer:!1,y:15,borderRadius:3,crop:!1,verticalAlign:"top",zIndex:2},dial:{},pivot:{},tooltip:{headerFormat:""},showInLegend:!1},
{angular:!0,directTouch:!0,drawGraph:b.noop,fixedBox:!0,forceDL:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],translate:function(){var a=this.yAxis,b=this.options,l=a.center;this.generatePoints();t(this.points,function(d){var c=v(b.dial,d.dial),h=f(g(c.radius,80))*l[2]/200,r=f(g(c.baseLength,70))*h/100,m=f(g(c.rearLength,10))*h/100,w=c.baseWidth||3,p=c.topWidth||1,k=b.overshoot,q=a.startAngleRad+a.translate(d.y,null,null,null,!0);u(k)?(k=k/180*Math.PI,q=Math.max(a.startAngleRad-
k,Math.min(a.endAngleRad+k,q))):!1===b.wrap&&(q=Math.max(a.startAngleRad,Math.min(a.endAngleRad,q)));q=180*q/Math.PI;d.shapeType="path";d.shapeArgs={d:c.path||["M",-m,-w/2,"L",r,-w/2,h,-p/2,h,p/2,r,w/2,-m,w/2,"z"],translateX:l[0],translateY:l[1],rotation:q};d.plotX=l[0];d.plotY=l[1]})},drawPoints:function(){var a=this,b=a.yAxis.center,l=a.pivot,d=a.options,e=d.pivot,n=a.chart.renderer;t(a.points,function(c){var b=c.graphic,e=c.shapeArgs,h=e.d;v(d.dial,c.dial);b?(b.animate(e),e.d=h):c.graphic=n[c.shapeType](e).attr({rotation:e.rotation,
zIndex:1}).addClass("highcharts-dial").add(a.group)});l?l.animate({translateX:b[0],translateY:b[1]}):a.pivot=n.circle(0,0,g(e.radius,5)).attr({zIndex:2}).addClass("highcharts-pivot").translate(b[0],b[1]).add(a.group)},animate:function(a){var c=this;a||(t(c.points,function(a){var d=a.graphic;d&&(d.attr({rotation:180*c.yAxis.startAngleRad/Math.PI}),d.animate({rotation:a.shapeArgs.rotation},c.options.animation))}),c.animate=null)},render:function(){this.group=this.plotGroup("group","series",this.visible?
"visible":"hidden",this.options.zIndex,this.chart.seriesGroup);k.prototype.render.call(this);this.group.clip(this.chart.clipRect)},setData:function(a,b){k.prototype.setData.call(this,a,!1);this.processData();this.generatePoints();g(b,!0)&&this.chart.redraw()},drawTracker:a&&a.drawTrackerPoint},{setState:function(a){this.state=a}})})(x);(function(b){var t=b.each,u=b.noop,v=b.seriesType,g=b.seriesTypes;v("boxplot","column",{threshold:null,tooltip:{pointFormat:'\x3cspan class\x3d"highcharts-color-{point.colorIndex}"\x3e\u25cf\x3c/span\x3e \x3cb\x3e {series.name}\x3c/b\x3e\x3cbr/\x3eMaximum: {point.high}\x3cbr/\x3eUpper quartile: {point.q3}\x3cbr/\x3eMedian: {point.median}\x3cbr/\x3eLower quartile: {point.q1}\x3cbr/\x3eMinimum: {point.low}\x3cbr/\x3e'},
whiskerLength:"50%"},{pointArrayMap:["low","q1","median","q3","high"],toYData:function(b){return[b.low,b.q1,b.median,b.q3,b.high]},pointValKey:"high",drawDataLabels:u,translate:function(){var b=this.yAxis,k=this.pointArrayMap;g.column.prototype.translate.apply(this);t(this.points,function(f){t(k,function(a){null!==f[a]&&(f[a+"Plot"]=b.translate(f[a],0,1,0,1))})})},drawPoints:function(){var b=this,g=b.chart.renderer,q,a,c,h,l,d,e=0,n,r,m,w,p=!1!==b.doQuartiles,u,v=b.options.whiskerLength;t(b.points,
function(f){var k=f.graphic,t=k?"animate":"attr",E=f.shapeArgs;void 0!==f.plotY&&(n=E.width,r=Math.floor(E.x),m=r+n,w=Math.round(n/2),q=Math.floor(p?f.q1Plot:f.lowPlot),a=Math.floor(p?f.q3Plot:f.lowPlot),c=Math.floor(f.highPlot),h=Math.floor(f.lowPlot),k||(f.graphic=k=g.g("point").add(b.group),f.stem=g.path().addClass("highcharts-boxplot-stem").add(k),v&&(f.whiskers=g.path().addClass("highcharts-boxplot-whisker").add(k)),p&&(f.box=g.path(void 0).addClass("highcharts-boxplot-box").add(k)),f.medianShape=
g.path(void 0).addClass("highcharts-boxplot-median").add(k)),d=f.stem.strokeWidth()%2/2,e=r+w+d,f.stem[t]({d:["M",e,a,"L",e,c,"M",e,q,"L",e,h]}),p&&(d=f.box.strokeWidth()%2/2,q=Math.floor(q)+d,a=Math.floor(a)+d,r+=d,m+=d,f.box[t]({d:["M",r,a,"L",r,q,"L",m,q,"L",m,a,"L",r,a,"z"]})),v&&(d=f.whiskers.strokeWidth()%2/2,c+=d,h+=d,u=/%$/.test(v)?w*parseFloat(v)/100:v/2,f.whiskers[t]({d:["M",e-u,c,"L",e+u,c,"M",e-u,h,"L",e+u,h]})),l=Math.round(f.medianPlot),d=f.medianShape.strokeWidth()%2/2,l+=d,f.medianShape[t]({d:["M",
r,l,"L",m,l]}))})},setStackedPoints:u})})(x);(function(b){var t=b.each,u=b.noop,v=b.seriesType,g=b.seriesTypes;v("errorbar","boxplot",{grouping:!1,linkedTo:":previous",tooltip:{pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.low}\x3c/b\x3e - \x3cb\x3e{point.high}\x3c/b\x3e\x3cbr/\x3e'},whiskerWidth:null},{type:"errorbar",pointArrayMap:["low","high"],toYData:function(b){return[b.low,b.high]},pointValKey:"high",doQuartiles:!1,drawDataLabels:g.arearange?
function(){var b=this.pointValKey;g.arearange.prototype.drawDataLabels.call(this);t(this.data,function(f){f.y=f[b]})}:u,getColumnMetrics:function(){return this.linkedParent&&this.linkedParent.columnMetrics||g.column.prototype.getColumnMetrics.call(this)}})})(x);(function(b){var t=b.correctFloat,u=b.isNumber,v=b.pick,g=b.Point,f=b.Series,k=b.seriesType,q=b.seriesTypes;k("waterfall","column",{dataLabels:{inside:!0}},{pointValKey:"y",translate:function(){var a=this.options,c=this.yAxis,b,l,d,e,n,f,m,
g,p,k,u=v(a.minPointLength,5),x=u/2,A=a.threshold,B=a.stacking,z;q.column.prototype.translate.apply(this);g=p=A;l=this.points;b=0;for(a=l.length;b<a;b++)d=l[b],m=this.processedYData[b],e=d.shapeArgs,n=B&&c.stacks[(this.negStacks&&m<A?"-":"")+this.stackKey],z=this.getStackIndicator(z,d.x,this.index),k=n?n[d.x].points[z.key]:[0,m],d.isSum?d.y=t(m):d.isIntermediateSum&&(d.y=t(m-p)),f=Math.max(g,g+d.y)+k[0],e.y=c.translate(f,0,1,0,1),d.isSum?(e.y=c.translate(k[1],0,1,0,1),e.height=Math.min(c.translate(k[0],
0,1,0,1),c.len)-e.y):d.isIntermediateSum?(e.y=c.translate(k[1],0,1,0,1),e.height=Math.min(c.translate(p,0,1,0,1),c.len)-e.y,p=k[1]):(e.height=0<m?c.translate(g,0,1,0,1)-e.y:c.translate(g,0,1,0,1)-c.translate(g-m,0,1,0,1),g+=n&&n[d.x]?n[d.x].total:m),0>e.height&&(e.y+=e.height,e.height*=-1),d.plotY=e.y=Math.round(e.y)-this.borderWidth%2/2,e.height=Math.max(Math.round(e.height),.001),d.yBottom=e.y+e.height,e.height<=u&&!d.isNull?(e.height=u,e.y-=x,d.plotY=e.y,d.minPointLengthOffset=0>d.y?-x:x):d.minPointLengthOffset=
0,e=d.plotY+(d.negative?e.height:0),this.chart.inverted?d.tooltipPos[0]=c.len-e:d.tooltipPos[1]=e},processData:function(a){var c=this.yData,b=this.options.data,l,d=c.length,e,n,r,m,g,p;n=e=r=m=this.options.threshold||0;for(p=0;p<d;p++)g=c[p],l=b&&b[p]?b[p]:{},"sum"===g||l.isSum?c[p]=t(n):"intermediateSum"===g||l.isIntermediateSum?c[p]=t(e):(n+=g,e+=g),r=Math.min(n,r),m=Math.max(n,m);f.prototype.processData.call(this,a);this.options.stacking||(this.dataMin=r,this.dataMax=m)},toYData:function(a){return a.isSum?
0===a.x?null:"sum":a.isIntermediateSum?0===a.x?null:"intermediateSum":a.y},getGraphPath:function(){return["M",0,0]},getCrispPath:function(){var a=this.data,b=a.length,h=this.graph.strokeWidth()+this.borderWidth,h=Math.round(h)%2/2,l=this.yAxis.reversed,d=[],e,n,f;for(f=1;f<b;f++){n=a[f].shapeArgs;e=a[f-1].shapeArgs;n=["M",e.x+e.width,e.y+a[f-1].minPointLengthOffset+h,"L",n.x,e.y+a[f-1].minPointLengthOffset+h];if(0>a[f-1].y&&!l||0<a[f-1].y&&l)n[2]+=e.height,n[5]+=e.height;d=d.concat(n)}return d},drawGraph:function(){f.prototype.drawGraph.call(this);
this.graph.attr({d:this.getCrispPath()})},setStackedPoints:function(){var a=this.options,b,h;f.prototype.setStackedPoints.apply(this,arguments);b=this.stackedYData?this.stackedYData.length:0;for(h=1;h<b;h++)a.data[h].isSum||a.data[h].isIntermediateSum||(this.stackedYData[h]+=this.stackedYData[h-1])},getExtremes:function(){if(this.options.stacking)return f.prototype.getExtremes.apply(this,arguments)}},{getClassName:function(){var a=g.prototype.getClassName.call(this);this.isSum?a+=" highcharts-sum":
this.isIntermediateSum&&(a+=" highcharts-intermediate-sum");return a},isValid:function(){return u(this.y,!0)||this.isSum||this.isIntermediateSum}})})(x);(function(b){var t=b.Series,u=b.seriesType,v=b.seriesTypes;u("polygon","scatter",{marker:{enabled:!1,states:{hover:{enabled:!1}}},stickyTracking:!1,tooltip:{followPointer:!0,pointFormat:""},trackByArea:!0},{type:"polygon",getGraphPath:function(){for(var b=t.prototype.getGraphPath.call(this),f=b.length+1;f--;)(f===b.length||"M"===b[f])&&0<f&&b.splice(f,
0,"z");return this.areaPath=b},drawGraph:function(){v.area.prototype.drawGraph.call(this)},drawLegendSymbol:b.LegendSymbolMixin.drawRectangle,drawTracker:t.prototype.drawTracker,setStackedPoints:b.noop})})(x);(function(b){var t=b.arrayMax,u=b.arrayMin,v=b.Axis,g=b.each,f=b.isNumber,k=b.noop,q=b.pick,a=b.pInt,c=b.Point,h=b.seriesType,l=b.seriesTypes;h("bubble","scatter",{dataLabels:{formatter:function(){return this.point.z},inside:!0,verticalAlign:"middle"},marker:{radius:null,states:{hover:{radiusPlus:0}},
symbol:"circle"},minSize:8,maxSize:"20%",softThreshold:!1,states:{hover:{halo:{size:5}}},tooltip:{pointFormat:"({point.x}, {point.y}), Size: {point.z}"},turboThreshold:0,zThreshold:0,zoneAxis:"z"},{pointArrayMap:["y","z"],parallelArrays:["x","y","z"],trackerGroups:["group","dataLabelsGroup"],specialGroup:"group",bubblePadding:!0,zoneAxis:"z",directTouch:!0,getRadii:function(a,b,c,f){var d,e,h,l=this.zData,n=[],r=this.options,g="width"!==r.sizeBy,k=r.zThreshold,q=b-a;e=0;for(d=l.length;e<d;e++)h=l[e],
r.sizeByAbsoluteValue&&null!==h&&(h=Math.abs(h-k),b=Math.max(b-k,Math.abs(a-k)),a=0),null===h?h=null:h<a?h=c/2-1:(h=0<q?(h-a)/q:.5,g&&0<=h&&(h=Math.sqrt(h)),h=Math.ceil(c+h*(f-c))/2),n.push(h);this.radii=n},animate:function(a){var b=this.options.animation;a||(g(this.points,function(a){var c=a.graphic,d;c&&c.width&&(d={x:c.x,y:c.y,width:c.width,height:c.height},c.attr({x:a.plotX,y:a.plotY,width:1,height:1}),c.animate(d,b))}),this.animate=null)},translate:function(){var a,c=this.data,h,g,m=this.radii;
l.scatter.prototype.translate.call(this);for(a=c.length;a--;)h=c[a],g=m?m[a]:0,f(g)&&g>=this.minPxSize/2?(h.marker=b.extend(h.marker,{radius:g,width:2*g,height:2*g}),h.dlBox={x:h.plotX-g,y:h.plotY-g,width:2*g,height:2*g}):h.shapeArgs=h.plotY=h.dlBox=void 0},alignDataLabel:l.column.prototype.alignDataLabel,buildKDTree:k,applyZones:k},{haloPath:function(a){return c.prototype.haloPath.call(this,0===a?0:(this.marker?this.marker.radius||0:0)+a)},ttBelow:!1});v.prototype.beforePadding=function(){var b=
this,c=this.len,h=this.chart,l=0,m=c,k=this.isXAxis,p=k?"xData":"yData",v=this.min,x={},y=Math.min(h.plotWidth,h.plotHeight),A=Number.MAX_VALUE,B=-Number.MAX_VALUE,z=this.max-v,C=c/z,D=[];g(this.series,function(c){var d=c.options;!c.bubblePadding||!c.visible&&h.options.chart.ignoreHiddenSeries||(b.allowZoomOutside=!0,D.push(c),k&&(g(["minSize","maxSize"],function(c){var b=d[c],e=/%$/.test(b),b=a(b);x[c]=e?y*b/100:b}),c.minPxSize=x.minSize,c.maxPxSize=Math.max(x.maxSize,x.minSize),c=c.zData,c.length&&
(A=q(d.zMin,Math.min(A,Math.max(u(c),!1===d.displayNegative?d.zThreshold:-Number.MAX_VALUE))),B=q(d.zMax,Math.max(B,t(c))))))});g(D,function(a){var c=a[p],d=c.length,e;k&&a.getRadii(A,B,a.minPxSize,a.maxPxSize);if(0<z)for(;d--;)f(c[d])&&b.dataMin<=c[d]&&c[d]<=b.dataMax&&(e=a.radii[d],l=Math.min((c[d]-v)*C-e,l),m=Math.max((c[d]-v)*C+e,m))});D.length&&0<z&&!this.isLog&&(m-=c,C*=(c+l-m)/c,g([["min","userMin",l],["max","userMax",m]],function(a){void 0===q(b.options[a[0]],b[a[1]])&&(b[a[0]]+=a[2]/C)}))}})(x);
(function(b){function t(a,c){var b=this.chart,f=this.options.animation,d=this.group,e=this.markerGroup,g=this.xAxis.center,k=b.plotLeft,m=b.plotTop;b.polar?b.renderer.isSVG&&(!0===f&&(f={}),c?(a={translateX:g[0]+k,translateY:g[1]+m,scaleX:.001,scaleY:.001},d.attr(a),e&&e.attr(a)):(a={translateX:k,translateY:m,scaleX:1,scaleY:1},d.animate(a,f),e&&e.animate(a,f),this.animate=null)):a.call(this,c)}var u=b.each,v=b.pick,g=b.seriesTypes,f=b.wrap,k=b.Series.prototype,q=b.Pointer.prototype;k.searchPointByAngle=
function(a){var c=this.chart,b=this.xAxis.pane.center;return this.searchKDTree({clientX:180+-180/Math.PI*Math.atan2(a.chartX-b[0]-c.plotLeft,a.chartY-b[1]-c.plotTop)})};k.getConnectors=function(a,b,h,f){var c,e,l,g,m,k,p,q;e=f?1:0;c=0<=b&&b<=a.length-1?b:0>b?a.length-1+b:0;b=0>c-1?a.length-(1+e):c-1;e=c+1>a.length-1?e:c+1;l=a[b];e=a[e];g=l.plotX;l=l.plotY;m=e.plotX;k=e.plotY;e=a[c].plotX;c=a[c].plotY;g=(1.5*e+g)/2.5;l=(1.5*c+l)/2.5;m=(1.5*e+m)/2.5;p=(1.5*c+k)/2.5;k=Math.sqrt(Math.pow(g-e,2)+Math.pow(l-
c,2));q=Math.sqrt(Math.pow(m-e,2)+Math.pow(p-c,2));g=Math.atan2(l-c,g-e);p=Math.PI/2+(g+Math.atan2(p-c,m-e))/2;Math.abs(g-p)>Math.PI/2&&(p-=Math.PI);g=e+Math.cos(p)*k;l=c+Math.sin(p)*k;m=e+Math.cos(Math.PI+p)*q;p=c+Math.sin(Math.PI+p)*q;e={rightContX:m,rightContY:p,leftContX:g,leftContY:l,plotX:e,plotY:c};h&&(e.prevPointCont=this.getConnectors(a,b,!1,f));return e};f(k,"buildKDTree",function(a){this.chart.polar&&(this.kdByAngle?this.searchPoint=this.searchPointByAngle:this.options.findNearestPointBy=
"xy");a.apply(this)});k.toXY=function(a){var b,h=this.chart,f=a.plotX;b=a.plotY;a.rectPlotX=f;a.rectPlotY=b;b=this.xAxis.postTranslate(a.plotX,this.yAxis.len-b);a.plotX=a.polarPlotX=b.x-h.plotLeft;a.plotY=a.polarPlotY=b.y-h.plotTop;this.kdByAngle?(h=(f/Math.PI*180+this.xAxis.pane.options.startAngle)%360,0>h&&(h+=360),a.clientX=h):a.clientX=a.plotX};g.spline&&(f(g.spline.prototype,"getPointSpline",function(a,b,h,f){this.chart.polar?f?(a=this.getConnectors(b,f,!0,this.connectEnds),a=["C",a.prevPointCont.rightContX,
a.prevPointCont.rightContY,a.leftContX,a.leftContY,a.plotX,a.plotY]):a=["M",h.plotX,h.plotY]:a=a.call(this,b,h,f);return a}),g.areasplinerange&&(g.areasplinerange.prototype.getPointSpline=g.spline.prototype.getPointSpline));f(k,"translate",function(a){var b=this.chart;a.call(this);if(b.polar&&(this.kdByAngle=b.tooltip&&b.tooltip.shared,!this.preventPostTranslate))for(a=this.points,b=a.length;b--;)this.toXY(a[b])});f(k,"getGraphPath",function(a,b){var c=this,f,d,e;if(this.chart.polar){b=b||this.points;
for(f=0;f<b.length;f++)if(!b[f].isNull){d=f;break}!1!==this.options.connectEnds&&void 0!==d&&(this.connectEnds=!0,b.splice(b.length,0,b[d]),e=!0);u(b,function(a){void 0===a.polarPlotY&&c.toXY(a)})}f=a.apply(this,[].slice.call(arguments,1));e&&b.pop();return f});f(k,"animate",t);g.column&&(g=g.column.prototype,g.polarArc=function(a,b,f,g){var c=this.xAxis.center,e=this.yAxis.len;return this.chart.renderer.symbols.arc(c[0],c[1],e-b,null,{start:f,end:g,innerR:e-v(a,e)})},f(g,"animate",t),f(g,"translate",
function(a){var b=this.xAxis,f=b.startAngleRad,g,d,e;this.preventPostTranslate=!0;a.call(this);if(b.isRadial)for(g=this.points,e=g.length;e--;)d=g[e],a=d.barX+f,d.shapeType="path",d.shapeArgs={d:this.polarArc(d.yBottom,d.plotY,a,a+d.pointWidth)},this.toXY(d),d.tooltipPos=[d.plotX,d.plotY],d.ttBelow=d.plotY>b.center[1]}),f(g,"alignDataLabel",function(a,b,f,g,d,e){this.chart.polar?(a=b.rectPlotX/Math.PI*180,null===g.align&&(g.align=20<a&&160>a?"left":200<a&&340>a?"right":"center"),null===g.verticalAlign&&
(g.verticalAlign=45>a||315<a?"bottom":135<a&&225>a?"top":"middle"),k.alignDataLabel.call(this,b,f,g,d,e)):a.call(this,b,f,g,d,e)}));f(q,"getCoordinates",function(a,b){var c=this.chart,f={xAxis:[],yAxis:[]};c.polar?u(c.axes,function(a){var d=a.isXAxis,g=a.center,h=b.chartX-g[0]-c.plotLeft,g=b.chartY-g[1]-c.plotTop;f[d?"xAxis":"yAxis"].push({axis:a,value:a.translate(d?Math.PI-Math.atan2(h,g):Math.sqrt(Math.pow(h,2)+Math.pow(g,2)),!0)})}):f=a.call(this,b);return f});f(b.Chart.prototype,"getAxes",function(a){this.pane||
(this.pane=[]);u(b.splat(this.options.pane),function(a){new b.Pane(a,this)},this);a.call(this)});f(b.Chart.prototype,"drawChartBox",function(a){a.call(this);u(this.pane,function(a){a.render()})});f(b.Chart.prototype,"get",function(a,c){return b.find(this.pane,function(a){return a.options.id===c})||a.call(this,c)})})(x)});

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/fieldpage/fieldpage.html","<div id=field-page><div class=\"field-page-content margin-top--2_5\"><div class=field-page-content-header><p>SITUACIÓN DEL <strong>TRABAJO DE CAMPO</strong></p></div><div class=\"field-page-content-selection display__flex flex-justify-content-end margin-top--2 margin-right--2_5\"><div class=selection><div odec-select2 odec-select2-data=fieldpage.muestras odec-select2-selection=fieldpage.muestras[0] odec-select2-event=\"\'changeSelection:muestra\'\"></div></div><div class=empty></div><div class=selection><div odec-select2 odec-select2-data=fieldpage.comunidades odec-select2-selection=fieldpage.comunidades[0] odec-select2-event=\"\'changeSelection:comunidad\'\"></div></div></div><div class=\"field-page-content-widget padding-top--2_5\"><odec-view-data-loader ng-if=\"fieldpage.widgetField.loading && !fieldpage.widgetField.data\" odec-view-data-loader-loading=!fieldpage.widgetField.data style=\"width: 100%\"></odec-view-data-loader><odec-widget-field ng-if=\"!fieldpage.widgetField.loading && fieldpage.widgetField.data\" data=fieldpage.widgetField.data></odec-widget-field></div><div class=\"date text-left\" ng-if=\"!fieldpage.widgetField.loading && fieldpage.widgetField.data\"><span>* Última fecha de carga: {{ fieldpage.dateLoad }}</span></div><div class=field-page-content-table><table id=fieldTable class=\"table table-stripped table-bordered\" ng-if=\"!fieldpage.widgetField.loading && fieldpage.widgetField.data\" odec-datatable odec-datatable-column-defs=fieldpage.table.columnsDef odec-datatable-columns=fieldpage.table.columns odec-datatable-data=fieldpage.table.data odec-datatable-paginate=fieldpage.table.paginate odec-datatable-language-url={{fieldpage.table.languageUrl}} odec-datatable-show-length-menu=fieldpage.table.showLengthMenu></table></div></div></div>");
$templateCache.put("app/landingpage/landingpage.html","<div class=landing-page><div class=landing-page-menu><div class=landing-page-menu-logo><img ng-src=assets/images/egm-logo.svg height=100% width=100% src=assets/images/egm-logo.svg></div><div class=landing-page-menu-content><div class=landing-page-menu-content-panel><div class=\"landing-page-menu-content-panel-header padding-left--0_5\"><p>publicaciones</p></div><div class=landing-page-menu-content-panel-body><ul class=\"landing-page-menu-content-panel-body-links-list margin--1\"><li><a ng-if=landingpage.hasAimc ng-click=\"landingpage.onClickRedirect(\'AIMC\')\" href><img class=\"landing-page-menu-content-panel-body-icon margin-right--1\" src=./assets/images/historico_egm.svg alt=\"\"> <span>egm</span> </a></li><li><a ng-if=landingpage.hasAimcCat ng-click=\"landingpage.onClickRedirect(\'AIMCCAT\')\" href><img class=\"landing-page-menu-content-panel-body-icon margin-right--1\" src=./assets/images/radio_cat.svg alt=\"\"> <span>egm radio cataluña</span> </a></li><li><a href=https://reporting.aimc.es/ ><img class=\"landing-page-menu-content-panel-body-icon margin-right--1\" src=./assets/images/dashboard_egm.svg alt=\"\"> <span>egm dashboard</span></a></li><li><a href=https://internet.aimc.es/ ><img class=\"landing-page-menu-content-panel-body-icon margin-right--1\" src=./assets/images/egm_internet_1.svg alt=\"\"> <span>internet dashboard</span></a></li><li><a ng-if=landingpage.hasField ng-click=landingpage.onClickField() href><img class=\"landing-page-menu-content-panel-body-icon margin-right--1\" src=./assets/images/trabajo_campo.svg alt=\"\"> <span>situación de trabajo de campo</span></a></li></ul></div></div></div></div><!--<div class=\"landing-page-content margin--1\">\n        <h2>RENOVACIÓN EN LA PRESENTACIÓN ONLINE DE DATOS EGM.</h2>\n        <p>\n            A lo largo del 2018 hemos celebrado los 50 primeros años del Estudio General de Medios (EGM). A lo largo de su historia el EGM ha consolidado los cimientos de la Industria de los Medios de Comunicación y de la Publicidad, no sólo como “currency” en el intercambio de publicidad por audiencias; sino también como estudio referencial para la construcción de paneles para la medición pasiva de la televisión o internet, o como estudio que determina variables clave para el mercado como es, por ejemplo, el Índice Socioeconómico.\n        </p>\n        <p>\n            Durante toda su existencia el estudio ha ido evolucionando y se ha adaptado a las nuevas capacidades tecnológicas. En la actualidad el EGM combina cinco estudios, tres metodologías para hacer encuestas (personal, telefónica y online) y más de 150.000 entrevistas. \n        </p>\n\n        <p>\n            Dentro del área de comunicación con nuestros asociados y con las distintas “comunidades de interés” abordamos una renovación en la visualización de resultados. Con el soporte de ODEC, hemos intentado darle un formato más actual e intuitivo y, lógicamente, sin perder la información histórica de gran interés para los investigadores del escenario de medios en este país.\n        </p>\n\n        <p>\n            Desde el equipo de AIMC esperamos que esta nueva visualización de los resultados del EGM tenga vuestra aprobación.\n        </p>\n    </div>--></div>");
$templateCache.put("app/login/login.html","<div class=login-wrapper><div class=login-text><h2>RENOVACIÓN EN LA PRESENTACIÓN ONLINE DE DATOS EGM.</h2><p>En el 2018 hemos celebrado los 50 primeros años del Estudio General de Medios (EGM). A lo largo de su historia el EGM ha consolidado los cimientos de la Industria de los Medios de Comunicación y de la Publicidad, no sólo como “currency” en el intercambio de publicidad por audiencias; sino también como estudio referencial para la construcción de paneles para la medición pasiva de la televisión o internet, o como estudio que determina variables clave para el mercado como es, por ejemplo, el Índice Socioeconómico.</p><p>Durante toda su existencia el estudio ha ido evolucionando y se ha adaptado a las nuevas capacidades tecnológicas. En la actualidad el EGM combina cinco estudios, tres metodologías para hacer encuestas (personal, telefónica y online) y más de 150.000 entrevistas.</p><p>Dentro del área de comunicación con nuestros asociados y con las distintas “comunidades de interés” abordamos una renovación en la visualización de resultados. Con el soporte de ODEC, hemos intentado darle un formato más actual e intuitivo y, lógicamente, sin perder la información histórica de gran interés para los investigadores del escenario de medios en este país.</p><p>Desde el equipo de AIMC esperamos que esta nueva visualización de los resultados del EGM tenga vuestra aprobación.</p><div class=text-logo><img ng-src=assets/images/egm-logo.svg src=assets/images/egm-logo.svg height=100%></div></div><div class=login-wrapper--inner><form><div class=\"logo-wrapper text-center margin-top--2 padding--0_5\"><img src=assets/images/headerlogo1.svg height=25px> <img src=assets/images/texto-logo.svg height=25px></div><div class=\"login-form margin-left--1_5 margin-right--1_5\"><div class=\"margin-top--1_5 login-input\"><input type=text name=username placeholder=Usuario autofocus ng-model=login.username autocomplete=off></div><div class=\"margin-top--1 login-input\"><input #password type=password name=password placeholder=Contraseña ng-model=login.password autocomplete=off></div></div><div class=\"login-errors margin--0_5 margin-left--2\" ng-if=login.errorMessage><span class=\"label text-error message_wrapped\"><small>{{login.errorMessage}}</small></span></div><div class=\"text-center margin--1_5\"><odec-loading-button class=\"padding--0_5 btn-socios\" ng-click=login.login(login.username,login.password) odec-loading-button-loading=login.loading><span>Acceso asociados</span></odec-loading-button></div></form><hr class=margin--2 style=border-color:lightgrey><div class=\"text-center margin--1_5\" uib-dropdown><button class=\"padding--0_5 btn btn-action btn-not-socios no-padding\" uib-dropdown-toggle><span>Acceso datos públicos</span></button><ul class=\"dropdown-menu links\" uib-dropdown-menu role=menu aria-labelledby=single-button><li role=menuitem><a href=https://reporting.aimc.es/ >Resumen general de resultados EGM</a></li><li role=menuitem><a href=https://internet.aimc.es/ >Audiencia de Internet en el EGM</a></li></ul></div></div></div>");
$templateCache.put("app/main/main.html","<odec-layout-ui opened=main.menu.opened><odec-sidebar odec-sidebar-opened=main.menu.opened><odec-menu-list odec-menu-list-collection=main.menu.collection></odec-menu-list></odec-sidebar><div class=main-content><odec-sidebar-overlay class=no-print odec-sidebar-overlay-opened=main.menu.opened odec-sidebar-overlay-close=main.menu.open(value)></odec-sidebar-overlay><odec-header class=no-print><div class=header-logos><div class=header-logos-item><a href=https://www.aimc.es/ target=_blank><img src=assets/images/headerlogo1.svg height=100% width=100%></a></div><div class=\"header-logos-item mobile-hide\"><img src=assets/images/texto-logo.svg height=100% width=100%></div></div><!--<odec-sidebar-toggle odec-sidebar-toggle-open=\"main.menu.open(value)\"></odec-sidebar-toggle>            --><ul class=header-nav><li class=header-nav-item ng-if=main.goHomeAvailable><a ng-click=main.goBackHome() href class=\"header-nav-item-toggle verticalAlign\"><img src=assets/images/info.svg alt=\"\" style=width:25px;margin:15px></a></li><!-- project selector--><li class=header-nav-item ng-if=main.filtersAvailable><div class=\"header-nav-notifications header-nav-item-dropdown text-toggle margin-left--1\" uib-dropdown><a href class=\"header-nav-item-toggle verticalAlign\" uib-dropdown-toggle>{{main.projectPreselected|projectIdToLabel}}</a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=simple-dropdown><li class=dropdown-menu-item ng-repeat=\"project in main.projectsCollection\"><a href ng-click=main.selectProject(project) class=padding--0_5>{{project.label}}</a></li></ul></div></li><li class=header-nav-item ng-if=main.filtersAvailable><div class=\"header-nav-notifications header-actions-item text-center padding-left--0_5\"><button class=\"wave-menu-button header-nav-item-toggle\" uib-tooltip=\"Selector de olas\" tooltip-placement=bottom ng-click=main.openPublicationSelectionOverlay()><div class=wave-selection-trigger><span class=vas><span class=padding-right--0_5>{{ main.publicationSelected.publication.year }}</span>-<span class=padding-left--0_5>{{ main.publicationSelected.publication.pubLabel }}</span></span> <i class=\"icon-size-xl icon-arrow_drop_down\"></i></div></button></div></li><li class=header-nav-item ng-if=main.isUserAdmin style=\"padding-top: 7px\"><a ui-sref=main.usermanagementlist class=\"header-nav-item-toggle verticalAlign padding--1\"><i class=\"icon-size-xl icon-user-plus2\" style=font-size:25px;margin-top:10px></i></a></li><li class=header-nav-item><div class=\"header-nav-notifications header-nav-item-dropdown margin-left--1\" uib-dropdown><a href class=header-nav-item-toggle uib-dropdown-toggle><i class=\"icon-size-xl icon-person\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=simple-dropdown><!-- No ponemos el nombre porque lo vamos a usar de otro modo como id del usuario\n                                <li class=\"dropdown-menu-header\">\n                                Bienvenido, {{main.user.data.name}}\n                            </li>--><li class=dropdown-menu-item><a href ng-click=main.logout() class=padding--0_5><i class=\"icon-size-md icon-power-off margin-right--1\"></i>Logout</a></li></ul></div></li></ul></odec-header><odec-publication-selector-overlay odec-publication-selector-overlay-collection=main.publicationCollection odec-publication-selector-overlay-preselection=main.publicationSelected odec-publication-selector-overlay-on-selection=main.onPublicationSelectionOverlaySelection(publication) odec-publication-selector-overlay-on-close=main.onPublicationSelectionOverlayClose(publication) odec-publication-selector-overlay-opened=main.filterOpened odec-publication-selector-overlay-project=main.projectPreselected></odec-publication-selector-overlay><div ui-view></div></div></odec-layout-ui>");
$templateCache.put("app/publicationpage/publicationpage.html","<div class=content-wrapper ng-if=publicationpage.iframeSrc><iframe ng-src={{publicationpage.iframeSrc}}></iframe></div><div style=width:0px;height:0px;overflow:hidden ng-if=publicationpage.iframeSrc2><iframe ng-src={{publicationpage.iframeSrc2}}></iframe></div>");
$templateCache.put("app/components/layout-ui/layoutUi.html","<div class=main-page><ng-transclude ng-class=\"{\'sidebar--open\':vm.opened}\"></ng-transclude></div>");
$templateCache.put("app/components/odecLoadingButton/odecLoadingButton.html","<button class=\"btn btn-action no-padding\" ng-disabled=odecLoadingButton.odecLoadingButtonLoading><ng-transclude class=button-text></ng-transclude><i ng-if=odecLoadingButton.odecLoadingButtonLoading class=\"icon-size-md icon-spinner22 animated-spin margin-left--0_5\"></i></button>");
$templateCache.put("app/components/odecPublicationSelectorOverlay/odecPublicationSelectorOverlay.html","<div class=\"wave-selector-view display__flex\" ng-class=\"{\'filter-opened\': odecPublicationSelectorOverlay.odecPublicationSelectorOverlayOpened}\" ng-if=odecPublicationSelectorOverlay.odecPublicationSelectorOverlayOpened><div class=\"filter-logo padding--2 display__flex flex-align-item-center\"><img ng-src=assets/images/egm-logo.svg height=100% width=100%></div><div class=\"filter-waves display__flex padding--2\"><div class=\"year-list years padding--2\" odec-scrollable=\"\" odec-scrollable-autohide=true odec-scrollable-color=#203365 odec-scrollable-zindex=9999><div class=\"year-item display__flex flex-direction-column\" ng-repeat=\"publication in odecPublicationSelectorOverlay.collection track by $index\"><div class=\"wave-year-button padding--0_5\" ng-class=\"{\'selected\': publication.year === odecPublicationSelectorOverlay.selection.year}\" ng-click=odecPublicationSelectorOverlay.onYearSelected(publication)><span>{{ publication.year }}</span></div></div></div><div class=\"year-list pubs display__flex flex-direction-column padding--2\" odec-scrollable=\"\" odec-scrollable-autohide=true odec-scrollable-color=#203365 odec-scrollable-zindex=9999><div class=wave-item ng-repeat=\"pub in odecPublicationSelectorOverlay.pubSetFilteredByYear track by $index\"><div class=\"wave-year-button wave-year-button-label padding--0_5\" ng-click=odecPublicationSelectorOverlay.onPublicationSelection(pub) ng-class=\"{\'selected\': pub.pubId === odecPublicationSelectorOverlay.selection.publication.pubId}\"><span>{{pub.pubLabel}}</span></div></div></div><div><button class=close-button uib-tooltip=\"Cerrar Filtro\" tooltip-placement=bottom ng-click=odecPublicationSelectorOverlay.closeFilter()><i class=\"icon-size-xl icon-close\"></i></button></div></div></div>");
$templateCache.put("app/components/odecSelect2/odecSelect2.html","<select style=width:100%></select>");
$templateCache.put("app/components/odecTransitionPage/odecTransitionPage.html","<div class=transitionPage ng-class=\"{\'entering\':odecTransitionPage.loading}\"><img src=./assets/images/loader_img.gif alt=loader></div>");
$templateCache.put("app/components/odecViewDataLoader/odecViewDataLoader.html","<div class=\"loading-bar-wrapper margin-top--0_5\" ng-if=odecViewDataLoader.odecViewDataLoaderLoading><div class=\"loader-bar-animated text-center\"><i class=\"icon-size-xl icon-spinner22 animated-spin\"></i></div></div>");
$templateCache.put("app/components/odecWidgetField/odecWidgetField.html","<div class=widget-field><odec-highcharts id=odecWidgetField.idChart odec-highcharts-config=odecWidgetField.chartConfig odec-highcharts-data=odecWidgetField.chartData odec-highcharts-categories=odecWidgetField.chartCategories></odec-highcharts></div>");
$templateCache.put("app/components/tableManager/tableManager.html","<div class=table-wrapper><div class=table-toolbar><div class=table-search><input type=text ng-model=tableManager.search.email> <button ng-click=tableManager.onSearch(tableManager.search.email) ng-if=!tableManager.filtered><i class=icon-search2></i></button> <button ng-click=tableManager.onRemoveFilter() ng-if=tableManager.filtered><i class=icon-close></i></button></div><div class=flex-space-in-middle></div><div class=table-actions><button class=\"btn no-padding no-margin table-actions--button\" uib-tooltip=\"Copiar al portapapeles\" ng-click=tableManager.copyToClipboard()><i class=\"icon-size-xl icon-paste-document\"></i></button></div></div><div class=table-headers><div class=\"table-headers-cell padding--1\" ng-repeat=\"field in tableManager.tableManagerColumns track by $index\" ng-if=!field.hide><div class=template-string><p>{{field.label}}</p></div></div></div><div class=table-body><div class=table-body-row ng-repeat=\"row in tableManager.paginatedData track by $index\"><div class=\"table-body-row-cell padding--0_5\" ng-repeat=\"(key, value) in row\" ng-if=!tableManager.tableManagerColumns[$index].hide><table-cell-renderer table-cell-renderer-type=\"value.renderer && value.renderer.type\" table-cell-renderer-config=\"value.renderer && value.renderer.options\" table-cell-renderer-data=value.value table-cell-renderer-row=row></table-cell-renderer></div></div></div><div class=table-pagination><div class=flex-space-in-middle><span>Page {{tableManager.pagination.pageSelected}}/{{tableManager.pagination.total}} ({{tableManager.proxyData.length}} registros)</span></div><div class=table-pagination-list><button class=\"table-pagination-previous table-pagination-button\" ng-disabled=\"tableManager.pagination.pageSelected<=1\" ng-click=tableManager.setPagination(tableManager.pagination.pageSelected-1)>Anterior</button><div class=table-pagination-indication><form><input type=text ng-model=tableManager.pagination.pageSelected ng-disabled=\"tableManager.pagination.total<=1\" ng-change=tableManager.setPagination(tableManager.pagination.pageSelected)></form></div><button class=\"table-pagination-next table-pagination-button\" ng-disabled=\"tableManager.pagination.pageSelected=== tableManager.pagination.total\" ng-click=tableManager.setPagination(tableManager.pagination.pageSelected+1)>Siguiente</button></div></div></div>");
$templateCache.put("app/userManagement/newUser/newUser.html","<odec-view-data-loader odec-view-data-loader-loading=newuser.loading style=\"width: 100%\"></odec-view-data-loader><div class=\"newuser-page padding--2\" ng-if=!newuser.loading><h2 style=\"font-weight:bold;text-decoration: underline\">NUEVO USUARIO</h2><div class=newuser-field><div class=newuser-field-label>Id</div><div class=newuser-field-text-input><input type=text ng-model=newuser.data.name></div></div><div class=newuser-field><div class=newuser-field-label>Usuario</div><div class=newuser-field-text-input><input type=text ng-model=newuser.data.user></div></div><div class=newuser-field><div class=newuser-field-label>Password</div><div class=newuser-field-text-input><input type=password ng-model=newuser.data.password></div></div><div class=\"newuser-field newuser-field--column\"><p class=margin--bottom--1 style=font-weight:bold>Seleccion de estudio</p><div class=\"display--flex flex-direction--row\"><div class=\"newuser-field-checkbox pretty p-svg p-curve\" ng-if=newuser.userProjects.AIMC><input type=checkbox ng-model=newuser.data.projects.AIMC><div class=\"state p-success\"><!-- svg path --> <svg class=\"svg svg-icon\" viewBox=\"0 0 20 20\"><path d=M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z style=\"stroke: white;fill:white\"></path></svg><label>AIMC</label></div></div><div class=\"newuser-field-checkbox pretty p-svg p-curve\" ng-if=newuser.userProjects.AIMCCAT><input type=checkbox ng-model=newuser.data.projects.AIMCCAT><div class=\"state p-success\"><!-- svg path --> <svg class=\"svg svg-icon\" viewBox=\"0 0 20 20\"><path d=M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z style=\"stroke: white;fill:white\"></path></svg><label>AIMC Cataluña</label></div></div><div class=\"newuser-field-checkbox pretty p-svg p-curve\" ng-if=newuser.userProjects.AIMCMARCAS><input type=checkbox ng-model=newuser.data.projects.AIMCMARCAS><div class=\"state p-success\"><!-- svg path --> <svg class=\"svg svg-icon\" viewBox=\"0 0 20 20\"><path d=M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z style=\"stroke: white;fill:white\"></path></svg><label>AIMC Marcas</label></div></div></div></div><div class=\"newuser-field newuser-field--column\"><p class=margin--bottom--1 style=font-weight:bold>Seleccion de roles</p><div class=\"display--flex flex-direction--row\"><div class=\"newuser-field-checkbox pretty p-svg p-curve\"><input type=checkbox ng-model=newuser.data.roles.ADMIN_USER><div class=\"state p-success\"><!-- svg path --> <svg class=\"svg svg-icon\" viewBox=\"0 0 20 20\"><path d=M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z style=\"stroke: white;fill:white\"></path></svg><label>ADMIN USER</label></div></div><div class=\"newuser-field-checkbox pretty p-svg p-curve\" ng-if=newuser.hasRolField><input type=checkbox ng-model=newuser.data.roles.SEGUIMIENTO_CAMPO><div class=\"state p-success\"><!-- svg path --> <svg class=\"svg svg-icon\" viewBox=\"0 0 20 20\"><path d=M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z style=\"stroke: white;fill:white\"></path></svg><label>SEGUIMIENTO CAMPO</label></div></div></div></div><div style=text-align:center><button class=\"button-add margin-right--0_5\" ng-click=newuser.createUser()><span>Guardar</span></button> <button class=button-add ng-click=newuser.goBack()><span>Cancelar</span></button></div></div>");
$templateCache.put("app/userManagement/userManagementList/userManagementList.html","<div class=\"usermanagementlist-page padding--2\"><div class=action-list><button class=\"button-add margin-bottom--1\" ng-click=usermanagementlist.createNewUser()><span>Nuevo</span></button></div><table-manager table-manager-data-collection=usermanagementlist.userCollection table-manager-columns=usermanagementlist.headerFields></table-manager></div>");
$templateCache.put("app/components/layout-ui/odecHeader/odecHeader.html","<header class=card><ng-transclude></ng-transclude></header>");
$templateCache.put("app/components/layout-ui/odecMenuLink/odecMenuLink.html","<li ng-if=odecMenuLink.odecMenuLinkVisible class=sidebar-nav-submenu-item><a href ng-click=odecMenuLink.onClick($event)>{{odecMenuLink.odecMenuLinkLabel|translate}}</a></li>");
$templateCache.put("app/components/layout-ui/odecMenuList/odecMenuList.html","<ul class=\"sidebar-nav margin-top--1\"><odec-menu-list-item ng-repeat=\"menuItem in odecMenuList.data.odecMenuListCollection track by $index\" ng-if=menuItem.visible odec-menu-list-item-icon=menuItem.icon odec-menu-list-item-label=menuItem.label odec-menu-list-item-selected=menuItem.selected odec-menu-list-item-submenu-childs=menuItem.child ng-click=odecMenuList.onSelect($event,menuItem)></odec-menu-list-item></ul>");
$templateCache.put("app/components/layout-ui/odecSidebar/odecSidebar.html","<div class=\"sidebar no-print\" odec-scrollable odec-scrollable-autohide=true odec-scrollable-color=#AA142D odec-scrollable-show={{odecSidebar.odecSidebarOpened}}><div class=sidebar-logo><img ng-src=assets/images/headerlogo1.svg alt=\"\"></div><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/layout-ui/odecMenuListItem/odecMenuListItem.html","<li class=sidebar-nav-item ng-class=\"{\'sidebar-nav-item--opened\':vm.odecMenuListItemSelected}\"><a href=\"\" class=sidebar-nav-toggle ng-click=vm.odecMenuListItemSelectedOnSelect()><i class=\"sidebar-nav-toggle-icon icon-size-lg {{vm.odecMenuListItemIcon}}\"></i><span class=sidebar-nav-toggle-description>{{vm.odecMenuListItemLabel|translate}}</span></a><odec-submenu-list><odec-menu-link ng-repeat=\"link in vm.odecMenuListItemSubmenuChilds track by $index\" odec-menu-link-label=link.label odec-menu-link-state=link.state odec-menu-link-url=link.url odec-menu-link-visible=link.visible></odec-menu-link></odec-submenu-list></li>");
$templateCache.put("app/components/layout-ui/odecSidebarOverlay/odecSidebarOverlay.html","<div class=sidebar-overlay ng-if=odecSidebarOverlay.odecSidebarOverlayOpened ng-click=odecSidebarOverlay.closeOverlay({value:false})></div>");
$templateCache.put("app/components/layout-ui/odecSidebarToggle/odecSidebarToggle.html","<button class=btn-menu ng-click=odecSidebarToggle.clicked({value:true})><i class=\"icon-menu5 icon-size-xl\"></i></button>");
$templateCache.put("app/components/layout-ui/odecSubmenuList/odecSubmenuList.html","<ul class=sidebar-nav-submenu><ng-transclude></ng-transclude></ul>");
$templateCache.put("app/components/tableCellRenderer/templates/text.html","<p class=no-margin>{{tableCellRenderer.tableCellRendererData}}</p>");
$templateCache.put("app/components/tableCellRenderer/templates/usermanageractionlist.html","<div class=text-align--center><span><a href ng-click=\"tableCellRenderer.tableCellRendererConfig && tableCellRenderer.tableCellRendererConfig.events && tableCellRenderer.tableCellRendererConfig.events.edit(tableCellRenderer.tableCellRendererConfig,tableCellRenderer.tableCellRendererRow)\">Editar </a></span><span class=\"padding-left--0_5 padding-right--0_5\">/</span> <span><a href ng-click=\"tableCellRenderer.tableCellRendererConfig && tableCellRenderer.tableCellRendererConfig.events && tableCellRenderer.tableCellRendererConfig.events.delete(tableCellRenderer.tableCellRendererConfig,tableCellRenderer.tableCellRendererRow)\">Borrar</a></span></div>");}]);
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecSubmenuList', odecSubmenuList);

    //odecSubmenuList.$inject = ['dep'];
    function odecSubmenuList() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecSubmenuList/odecSubmenuList.html',
            bindToController: true,
            controller: odecSubmenuListController,
            controllerAs: 'vm',
            link: link,
            restrict: 'EA',
            transclude:true,
            scope: {
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /* @ngInject */
    function odecSubmenuListController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecSidebarToggle', odecSidebarToggle);

    //odecSidebarToggle.$inject = ['dependency1'];
    function odecSidebarToggle() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecSidebarToggle/odecSidebarToggle.html',
            bindToController: true,
            controller: odecSidebarToggleController,
            controllerAs: 'odecSidebarToggle',
            link: link,
            restrict: 'EA',
            scope: {
                odecSidebarToggleOpen:'&'
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecSidebarToggleController () {
        var vm = this;

        vm.clicked = clicked;

        /** private methods */
        function clicked(value) {
            vm.odecSidebarToggleOpen(value);
        }    
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecSidebarOverlay', odecSidebarOverlay);

    //odecSidebarOverlay.$inject = ['dependency1'];
    function odecSidebarOverlay() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/layout-ui/odecSidebarOverlay/odecSidebarOverlay.html',
            bindToController: true,
            controller: odecSidebarOverlayController,
            controllerAs: 'odecSidebarOverlay',
            link: link,
            restrict: 'EA',
            scope: {
                odecSidebarOverlayOpened:'=',
                odecSidebarOverlayClose:'&'
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecSidebarOverlayController () {
        var vm = this;

        vm.closeOverlay = closeOverlay;

        /** private methods */

        function closeOverlay(value) {
            vm.odecSidebarOverlayClose(value);
        } 
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecSidebar', odecSidebar);

    //odecSidebar.$inject = ['dependency1'];
    function odecSidebar() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecSidebar/odecSidebar.html',
            bindToController: true,
            controller: odecSidebarController,
            controllerAs: 'odecSidebar',
            link: link,
            restrict: 'EA',
            replace:true,
            transclude:true,
            scope: {
                odecSidebarOpened:'='
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecSidebarController () {
        
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecMenuListItem', odecMenuListItem);

    //odecMenuListItem.$inject = ['dep'];
    function odecMenuListItem() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecMenuListItem/odecMenuListItem.html',
            bindToController: true,
            controller: odecMenuListItemController,
            controllerAs: 'vm',
            link: link,
            restrict: 'EA',
            scope: {
                odecMenuListItemSelected:'=',
                odecMenuListItemIcon:'<',
                odecMenuListItemSelectedOnSelect:'&',
                odecMenuListItemLabel:'<',
                odecMenuListItemSubmenuChilds:'<'
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecMenuListItemController () {
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecMenuLink', odecMenuLink);

    odecMenuLink.$inject = ['$state'];
    function odecMenuLink($state) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecMenuLink/odecMenuLink.html',
            bindToController: true,
            controller: odecMenuLinkController,
            controllerAs: 'odecMenuLink',
            link: link,
            restrict: 'EA',
            scope: {
                odecMenuLinkLabel:'<',
                odecMenuLinkState:'<',
                odecMenuLinkUrl:'<',
                odecMenuLinkOnClick:'&',
                odecMenuLinkVisible: '<'
            }
        };
        return directive;
        
        function link(scope) {
            var vm = scope.odecMenuLink;
            vm.onClick = onClick;

            /** metodos privados */

            function onClick() {
                scope.$emit('odecMenuLink:clicked');
                $state.go.apply(this,vm.odecMenuLinkState);
            }
        }
    }
    /* @ngInject */
    function odecMenuLinkController () {
        
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecMenuList', odecMenuList);

    //odecMenuList.$inject = ['lodash'];
    function odecMenuList() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/layout-ui/odecMenuList/odecMenuList.html',
            bindToController: true,
            controller: odecMenuListController,
            controllerAs: 'odecMenuList',
            link: link,
            restrict: 'EA',
            scope: {
                odecMenuListCollection: '<'
            }
        };
        return directive;

        function link(scope) {
            var vm = scope.odecMenuList;
            // seleccionamos el primer item
            vm.data = {
                odecMenuListCollection: preSelect(vm.odecMenuListCollection)
            };
        }


        /** METODOS PRIVADOS */

        // si viene con algun elemento preseleccionado lo devolvemos tal cual sino
        // le preseleccionamos el primero
        function preSelect(collection) {
            var hasSelectedItem = _.chain(collection)
                .some(function (item) {
                    return item.selected;
                })
                .value();
            
            if (!hasSelectedItem) {
                return _.chain(collection)
                .map(function (item, index) {
                    if (index === 0) {
                        item.selected = true;
                    }
                    return item;
                })
                .value();
            }
            
            return collection;
        }
    }
    /* @ngInject */
    function odecMenuListController() {
        var vm = this;
        vm.onSelect = onSelect;

        /** private methods */
        function onSelect(event,menuItem) {
            if (!menuItem) {
                return;
            }
            
            // quitamos todos los seleccionados y ponemos el que toca a seleccionados
            vm.data.odecMenuListCollection = _.chain(vm.data.odecMenuListCollection)
            .map(function(item){
                if(item === menuItem) {
                    item.selected = true;
                } else {
                    item.selected = false;
                }
                return item;
            })
            .value();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecHeader', odecHeader);

    //odecHeader.$inject = ['dependency1'];
    function odecHeader() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecHeader/odecHeader.html',
            bindToController: true,
            controller: odecHeaderController,
            controllerAs: 'odecHeader',
            link: link,
            restrict: 'EA',
            replace:true,
            transclude:true,
            scope: {
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecHeaderController () {
        
    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .factory('usermanagementlistService', usermanagementlistService);

  /** @ngInject */
  function usermanagementlistService($http) {

    /** methods exposed */
    var service = {
      getUsers: getUsers,
      deleteUser:deleteUser
    };

    return service;

    /** private methods */

    function getUsers() {
      return $http({
        method: 'GET',
        url: './api/usermanagement'
      });
    }

    function deleteUser(userId) {
      return $http({
        method: 'DELETE',
        url: './api/usermanagement/' + userId
      });      
    }

  }
})();
(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];  
  function routerConfig($stateProvider) {
    $stateProvider
      .state('main.usermanagementlist', {
        url: '/usermanagementlist',
        templateUrl: 'app/userManagement/userManagementList/userManagementList.html',
        controller: 'UsermanagementlistController',
        controllerAs: 'usermanagementlist',
        resolve:{
          timing: timing
        }
      });
  }

  timing.$inject = ['publicaciones','configuration'];
  function timing(publicaciones,configuration) {
    return true;
  }


})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('UsermanagementlistController', UsermanagementlistController);

  UsermanagementlistController.$inject = ['$state', 'usermanagementlistService', 'errorHandlerService', 'userHelperService'];
  function UsermanagementlistController($state, usermanagementlistService, errorHandlerService, userHelperService) {
    var HEADER_FIELDS = [
      { property: 'id', label: 'id', hide: true, renderer: { type: 'text', options: {} } , notExportable: true},
      { property: 'name', label: 'id', renderer: { type: 'text', options: {} } },
      { property: 'email', label: 'usuario', renderer: { type: 'text', options: {} } },
      { property: 'projectId', label: 'proyecto', renderer: { type: 'text', options: {} } },
      { property: 'roles', label: 'roles', renderer: { type: 'text', options: {} } },
      { property: '_actions', label: '', renderer: { type: 'usermanageractionlist', options: { events: { edit: editUser, delete: deleteUser } } }, notExportable: true }
    ];
    var vm = this;
    vm.userCollection = [];
    vm.error = null;
    vm.loading = true;
    vm.headerFields = HEADER_FIELDS;
    vm.createNewUser = createNewUser;

    init();



    /** private methods */

    function init() {
      vm.loading = true;
      usermanagementlistService.getUsers()
        .then(function (data) {
          vm.userCollection = transformData(HEADER_FIELDS, data.data.data);
          vm.error = null;
        })
        .catch(function (error) {
          vm.error = error;
          vm.userCollection = [];
        })
        .finally(function () {
          vm.loading = false;
        });
    }

    function transformData(headerDefinition, data) {
      return _.map(data, function (el) {
        return _.reduce(headerDefinition, function (aggr, subitem) {
          aggr[subitem.property] = {
            renderer: subitem.renderer,
            value: el[subitem.property]
          };
          return aggr;
        }, {});
      })
    }

    function createNewUser() {
      $state.go('main.newuser');
    }

    function editUser(config, data) {
      $state.go('main.edituser', { idUser: data.id.value });
    }

    function deleteUser(config, data) {
      var id = data.id.value;
      var user = userHelperService.getUser();

      if (user.data.id === id) {
        errorHandlerService.callbackError('No se puede eliminar a si mismo');
        return;
      }

      usermanagementlistService.deleteUser(id)
        .then(function () {
          errorHandlerService.callbackSuccess.bind({ text: 'Usaurio eliminado correctamente' })();
          init();
        })
        .catch(function (error) {
          errorHandlerService.callbackError('No se pudo eliminar el usuario');
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .factory('newuserService', newuserService);

  /** @ngInject */
  function newuserService($http) {

    /** methods exposed */
    var service = {
    };

    return service;

    /** private methods */

  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];
  function routerConfig($stateProvider) {
    $stateProvider
      .state('main.newuser', {
        url: '/newuser',
        templateUrl: 'app/userManagement/newUser/newUser.html',
        controller: 'NewuserController',
        controllerAs: 'newuser',
        resolve: {
          timing: timing
        }
      });

    $stateProvider
      .state('main.edituser', {
        url: '/user/:idUser',
        templateUrl: 'app/userManagement/newUser/newUser.html',
        controller: 'NewuserController',
        controllerAs: 'newuser',
        resolve: {
          timing: timing
        }
      });
  }

  timing.$inject = ['publicaciones', 'configuration'];
  function timing(publicaciones, configuration) {
    return true;
  }


})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('NewuserController', NewuserController);

  NewuserController.$inject = ['$http', 'errorHandlerService', '$timeout', '$state', 'userHelperService', '$stateParams'];
  function NewuserController($http, errorHandlerService, $timeout, $state, userHelperService, $stateParams) {
    var vm = this;
    vm.loading = true;
    vm.editing = false;
    vm.userEditing = null;
    vm.data = {
      user: '',
      name: '',
      password: '',
      projects: {
        AIMC: false,
        AIMCCAT: false,
        AIMCMARCAS: false
      },
      roles: {
        ADMIN_USER: false,
        SEGUIMIENTO_CAMPO: false
      }
    };

    vm.createUser = createUser;
    vm.goBack = goBack;
    vm.userProjects = {
      AIMC: false,
      AIMCCAT: false,
      AIMCMARCAS: false
    };
    vm.hasRolField = false;
  

    init();



    /** private methods */

    function init() {
      var user = userHelperService.getUser();

      if (_.some(user.data.projectId.split(','), function (item) { return item === 'AIMC'; })) {
        vm.userProjects.AIMC = true;
      }

      if (_.some(user.data.projectId.split(','), function (item) { return item === 'AIMCCAT'; })) {
        vm.userProjects.AIMCCAT = true;
      }

      if (_.some(user.data.projectId.split(','), function (item) { return item === 'AIMCMARCAS'; })) {
        vm.userProjects.AIMCMARCAS = true;
      }

     
      if (user.data.roles && _.some(user.data.roles.split(','), function (item) { return item === 'SEGUIMIENTO_CAMPO'; })) {
        vm.hasRolField = true;
      }
      
      if (angular.isDefined($stateParams.idUser)) {
        vm.userEditing = $stateParams.idUser;
        
        vm.editing = true;
        findUser(vm.userEditing)
          .then(function(data){
            vm.loading = false;
            vm.data = {
              user: data.data.email,
              name: data.data.name,
              password: '----------',
              projects: {
                AIMC: _.some(data.data.projectId.split(','),function(item) { return item === 'AIMC';}),
                AIMCCAT: _.some(data.data.projectId.split(','),function(item) { return item === 'AIMCCAT';}),
                AIMCMARCAS: _.some(data.data.projectId.split(','),function(item) { return item === 'AIMCMARCAS';})
              },
              roles: {
                ADMIN_USER: data.data.roles && _.some(data.data.roles.split(','),function(item) { return item === 'ADMIN_USER';}),
                SEGUIMIENTO_CAMPO: data.data.roles && _.some(data.data.roles.split(','),function(item) { return item === 'SEGUIMIENTO_CAMPO';})
              }
            };
          })
          .catch(function() {
            errorHandlerService.callbackError('No se pudo acceder al usuario');
            $timeout(function () {
              $state.go('main.usermanagementlist');
            }, 900);
          });
      } else {
        vm.editing = false;
        vm.loading = false;
      }
    }

    function createUser() {
      var user = resolveBody(vm.data);
      if (!user.name) { errorHandlerService.callbackError('Se debe especificar un id de usuario'); return; }
      if (!user.email) { errorHandlerService.callbackError('Se debe especificar un usuario'); return; }
      if (!vm.editing && !user.password) { errorHandlerService.callbackError('Se debe especificar un password'); return; }
      if (!vm.editing && user.password === '----------') {errorHandlerService.callbackError('Este password no es valido, escoja otro'); return; }
      if (user.projectId.length === 0) { errorHandlerService.callbackError('Se debe especificar al menos un estudio'); return; }

      if (vm.editing) {
        update(user,vm.userEditing);
      } else {
        create(user);
      }
      
    }

    function create(user) {
      return $http({
        method: 'POST',
        url: './api/users',
        data: user
      })
        .then(function (data) {
          errorHandlerService.callbackSuccess.bind({ text: 'Usaurio creado correctamente' })();
          $timeout(function () {
            $state.go('main.usermanagementlist');
          }, 900);
        })
        .catch(function (error) {
          if (error.name === 'BadRequest') {
            errorHandlerService.callbackError('No se pudo crear el usuario');
            return;
          }
          errorHandlerService.callbackError('No se pudo crear el usuario');
        });
    }

    function update(user,userId) {
      return $http({
        method: 'PATCH',
        url: './api/users/' + userId,
        data: user
      })
        .then(function (data) {
          errorHandlerService.callbackSuccess.bind({ text: 'Usaurio creado correctamente' })();
          $timeout(function () {
            $state.go('main.usermanagementlist');
          }, 900);
        })
        .catch(function (error) {
          if (error.name === 'BadRequest') {
            errorHandlerService.callbackError('No se pudo crear el usuario');
            return;
          }
          errorHandlerService.callbackError('No se pudo crear el usuario');
        });
    }

    function findUser(idUser) {
      return $http({
        method: 'GET',
        url: './api/usermanagement/'+idUser
      });      
    }

    function resolveBody(data) {
      var body = {
        email: data.user,        
        name: data.name,
        projectId: Object.keys(data.projects).filter(function (item) { return data.projects[item]; }).join(','),
        roles: Object.keys(data.roles).filter(function (item) { return data.roles[item]; }).join('')
      }

      // este es el pass que se pone en la edicion, no deberia estar permitido
      if (data.password !== '----------') {
        body = _.extend({},body,{password: data.password})
      }
      
      return body;
    }

    function goBack() {
      $state.go('main.usermanagementlist');      
    }
  }
})();

/* eslint-disable angular/document-service */
(function () {
    'use strict';

    angular
        .module('app')
        .directive('tableManager', tableManager);

    //tableManager.$inject = [];
    function tableManager() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/tableManager/tableManager.html',
            bindToController: true,
            controller: TableManagerController,
            controllerAs: 'tableManager',
            link: link,
            restrict: 'EA',
            scope: {
                tableManagerDataCollection: '<',
                tableManagerColumns: '<'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var vm = scope.tableManager;


            var dataListener = scope.$watch('tableManager.tableManagerDataCollection', init);
            scope.$on('$destroy', function () {
                dataListener();
            });

            function init() {
                vm.proxyData = vm.tableManagerDataCollection;
                vm.setPagination(1);
            }
        }
    }
    /* @ngInject */
    function TableManagerController(toastr) {
        var vm = this;
        vm.filtered = false;
        vm.proxyData = [];

        // pagination
        vm.pagination = {
            MAX_ITEMS_PER_PAGE: 10,
            pageSelected: 1,
            total: 0
        };

        vm.search = {
            email: ''
        };

        vm.setPagination = setPagination;
        vm.onSearch = onSearch;
        vm.onRemoveFilter = onRemoveFilter;
        vm.copyToClipboard = copyToClipboard;

        // private methods
        function setPagination(page) {
            var itemStart = (vm.pagination.MAX_ITEMS_PER_PAGE) * (page - 1);
            var npages = Math.ceil(vm.proxyData.length / vm.pagination.MAX_ITEMS_PER_PAGE)

            if (vm.proxyData.length === 0) {
                vm.pagination.pageSelected = 0;
                vm.paginatedData = [];
                vm.pagination.total = npages;
                return;
            }

            if (!page || page > npages) { return; }
            vm.pagination.pageSelected = page;
            if (vm.search.email) {
                vm.paginatedData = vm.proxyData.slice(itemStart, itemStart + vm.pagination.MAX_ITEMS_PER_PAGE);
                vm.pagination.total = npages;

            } else {
                vm.paginatedData = vm.proxyData.slice(itemStart, itemStart + vm.pagination.MAX_ITEMS_PER_PAGE);
                vm.pagination.total = npages;
            }

        }

        function onSearch(text) {
            var regex = new RegExp(text);
            vm.proxyData = _.filter(vm.tableManagerDataCollection, function (item) { 
                return regex.test(item.email.value.toString()) || regex.test(item.name.value.toString()); 
            });
            vm.filtered = true;
            setPagination(1);
        }

        function onRemoveFilter() {
            vm.proxyData = vm.tableManagerDataCollection;
            vm.search.email = '';
            vm.filtered = false;
            setPagination(1);
        }

        function fnTransform() {
            var cabs = _.chain(vm.tableManagerColumns)
                .filter(function (item) { return !item.notExportable; })
                .map('label')
                .value();
            var data = _.chain(vm.tableManagerDataCollection)
                .reduce(function(aggr,item) {
                    
                    var output = _.chain(vm.tableManagerColumns)
                        .filter(function (x) { return !x.notExportable; })
                        .map('property')
                        .map(function(el) {
                            var val = item[el] && item[el].value && '"' + item[el].value + '"';
                            return val;
                        })
                        .value();
                    
                        aggr.push(output);

                        return aggr;

                },[])
                .value();
            
            var totalArr = [].concat([cabs],data);
            return _.map(totalArr,function(el) { return el.join('\t')}).join('\n');
        }

        function copyToClipboard() {
            var el = document.createElement('textarea');  // Create a <textarea> element
            el.value = fnTransform();                                 // Set its value to the string that you want copied
            el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
            el.style.position = 'absolute';
            el.style.left = '-9999px';                      // Move outside the screen to make it invisible
            document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
            var selected =
                document.getSelection().rangeCount > 0        // Check if there is any content selected previously
                    ? document.getSelection().getRangeAt(0)     // Store selection if found
                    : false;                                    // Mark as false to know no selection existed before
            el.select();                                    // Select the <textarea> content
            document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
            document.body.removeChild(el);                  // Remove the <textarea> element
            if (selected) {                                 // If a selection existed before copying
                document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
                document.getSelection().addRange(selected);   // Restore the original selection
            }
            toastr.success('La tabla esta copiada en el portapapeles','Proceso finalizado');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('tableCellRenderer', tableCellRenderer)
        .run(setTemplates);

        tableCellRenderer.$inject = ['$templateCache','$compile'];
    function tableCellRenderer($templateCache,$compile) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: TableCellRendererController,
            controllerAs: 'tableCellRenderer',
            link: link,
            restrict: 'EA',
            scope: {
                tableCellRendererType:'<',
                tableCellRendererConfig:'<',
                tableCellRendererData:'<',
                tableCellRendererRow:'<'
            }
        };
        return directive;

        function link(scope, element) {
            var vm = scope.tableCellRenderer,
                renderType,
                template;

            renderType = vm.tableCellRendererType;
            template = $templateCache.get(getTemplateUrl(renderType));

            element.replaceWith($compile(template)(scope));

            /** private methods */

            

            function getTemplateUrl(renderType) {
                return 'app/components/tableCellRenderer/templates/'+ renderType +'.html';
            }
        }
    }
    /* @ngInject */
    function TableCellRendererController () {

    }

    setTemplates.$inject = ['$q','$http','$templateCache','errorHandlerService'];
    /**
     * Method that will be run once at bootstrap and will include all templates that are necesary
     * for the renderer
     *
     * @param {any} $q
     * @param {any} $http
     * @param {any} $templateCache
     */
    function setTemplates($q,$http,$templateCache,errorHandlerService) {
        var sources = [
            {name:'text',url:'app/components/tableCellRenderer/templates/text.html'},
            {name:'usermanageractionlist',url:'app/components/tableCellRenderer/templates/usermanageractionlist.html'}
        ];

        $q.all(getSources(sources))
            .then(function(data){
                _.map(data,function(tmpl,index) {
                    if (tmpl && !$templateCache.get(sources[index].url)) {
                        $templateCache.put(sources[index].url,tmpl.data);
                    }
                });
            })
            .catch(errorHandlerService.callbackError);

        function getSources(sources) {
            return _.map(sources,function(source){
                if (!$templateCache.get(source.url)) {
                    return $http.get(source.url);
                }
            });
        }

    }


})();

(function () {
    'use strict';
  
    angular
      .module('app')
      .directive('odecWidgetField', odecWidgetField);
  
      odecWidgetField.$inject = [];
    function odecWidgetField() {
      
        var directive = {
            templateUrl: 'app/components/odecWidgetField/odecWidgetField.html',
            bindToController: true,
            controller: odecWidgetFieldController,
            controllerAs: 'odecWidgetField',
            link: link,
            restrict: 'EA',
            scope:{
                data: '<'
            }
            
          };

        return directive;

        function link(scope, element, attrs) {
            
            var vm = scope.odecWidgetField;
            var configWatcher;
            vm.chartData = [];
            vm.chartCategories = [];
            vm.chartConfig = {};
            vm.hasData = false;
            var series;

            // Watchers
            configWatcher = scope.$watch(function () {
                return vm.data;
            }, init);

            scope.$on('$destroy', function () {
                configWatcher();
            });

            function init(data){
              
                var config = data || vm.data;
                if (!config) {
                    return;
                }

                series = angular.copy(config);
                // vm.categories = angular.copy(config.categories);
                vm.idChart = 'odec-widget-field-chart';
                vm.chartConfig = angular.copy(getConfigColumn());
                vm.chartData = series;
                vm.chartCategories = series[0].categorias;
            }

            function getConfigColumn() {

                return {                   
                    title: {
                        text: ''
                    },
                    chart: {
                        type: 'line',
                        spacingBottom: 60
                    },
                    xAxis: {
                        enableMouseTracking: true
                    },
                    yAxis: {
                        min: 0,
                        title: null,
                        gridLineDashStyle: 'longdash',
                    },
                    tooltip: {
                        enabled: true,
                        backgroundColor: '#ffffff',
                        shared: true,
                        crosshairs: true,
                        useHTML: true,
                        headerFormat: '<div style="font-size: 15px; margin-left: 10px;"> Día {point.key} </div>',
                        pointFormat: '<span"> <a style="font-size: 12px; color:{series.color};">●</a> <b> {series.name}: {point.y}</b><br/>',
                        style: {
                            fontFamily: 'Montserrat'
                        }
                    },
                    plotOptions: {
                        series: {
                            point: {
                                events: {
                                    mouseOut: function (e) {
                                        this.dataLabel.css({
                                            fontSize: "0px"
                                        });
                                    },
                                    mouseOver: function (e) {
                                        this.dataLabel.css({
                                            fontSize: "11px"
                                        });
                                    }
                                }
                            },
                            dataLabels: {
                                enabled: true,
                                align: 'center',
                                style: { fontSize: '0px' },
                                states: {
                                    hover: {
                                        enabled: true
                                    }
                                }
                            }
                        },
                        line: {
                            marker: {
                                enabled: true,
                                symbol: 'circle',
                                radius: 4
                            }
                        }
                    },
                    credits:{
                        enabled: false
                    },
                    legend: {
                        symbolHeight: 0,
                        symbolPadding: 10,
                        symbolWidth: 0,
                        verticalAlign: 'bottom',
                        align: 'left',
                        x: 60,
                        labelFormatter: function () {
                        return '<span"><b style="padding: 10px;">' + this.name + '</b><br/>';
                    }
                    } ,
                    responsive: {
                        rules: [{
                          condition: {
                            maxWidth: 500
                          },
                          chartOptions: {
                            legend: {
                              itemWidth: 125
                            }
                          }
                        }]
                      }
                }
            }
        }
    }
    /* @ngInject */
    function odecWidgetFieldController() {
      var vm = this;
    }

  })();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecViewDataLoader', odecViewDataLoader);

    //odecViewDataLoader.$inject = ['dependency1'];
    function odecViewDataLoader() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecViewDataLoader/odecViewDataLoader.html',
            bindToController: true,
            controller: odevViewDataLoaderController,
            controllerAs: 'odecViewDataLoader',
            link: link,
            restrict: 'EA',
            scope: {
                odecViewDataLoaderLoading:'='
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /* @ngInject */
    function odevViewDataLoaderController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecTransitionPage', odecTransitionPage);

    /* @ngInject */
    function odecTransitionPage($rootScope) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecTransitionPage/odecTransitionPage.html',
            bindToController: true,
            controller: odecTransitionPageController,
            controllerAs: 'odecTransitionPage',
            link: link,
            restrict: 'EA',
            replace:true,
            scope: {
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /* @ngInject */
    function odecTransitionPageController ($rootScope,$scope) {
        var vm = this,
            startWatcher,
            endWatcher;


        vm.loading = true;

        /** watchers */
        startWatcher = $rootScope.$on('transition:start',function() {toggleLoading(true);});
        endWatcher = $rootScope.$on('transition:end',function() {toggleLoading(false);});

        $scope.$on('$destroy',function() {
            startWatcher();
            endWatcher();
        });


        /** private methods */
        function toggleLoading(value) {
            vm.loading = value;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecSelect2', odecSelect2);

    /** @ngInject */
    function odecSelect2($rootScope) {
        var directive = {
            templateUrl: 'app/components/odecSelect2/odecSelect2.html',
            restrict: 'EA',
            replace:true,
            scope: {
                odecSelect2Data: '=',
                odecSelect2Event:'<',
                odecSelect2Selection: '=',
                odecSelect2Raw: '@',
                odecSelect2Placeholder: '@',
                odecSelect2ConfigExtra: '@',
                odecSelect2AllowClear: '=',
                odecSelect2Disabled: '<',
                odecSelect2Multiple: '='
            },            
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el) {
            var select2Component,
                eventName = 'select2',
                options;

            if (scope.odecSelect2Multiple) {
                eventName = 'multiple';
            }

            if (scope.odecSelect2Event) {
                eventName += ':' + scope.odecSelect2Event;
            }

            /** private methods */
            function init(newData,oldData) {
                angular.element(el).html('');

                options = {                    
                    placeholder: scope.odecSelect2Placeholder || '...',
                    data: newData || [],
                    allowClear: scope.odecSelect2AllowClear,
                    multiple: scope.odecSelect2Multiple
                };

                scope.odecSelect2Selection = scope.odecSelect2Selection || null;

                if (scope.odecSelect2Raw) {
                    initRaw();
                } else {
                    initWithData();
                }
            }

            function initWithData() {
                options.disabled=scope.odecSelect2Disabled;
                select2Component = angular.element(el).select2(options);
                select2Component.val(scope.odecSelect2Selection).trigger('change');
            }

            function initRaw() {
                select2Component = angular.element(el).select2(options);
                select2Component.val(scope.odecSelect2Selection).trigger('change');            
            }

            /** events */
            angular.element(el).on('select2:select',function(event){
                $rootScope.$emit(eventName,angular.extend(event.params.data,{events:{selecting:true, multiple: scope.odecSelect2Multiple}}));
            });

            angular.element(el).on('select2:unselect',function(event){
                $rootScope.$emit(eventName,angular.extend(event.params.data,{events:{removing:true, multiple: scope.odecSelect2Multiple}}));
            });
            

            /** listeners */
            
            var collectionWatcher = scope.$watch('odecSelect2Data', init);
            var selectionWatcher = scope.$watch('odecSelect2Selection',function(newValue,oldValue){
                if (newValue) {
                    //select2Component.val(newValue);
                    select2Component.val(newValue).trigger('change');
                } 
                
            });
            var disabledWatcher = scope.$watch('odecSelect2Disabled',function(newValue,oldValue) {
                select2Component.prop('disabled', newValue);
            });
            
            scope.$on('$destroy', function () {
                collectionWatcher();
                selectionWatcher();
                disabledWatcher();
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecScrollable', odecScrollable);

    /** @ngInject */
    function odecScrollable($timeout) {
        var directive = {
            restrict: 'EA',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr) {
            var isMobile = mobileDetection();

            var transitionEvent = whichTransitionEvent();

            // param options passed to niceScroll
            var opciones = {};

            // width of bar
            opciones.width = attr.odecScrollableWidth || 7;

            // color of bar
            opciones.color = attr.odecScrollableColor || '#cecece';

            // align
            opciones.railalign = attr.odecScrollableRailalign || 'right';

            // time to wait before repaint, else sometimes on hide/show does not paint well
            opciones.waitAnimation = attr.odecScrollableWaitanimation || 300;

            opciones.zindex = attr.odecScrollableZindex || null;

            // autohide param
            if (attr.odecScrollableAutohide === 'true') {
                opciones.autohide = true;
            } else if (attr.odecScrollableAutohide === 'false') {
                opciones.autohide = false;
            } else if (attr.odecScrollableAutohide) {
                opciones.autohide = attr.odecScrollableAutohide;
            } else {
                opciones.autohide = false;
            }


            // in case odecScrollableShow undefined create it else wait til it changes
            if (!attr.odecScrollableShow) {
                create();
            }

            /** private methods */

            // initialization
            function create() {
                if (isMobile.any) {
                    angular.element(el).css('overflow-y', 'scroll');
                    return;
                }

                if (angular.element(el).getNiceScroll().length !== 0) {
                    // if already exists repaint
                    resize();
                } else {
                    // if not already exists call pluggin 
                    angular.element(el).niceScroll({
                        autohidemode: opciones.autohide,
                        styler: 'fb',
                        cursorcolor: opciones.color,
                        cursorwidth: opciones.width,
                        cursorborderradius: '0px',
                        background: 'rgb(118,122,125)',
                        spacebarenabled: false,
                        cursorborder: '0',
                        railalign: opciones.railalign,
                        zindex:opciones.zindex
                    });

                    resize();

                    // resize it just in case there's any animation
                    /*$timeout(function () {
                        angular.element(el).getNiceScroll().resize();
                    }, opciones.waitAnimation);*/
                }
            }

            // on destroy
            function destroy() {
                // clean it. wait in case there's any animation
                $timeout(function () {
                    angular.element(el).getNiceScroll().remove();
                    angular.element(el).attr('style', '');
                }, opciones.waitAnimation);
            }

            function whichTransitionEvent() {
                var t,
                    el = document.createElement("fakeelement");

                var transitions = {
                    "transition": "transitionend",
                    "OTransition": "oTransitionEnd",
                    "MozTransition": "transitionend",
                    "WebkitTransition": "webkitTransitionEnd"
                };

                for (t in transitions) {
                    if (el.style[t] !== undefined) {
                        return transitions[t];
                    }
                }
            }

            function resize() {
                return el.one(transitionEvent,function() {
                    angular.element(el).getNiceScroll().resize();
                });
            }

            /** listeners */

            // on show/hide change
            attr.$observe('odecScrollableShow', function (newValue) {
                if (newValue === 'false') {
                    // if hidding and already exists destroy it
                    if (angular.element(el).getNiceScroll().length !== 0) {
                        destroy();
                    }
                }

                // if showing initialize
                if (newValue === 'true') {
                    create();
                }
            });

            // on destroy
            scope.$on('$destroy', function () {
                destroy();
            });
        }

        function mobileDetection() {

            var mobileDetection,
                apple_phone = /iPhone/i,
                apple_ipod = /iPod/i,
                apple_tablet = /iPad/i,
                android_phone = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
                android_tablet = /Android/i,
                amazon_phone = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
                amazon_tablet = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
                windows_phone = /IEMobile/i,
                windows_tablet = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
                other_blackberry = /BlackBerry/i,
                other_blackberry_10 = /BB10/i,
                other_opera = /Opera Mini/i,
                other_chrome = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
                other_firefox = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
                seven_inch = new RegExp(
                    '(?:' + // Non-capturing group

                    'Nexus 7' + // Nexus 7

                    '|' + // OR

                    'BNTV250' + // B&N Nook Tablet 7 inch

                    '|' + // OR

                    'Kindle Fire' + // Kindle Fire

                    '|' + // OR

                    'Silk' + // Kindle Fire, Silk Accelerated

                    '|' + // OR

                    'GT-P1000' + // Galaxy Tab 7 inch

                    ')', // End non-capturing group

                    'i'); // Case-insensitive matching

            var match = function (regex, userAgent) {
                return regex.test(userAgent);
            };

            var IsMobileClass = function (userAgent) {
                var ua = userAgent || navigator.userAgent;

                // Facebook mobile app's integrated browser adds a bunch of strings that
                // match everything. Strip it out if it exists.
                var tmp = ua.split('[FBAN');
                if (typeof tmp[1] !== 'undefined') {
                    ua = tmp[0];
                }

                // Twitter mobile app's integrated browser on iPad adds a "Twitter for
                // iPhone" string. Same probable happens on other tablet platforms.
                // This will confuse detection so strip it out if it exists.
                tmp = ua.split('Twitter');
                if (typeof tmp[1] !== 'undefined') {
                    ua = tmp[0];
                }

                this.apple = {
                    phone: match(apple_phone, ua),
                    ipod: match(apple_ipod, ua),
                    tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
                    device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
                };
                this.amazon = {
                    phone: match(amazon_phone, ua),
                    tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
                    device: match(amazon_phone, ua) || match(amazon_tablet, ua)
                };
                this.android = {
                    phone: match(amazon_phone, ua) || match(android_phone, ua),
                    tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
                    device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
                };
                this.windows = {
                    phone: match(windows_phone, ua),
                    tablet: match(windows_tablet, ua),
                    device: match(windows_phone, ua) || match(windows_tablet, ua)
                };
                this.other = {
                    blackberry: match(other_blackberry, ua),
                    blackberry10: match(other_blackberry_10, ua),
                    opera: match(other_opera, ua),
                    firefox: match(other_firefox, ua),
                    chrome: match(other_chrome, ua),
                    device: match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
                };
                this.seven_inch = match(seven_inch, ua);
                this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

                // excludes 'other' devices and ipods, targeting touchscreen phones
                this.phone = this.apple.phone || this.android.phone || this.windows.phone;

                // excludes 7 inch devices, classifying as phone or tablet is left to the user
                this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;

                if (typeof window === 'undefined') {
                    return this;
                }
            };

            var instantiate = function () {
                var IM = new IsMobileClass();
                IM.Class = IsMobileClass;
                return IM;
            };

            mobileDetection = instantiate();
            return mobileDetection;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecPublicationSelectorOverlay', odecPublicationSelectorOverlay);

    odecPublicationSelectorOverlay.$inject = [];
    function odecPublicationSelectorOverlay() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecPublicationSelectorOverlay/odecPublicationSelectorOverlay.html',
            bindToController: true,
            controller: OdecPublicationSelectorOverlayController,
            controllerAs: 'odecPublicationSelectorOverlay',
            link: link,
            restrict: 'EA',
            scope: {
                odecPublicationSelectorOverlayCollection:'<',
                odecPublicationSelectorOverlayPreselection:'<',
                odecPublicationSelectorOverlayOnSelection:'&', // {year:...,publication:...}
                odecPublicationSelectorOverlayOnClose:'&',
                odecPublicationSelectorOverlayOpened:'<',
                odecPublicationSelectorOverlayProject:'<'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
            var vm = scope.odecPublicationSelectorOverlay;

            scope.$watch('odecPublicationSelectorOverlay.odecPublicationSelectorOverlayPreselection',init);

            function init() {
                vm.collection = vm.odecPublicationSelectorOverlayCollection[vm.odecPublicationSelectorOverlayProject];
                vm.selection = vm.odecPublicationSelectorOverlayPreselection;       
                vm.pubSetFilteredByYear = vm.getPubsFiltered(vm.collection,vm.selection.year);    
            }
        }
    }
    /* @ngInject */
    function OdecPublicationSelectorOverlayController ($rootScope) {
        var vm = this;
        
        vm.collection = [];
        vm.selection = vm.selection || {year:null,publication:null};
        vm.publicationsFiltered = [];
        vm.onYearSelected = onYearSelected;
        vm.getPubsFiltered = getPubsFiltered;
        vm.onPublicationSelection = onPublicationSelection;
        vm.closeFilter = closeFilter;

        function onYearSelected(selection) {
            vm.pubSetFilteredByYear = getPubsFiltered(vm.collection,selection.year)
        }

        function onPublicationSelection(publication) {
            vm.selection = {year:publication.year,publication:publication};
            vm.odecPublicationSelectorOverlayOnSelection({publication:publication});
            $rootScope.$emit('overlayselectionevent',publication);
            vm.odecPublicationSelectorOverlayOpened = false;
        }

        function getPubsFiltered(collection,year) {
            var setFiltered = _.find(vm.collection,{year:year});
            return setFiltered? setFiltered.publications:[];
        }

        function closeFilter() {
            vm.odecPublicationSelectorOverlayOnClose();
            vm.odecPublicationSelectorOverlayOpened = false;
        }

        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecLoadingButton', odecLoadingButton);

    function odecLoadingButton() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecLoadingButton/odecLoadingButton.html',
            bindToController: true,
            controller: odecLoadingButtonController,
            controllerAs: 'odecLoadingButton',
            link: link,
            restrict: 'EA',
            transclude:true,
            replace:true,
            scope: {
                odecLoadingButtonLoading:'='
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /* @ngInject */
    function odecLoadingButtonController () {
        
    }
})();
/*global Highcharts */
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecHighcharts', odecHighcharts);

    odecHighcharts.$inject = ['$timeout'];

    function odecHighcharts($timeout) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: odecHighchartsController,
            controllerAs: 'odecHighcharts',
            link: link,
            restrict: 'EA',
            scope: {
                odecHighchartsConfig: '<',
                odecHighchartsData: '<',
                odecHighchartsCategories: '<',
                odecHighchartsInstance: '=',
                odecHighchartsOnClick: '&'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var vm = scope.odecHighcharts;
            var chart,
                dataWatcher,
                TIMEOUT_REFLOW = 300;


            dataWatcher = scope.$watch(function() {
                return vm.odecHighchartsData;
            }, init);

            scope.$on('$destroy', function() {
                dataWatcher();
            });



            // private methods
            function init(newData) {
                // in case the data is null exit
                if (!newData || newData.length <= 0) {
                    return;
                }

                var opciones = vm.odecHighchartsConfig;

                // add data
                opciones.series = vm.odecHighchartsData && vm.odecHighchartsData.length > 0 ?
                    vm.odecHighchartsData :
                    vm.odecHighchartsConfig.series;

                // add categories
                opciones.xAxis = opciones.xAxis || {};
                opciones.xAxis.categories = vm.odecHighchartsCategories && vm.odecHighchartsCategories.length > 0 ?
                    vm.odecHighchartsCategories :
                    vm.odecHighchartsConfig.categories;

                // get id for chart from parent element
                opciones.chart = opciones.chart || {};
                opciones.chart.renderTo = element.attr('id');

                // set events                            
                if (angular.isDefined(attrs.odecHighchartsOnClick)) {
                    opciones.plotOptions = opciones.plotOptions || {};
                    opciones.plotOptions.series = opciones.plotOptions.series || {};
                    opciones.plotOptions.series.point = opciones.plotOptions.series.point || {};
                    opciones.plotOptions.series.point.events = {
                        click: angular.isDefined(attrs.odecHighchartsOnClick) && onClick
                    };
                }

                // fix responsive bug: need that container has own width and highcharts-container
                // to be width:100%
                element.attr('style','display:block;width:100%');
                chart = new Highcharts.Chart(opciones);
                reflow();

            }

            function reflow() {
                $timeout(function() {
                    chart.reflow();
                }, TIMEOUT_REFLOW);
            }

            function onClick(event) {
                vm.odecHighchartsOnClick({event:event});
            }
        }
    }
    /* @ngInject */
    function odecHighchartsController() {
        //var vm = this;
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecDatatable', odecDatatable);

    /** @ngInject */
    function odecDatatable($translate) {
        var directive = {
            restrict: 'EA',
            scope: {
                odecDatatableData: '=',
                odecDatatableColumns: '=',
                odecDatatableColumnDefs: '=',
                odecDatatableSort: '=',
                odecDatatableLanguageUrl: '@',
                odecDatatableSearchText:'=',
                odecDatatableAllowRowClick:'<',
                odecDatatableAllowCellClick:'<',
                odecDatatableTableState: '<',
                odecDatatablePageLength: '<',
                odecDatatableLengthMenu: '<',
                odecDatatableShowLengthMenu: '<',
                odecDatatableNotDestroy: '<',
                odecDatatablePaginate: '<'
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el,attr) {
            var options,
                tabla,
                id,
                event,
                saveState;

            //Specify the entries in the length drop down menu that DataTables shows when pagination is enabled. 
            //default COMBO -- OPTIONAL COMBO --> scope.odecDatatableLengthMenu;
            var comboNumberRowsSelector = [[10, 20, 50, 100], [10, 20, 50, 100]];
            
            id = attr.id;

            if (id) {
                event = 'datatables:' + id + ':';
            } else {
                event = 'datatables:';
            }
            
            /** private methods */

            // datatables initialization, prepares config and calls plugin
            function init(newData) {
                if (tabla && !scope.odecDatatableNotDestroy) {
                    destroy();
                }

                // only initiate if newData is not null
                if (!newData || !newData.length > 0) {return;}

                options = {};

                // set i18
                options.language = {
                    url: scope.odecDatatableLanguageUrl
                };

                // set data rows only if is defined
                if (angular.isDefined(scope.odecDatatableData)) {
                    options.data = scope.odecDatatableData;
                }

                // set data columns only if defined
                if (angular.isDefined(scope.odecDatatableColumns)) {
                    options.columns = scope.odecDatatableColumns;
                }

                // set column defs only if defined
                if (angular.isDefined(scope.odecDatatableColumnDefs)) {
                    options.columnDefs = scope.odecDatatableColumnDefs;
                }

                // if passed some sorting use it else will order by default using first column
                if (angular.isDefined(scope.odecDatatableSort)) {
                    options.aaSorting = scope.odecDatatableSort;
                } else {
                    options.aaSorting = [];
                }

                //Table state (columns sorting, search, pagination, ...)
                saveState = angular.isDefined(scope.odecDatatableTableState);

                // destroy table each time is update otherwise won't update
                options.destroy = true;

                // processing overlay during process
                options.bProcessing = true;

                // defer drawing, this avoids freezing when to much rows
                options.bDeferRender = true;

                // hide length change combo
                options.bLengthChange = false;

                if (angular.isDefined(scope.odecDatatablePaginate)) {
                    options.bPaginate = scope.odecDatatablePaginate;
                    options.bInfo = scope.odecDatatablePaginate;
                }

                if (angular.isDefined(scope.odecDatatablePageLength)) {
                    options.pageLength = scope.odecDatatablePageLength;
                }

                if (angular.isDefined(scope.odecDatatableShowLengthMenu) && scope.odecDatatableShowLengthMenu === true) {
                    options.bLengthChange = true;
                    //Optional combo to show
                    if(angular.isDefined(scope.odecDatatableLengthMenu)){
                        options.aLengthMenu = scope.odecDatatableLengthMenu;
                    }   
                    options.aLengthMenu = comboNumberRowsSelector;
                }

                // type of paging is simple numbers
                options.pagingType = 'simple_numbers';
                options.dom = '<"top"f>rt<"bottom"lip><"clear">';

                // in case the table don't fit x-space there will be a scrollbar
                options.sScrollX = true;

                //Saving the table state?
                options.stateSave = saveState;

                /**
                 * We emit the current table state
                 * 
                 * !! This will be call only if 'stateSave' value is true.
                 */
                options.stateSaveCallback = function (settings, data) {
                    var state = _.extend(data,{},{aiDisplay:settings.aiDisplay,aoData:settings.aoData});
                    scope.$emit('datatables:saveState', state);
                };

                /**
                 * Return the previous saved state
                 * 
                 * !! This will be call only if 'stateSave' value is true.
                 */
                options.stateLoadCallback = function (settings) {
                    return scope.odecDatatableTableState;
                };


                if (options.data && options.data.length > 0) {
                    // inititalize datatables just in case there is data
                    tabla = angular.element(el).DataTable(options);
                }

                if (scope.odecDatatableAllowCellClick) {
                    tabla.off( 'click' ).on( 'click', 'td', function () {
                        var cell = tabla.cell(this);
                        var index = tabla.cell(this).index();
                        scope.$emit(event + 'cell',{cell:cell, index:index});
                    });
                }
                
                if (scope.odecDatatableAllowRowClick) {
                    tabla.off('click','td');
                    tabla.on( 'click', 'td', function () {
                        var row = tabla.row(this).data();
                        scope.$emit(event + 'row',{row:row});
                    });
                }
            }

            // metod on destroy
            function destroy() {
                if (tabla) {
                    tabla.state.save();
                    tabla.destroy();
                    angular.element(el).empty();
                }
            }

            // method used to externalize search
            function searchGlobal(newData, oldData) {
                if (newData !== oldData) {
                    tabla.search(
                        newData,
                        false, //Regex
                        false //Smart search
                    ).draw();
                }
            }

            /** listeners */

            // watch change on data input
            var datawatch = scope.$watch('odecDatatableData', init);

            // watch change on search input
            var seachTextWatch = scope.$watch('odecDatatableSearchText', searchGlobal);

            // on destroy listener
            scope.$on('$destroy', function() {
                destroy();
                datawatch();
                seachTextWatch();
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecLayoutUi', odecLayoutUi);

    //odecLayoutUi.$inject = ['dependency1'];
    function odecLayoutUi() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/layoutUi.html',
            bindToController: true,
            controller: odecLayoutUiController,
            controllerAs: 'vm',
            link: link,
            restrict: 'EA',
            transclude:true,
            replace:true,
            scope: {
                opened:'='                
            }
        };
        return directive;
        
        function link() {           

        }
    }
     /* @ngInject */
    function odecLayoutUiController () {
        
    }    
})();

(function () {
  'use strict';

  angular
    .module('app')
    .factory('publicationpageService', publicationpageService);

  /** @ngInject */
  function publicationpageService(configurationLoaderService, $http, $q,stateManagerService) {

    var publicationGroupCollection = {
      data: [],
      selected: null
    };
    /** methods exposed */
    var service = {
      getPublicaciones: getPublicaciones,
      preventNonAuthorizedProjects: preventNonAuthorizedProjects
    };

    return service;

    /** private methods */

    function getPublicaciones() {
      return fetchPublicaciones()
        .then(preventNonAuthorizedProjects)
        .then(preparePublicationData)
        .then(sortPublicationData)
        .then(persistInStore);
    }

    function fetchPublicaciones() {
      return $http({
        method: 'GET',
        url: '/api/publicaciones?$sort[id]=1'
      });
    }

    function persistInStore(publications) {
      return stateManagerService.setState('publications',publications);
    }

    function preventNonAuthorizedProjects(publications) {
      var publicationsAvailable = publications.data.data;

      var validPubs = _.chain(publicationsAvailable)
        .filter(function (pub) {
          return _.chain(configurationLoaderService.getConfig().allowedProjectIds).some(function (el) { return el === pub.projectId; }).value();
        })
        .value();

      if (!validPubs || validPubs.length <= 0) {
        return $q.reject({ data: { "name": "NotAllowed", "message": "User not allowed", "code": 402, "className": "not-authenticated", "errors": {} } });
      }

      return validPubs;
    }

    function preparePublicationData(publications) {
      return _.reduce(publications, function (aggr, item) {
        // console.log("// ==================================== //");
        // console.log(item.publicacionId);
        var info = (item.publicacionId).match(/(.*):(.*)::(.*)/);
        if (!(info[0] && info[1] && info[2] && info[3])) {
          console.warn('Parece que hay una publicacion mal formateada');
          return aggr;
        }

        var obj = {
          year: info[2],
          pubURL: item.publicacionUrl,
          pubId: info[3],
          pubLabel: item.publicacionLabel
        };

        var pubId = item.projectId;

        if (!aggr[pubId]) { aggr[pubId] = []; }

        var _yearSearch = _.find(aggr[pubId], { year: obj.year });
        if (_yearSearch) {
          _yearSearch.publications.push(obj);
        } else {
          aggr[pubId].push({
            year: obj.year,
            publications: [].concat(obj)
          });
        }
        // console.log(aggr);
        // console.log(length);
        // console.log(_.chain(aggr).map('publications').flatten().value().length);
        return aggr;

      }, {});
    }

    function sortPublicationData(pubCollection) {      
      return _.chain(pubCollection).keys().reduce(function(aggr,key){ aggr[key]=sortCollection(pubCollection[key]);return aggr;},{}).value();
    }

    function sortCollection(pubCollection) {
      var lasts = _.find(pubCollection, { year: "ULTIMOS DATOS" });
      if (!lasts) {
        return _.chain(pubCollection).orderBy(function (item) { return parseInt(item.year); }, ['desc']).value();
      }
      var lastsIndex = _.findIndex(pubCollection, { year: "ULTIMOS DATOS" });
      var restCollection = _.filter(pubCollection, function (item) { return item.year !== 'ULTIMOS DATOS'; });
      var sortedRestCollection = _.chain(restCollection).orderBy(function (item) { return parseInt(item.year); }, ['desc']).value();
      return [].concat(lasts, sortedRestCollection);
    }


  }
})();
(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];  
  function routerConfig($stateProvider) {
    $stateProvider
      .state('main.publicationpage', {
        url: '/publicationpage',
        templateUrl: 'app/publicationpage/publicationpage.html',
        controller: 'PublicationpageController',
        controllerAs: 'publicationpage',
        params: {
          publicationId:'AIMC'
        },
        resolve:{
          
        }
      });
  }



})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('PublicationpageController', PublicationpageController);

PublicationpageController.$inject = ['$scope','$timeout','$state','$rootScope','mainService','storageService'];
  function PublicationpageController($scope,$timeout,$state,$rootScope,mainService,storageService) {
    var vm = this;
    vm.iframeSrc = null;
    vm.iframeSrc2 = null;

    init();

    var overlayselectionlistener = $rootScope.$on('overlayselectionevent', onPublicationSelectionOverlaySelectionEvent);

    $scope.$on('$destroy', function () {
      overlayselectionlistener();
    });

    /** private methods */

    function init() {
      $scope.$emit('projectSelectionEvent',{id:$state.params.publicationId});
      var pub =  mainService.getPubSelection(null,$state.params.publicationId);
      onPublicationSelectionOverlaySelection(pub) ;
    }


    function onPublicationSelectionOverlaySelection(publication) {
      /** limpiamos el idle */
      storageService.save('lastResource', new Date());
      /** */
      vm.filterOpened = false;
      vm.publicationSelected = _.extend({}, publication, { publication: publication });
      vm.iframeSrc2 = "/visualwebPlus/logout.jsp";
      $timeout(function () {
        vm.iframeSrc2 = null;
        vm.iframeSrc = null;
        vm.iframeSrc = vm.publicationSelected.pubURL;
      }, 600);
    }

    function onPublicationSelectionOverlaySelectionEvent(evnt,publication) {
      onPublicationSelectionOverlaySelection(publication);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .factory('mainService', mainService);

  /** @ngInject */
  function mainService(configurationLoaderService, $http, storageService, $q,stateManagerService) {
    return {
      getPubSelection:getPubSelection
    }
    

    function getPubSelection(pubCollections,project,pubId) {
      pubCollections = pubCollections || stateManagerService.getState('publications');
      var pubCollection = pubCollections[project];   
      
      // TODO: En algun sitio cuando es AIMCCAT solo se le pasa como project AIMC
      if (!pubCollection) { return {}; }

      if (pubId) {
        var p = _.chain(pubCollection).map('publications').flatten().find({pubId:pubId}).value()
        if (p) {
          return {
            pubURL:p.pubURL,
            pubId:p.pubId,
            pubLabel:p.pubLabel,
            year: p.year,
            publication:p
          };  
        }
      }
      var lasts = _.chain(pubCollection).find({ year: 'ULTIMOS DATOS' }).value();
      if (!lasts) {
        return {
          pubURL:pubCollection[0].publications[0].pubURL,
          pubId:pubCollection[0].publications[0].pubId,
          pubLabel:pubCollection[0].publications[0].pubLabel,
          year: pubCollection[0].publications[0].year,
          publication:pubCollection[0].publications[0]
        };
      }

      return {
        pubURL:lasts.publications[0].pubURL,
        pubId:lasts.publications[0].pubId,
        pubLabel:lasts.publications[0].pubLabel,
        year: lasts.year,
        publication:lasts.publications[0]
      };
    }

  }
})();
(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];  
  function routerConfig($stateProvider) {
    $stateProvider
      .state('main', {
        url: '/main',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main',
        resolve:{
          publicaciones: getPublicaciones,
          configuration:getConfiguration
        }
      });
  }

  getConfiguration.$inject = ['errorHandlerService','configurationLoaderService','$q'];
  function getConfiguration(errorHandlerService,configurationLoaderService,$q) {
    return configurationLoaderService.getRemoteConfig()
      .catch(errorHandlerService.callbackError);
  }

  getPublicaciones.$inject = ['configuration','publicationpageService'];  
  function getPublicaciones(configuration,publicationpageService) {
    return publicationpageService.getPublicaciones();
  }


})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('MainController', MainController);

  MainController.$inject = ['mainService', 'loginService', 'storageService', '$state', 'publicaciones', '$timeout', 'configurationLoaderService', '$rootScope', '$scope','$interval'];
  function MainController(mainService, loginService, storageService, $state, publicaciones, $timeout, configurationLoaderService, $rootScope, $scope,$interval) {
    var vm = this;
    vm.user = null;
    vm.filterOpened = false;
    vm.logout = logout;
    vm.filterOpened = false;
    vm.isUserAdmin = false;

    vm.publicationSelected = { year: null, publication: null };
    vm.publicationCollection = publicaciones;
    vm.openPublicationSelectionOverlay = openPublicationSelectionOverlay;
    vm.onPublicationSelectionOverlayClose = onPublicationSelectionOverlayClose;
    vm.projectPreselected = null;
    vm.projectsCollection = [];
    vm.selectProject = selectProject;
    vm.goBackHome = goBackHome;
    vm.filtersAvailable = false;
    vm.goHomeAvailable = false;

    init();

    var publicationChangeListener = $rootScope.$on('projectSelectionEvent', projectSelectionEvent);
    var overlayselectionlistener = $rootScope.$on('overlayselectionevent', selectPublication);
    var routeControl = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      validateButtonsForUrl(toState);
    });

    var idlePoolingPromise;
    idlePooling();

    $scope.$on('$destroy', function () {
      publicationChangeListener();
      routeControl();
      $interval.cancel(idlePoolingPromise);
    });

    /** private methods */

    function init() {
      // inicializamos la vista
      vm.iframeSrc2 = "/visualwebPlus/logout.jsp";
      $timeout(function () {
        vm.iframeSrc = null;
        storageService.save('lastResource',null);
      }, 600);


      vm.user = loginService.getUser();
      vm.isUserAdmin = vm.user.data.roles && _.some(vm.user.data.roles.split(','), function (item) { return item === 'ADMIN_USER' });
      vm.publicationSelected = getPublicationPreselection(vm.publicationCollection);
      vm.projectsCollection = setProjectCollection(_.chain(vm.publicationCollection).keys().value());

      vm.menu = {
        opened: false,
        collection: [],
        open: open
      };

      validateButtonsForUrl($state.current);

      $rootScope.$emit('overlayselectionevent', vm.publicationSelected);
    }

    function validateButtonsForUrl(toState) {
      if (toState.name === 'main.landingpage') {
        vm.filtersAvailable = false;
        vm.goHomeAvailable = false;
      } else if (toState.name === 'main.usermanagementlist' || toState.name === 'main.newuser') {
        vm.goHomeAvailable = true;
      } else if (toState.name === 'main.fieldpage') {
        vm.filtersAvailable = false;
        vm.goHomeAvailable = true;
      } else if (toState.name === 'main.publicationpage') {
        vm.filtersAvailable = true;
        vm.goHomeAvailable = true;
      }
    }

    function selectPublication(evnt, pub) {
      vm.publicationSelected = mainService.getPubSelection(null, vm.projectPreselected, pub.pubId);
    }

    function setProjectCollection(keys) {
      return _.chain(configurationLoaderService.getConfig().projectLabels)
        .filter(function (item) {
          return _.chain(keys).some(function (key) { return item.id === key; }).value();
        }).value();
    }

    function getPublicationPreselection(pubCollections) {
      var pubCollection, lasts, keys;
      keys = _.chain(pubCollections).keys().value();

      if (vm.projectsCollection.length === 0) {
        vm.projectsCollection = keys;
      }

      if (!vm.projectPreselected || _.indexOf(keys, vm.projectPreselected) < 0) {
        vm.projectPreselected = keys[0];
      }

      return mainService.getPubSelection(pubCollections, vm.projectPreselected);
    }

    function open(value) {
      vm.menu.opened = value;
    }

    function logout() {
      vm.iframeSrc2 = "/visualwebPlus/logout.jsp";
      $timeout(function () {
        vm.iframeSrc = null;
        storageService.clear();
        $state.go('login');
      }, 600);
    }

    function closeFilter() {
      vm.filterOpened = false;
    }

    function onPublicationSelectionOverlayClose() {
      vm.filterOpened = false;
    }

    function openPublicationSelectionOverlay() {
      vm.filterOpened = !vm.filterOpened;
    }

    function selectProject(project) {
      vm.projectPreselected = project.id;
      init();
    }

    function projectSelectionEvent(evnt, obj) {
      vm.filtersAvailable = true;
      selectProject(obj);
    }

    function goBackHome() {
      $state.go('main.landingpage');
    }

    function idlePooling() {
      // console.log('Idle control started');
      var validationInterval = 60000; // tiempo entre validaciones en milisegundos 60000 = 1 minuto 
      idlePoolingPromise = $interval(idleValidation, validationInterval);
    }

    function idleValidation() {
      // console.log('Validacion Idle:', new Date);

      var actualTimeStamp,
        timeDiff;
      var idleTimeout = 900; // tiempo maximo calñcde inactividad mins*60 15*60= 900 => 10 minutos

      // vamos a guardar una fecha en el localstorage
      var lastResource = storageService.retrieve('lastResource');
      if (!lastResource) {
        actualTimeStamp = new Date();
        storageService.save('lastResource', actualTimeStamp.valueOf());
        return true;
      } else {
        // verificamos que el tiempo pasado desde la ultima peticion no supera el tiempo del idle
        actualTimeStamp = new Date();
        timeDiff = (actualTimeStamp.valueOf() - lastResource) / 1000;
        // console.log('Diff Idle:',timeDiff);
        if (timeDiff > idleTimeout) {
          logout();
        }
      }
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('loginService', loginService);

    loginService.inject = ['$http', 'moment', 'storageService', 'errorHandlerService', 'configurationLoaderService', '$q', 'globalHelpersService', 'filterService', 'filterViewConfigurationService', 'userHelperService', 'filterHelperService','mainService'];
    function loginService($http, moment, storageService, errorHandlerService, configurationLoaderService, $q, globalHelpersService, filterService, filterViewConfigurationService, userHelperService, filterHelperService,mainService) {
            var service = {
            loginFullWorkflow: loginFullWorkflow,
            loginFullWorkflowWithToken: loginFullWorkflowWithToken,
            getUser: getUser,
            setUser: setUser,
            getToken: getToken,
            getUserLanguage: getUserLanguage,
            setMomentLocale: setMomentLocale,
            hasUserRole: hasUserRole,
            hasNetworkRole: hasNetworkRole,
            setDateFormat: setDateFormat,
            saveToStorage: saveToStorage
        };

        var user;

        return service;

        /** private methods */
        function loginFullWorkflow(username, password) {
            return $q.when(clearLocalstorage())
                .then(function () { return login(username, password); })
                //.then(getUserInfo)
                .then(setLanguage)
                //.then(getFilter)
                //.then(postLoginOperations)
                //.catch(errorHandlerService.callbackError);
                .then(saveToStorage)
                .then(mainService.getPublicaciones);

        }

        function loginFullWorkflowWithToken(token) {
            return $q.when(clearLocalstorage())
                .then(configurationLoaderService.getRemoteConfig)
                .then(function () { return loginWithToken(token); })
                .then(getUserInfo)
                .then(setLanguage)
                .then(getFilter)
                .then(postLoginOperations)
                .then(saveToStorage)
                .catch(errorHandlerService.callbackError);
        }


        // login error
        function login(user, password) {
            return $http({
                method: 'POST',
                url: './api/auth/local',
                data: {
                    email: user,
                    password: password
                }
            });
        }

        function loginWithToken(token) {
            return $http({
                method: 'GET',
                url: './api/users/globalLoginByToken',
                params: {
                    token: token
                },
                transformResponse: $http.defaults.transformResponse.concat([transformProperties])
            });
        }

        // transforms hashmap from backend to object
        function transformProperties(data, header, status) {
            if (status >= 400 && data.message) {
                return data;
            }

            data.profile = _.reduce(data.properties, function (aggr, item, index) {
                var key = item.name,
                    value = item.value;

                aggr[key] = value;
                return aggr;
            }, {});

            return data;
        }

        // operations to do on user object before saving
        function postLoginOperations(data) {
            var user = data.user;
            var filter = data.filter;

            //register log of login
            registerLog(user);

            //register login in traffic control
            registerLoginTrafficControl(user);

            user.networkRoles = [];

            //Is HQ?
            if (filterHelperService.isHQ(filter)) {
                user.networkRoles.push('IS_HQ');
            }

            return user;
        }

        /**
         * clear localstorage
         * 
         * @returns
         */
        function clearLocalstorage() {
            return storageService.clear();
        }

        /**
         * save user to localStorage
         * 
         * @param {any} userData
         * @returns
         */
        function saveToStorage(userData) {
            user = userData;
            return storageService.save('user', user);
        }

        /**
         * register the success access into logs
         * 
         * @param {any} userData
         * @returns
         */
        function registerLog(userData) {
            user = userData;
            var userLogin = _.chain(userData.properties).filter({ name: 'LOGIN' }).value();

            return $http({
                method: 'GET',
                url: './api/users/log',
                params: {
                    token: userData.value,
                    user: userLogin[0].value,
                    projectCode: userData.userListExternalProjectName,
                    date: new Date()
                }
            });

        }

        /**
         * register login in traffic control
         * 
         * @param {any} userData
         * @returns
         */
        function registerLoginTrafficControl(userData) {
            user = userData;
            var path = 'login';

            return $http({
                method: 'POST',
                url: './api/controlTraffic/log',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                transformRequest: function (obj) {
                    var str = [];
                    for (var p in obj) {
                        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
                    }
                    return str.join('&');
                },
                params: {
                    token: userData.value
                },
                data: {
                    path: path
                }
            });
        }

        /**
         * getter user variable
         * 
         * @returns
         */
        function getUser() {
            return user;
        }

        function hasUserRole(role) {
            return _.chain(user.roles).find({ code: role }).some().value();
        }

        function hasNetworkRole(role) {
            return _.indexOf(user.networkRoles, role) > -1;
        }

        /**
         * setter user variable
         * 
         * @param {any} _user
         */
        function setUser(_user) {
            user = _user;
        }

        /**
         * getter for token
         * 
         * @returns
         */
        function getToken() {
            return user.value;
        }

        /**
         * getter for user language
         * 
         * @returns language
         */
        function getUserLanguage() {
            return user.profile.language;
        }

        /**
         * set momentjs locale
         * 
         * @param {any} localeCode
         * @returns
         */
        function setMomentLocale(localeCode) {
            return moment.locale(localeCode);
        }

        /**
         * Get userInfo
         * 
         * @param {any} user
         * @returns user
         */
        function getUserInfo(user) {
            return $http({
                method: 'get',
                url: './api/users/user',
                params: {
                    token: user.data.value,
                    user: user.data.profile.LOGIN,
                    projectCode: user.data.userListExternalProjectName
                },
                transformResponse: $http.defaults.transformResponse.concat([addUserInfo.bind(user.data)])
            });
        }

        /**
         * Get userInfo attributes and reformat from hashmap to object and include it in user to persist
         * 
         * @param {any} response from api
         * @returns user
         */
        function addUserInfo(data) {
            var user = this;
            var userInfoAttrObj = _.chain(data.attributes)
                .reduce(function (aggr, item, index) {
                    var key = item.userAttributeDefinition.attributeDefinition.name;
                    var value = item.value;
                    aggr[key] = value;
                    return aggr;
                }, {})
                .value();

            var userInfo = _.extend({}, data, { attrs: userInfoAttrObj });
            return _.extend({}, user, { userInfo: userInfo });
        }


        function setDateFormat(user) {
            return $http({ method: 'GET', url: './api/alerts/info/shortDateFormat', params: { token: user.value, languageCode: user.profile.language } })
                .then(function (data) {
                    if (!data.data || !data.data.response) {
                        return $q.when(user);
                    }
                    user.profile.dateLocaleFormat = data.data.response.toUpperCase();
                    return $q.when(user);
                })
                .catch(function () {
                    return $q.when(user);
                });
        }

        /**
         * Uses userinfo attributes to get language+variant and set moment locale
         * 
         * @param {any} user
         * @returns user
         */
        function setLanguage(userdata) {
            var user = userdata.data,
                lang = 'es',
                variant = null;

            user.profile = {};
            user.profile.language = variant ? lang.toLowerCase() + '_' + variant.toUpperCase() : lang.toLowerCase();

            // set moment.js locale to be able to format dates            
            setMomentLocale(user.profile.language);

            return user;
        }

        /**
         * Loading the filter to add 'position roles' to the
         * user (is HQ?, ...)
         */
        function getFilter(user) {
            storageService.save('user', user);

            var loginFilter = filterViewConfigurationService.getFilterDefinition('loginFilter');
            return filterService.getData(loginFilter, false, true, false)
                .then(function (filter) { return { user: user, filter: filter }; });
        }
    }
})();


(function () {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'login',
        resolve: {
          configuration: getConfiguration,
          transition: ['$timeout', function ($timeout) {
            return $timeout(function () { }, 3000);
          }]

        },
        public:true
      });
  }

  /* @ngInject */
  function getConfiguration(errorHandlerService, configurationLoaderService, $timeout, $q) {
    return $timeout(function () { errorHandlerService.log('log', 'Ended timeout'); }, 3000)
      .then(function () {
        return $q.all([configurationLoaderService.getRemoteConfig()]);
      })
      .then(function () {
        errorHandlerService.log('log', 'configuration loaded');
      })
      .catch(errorHandlerService.callbackError);
  }


})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('LoginController', LoginController);

  LoginController.$inject = ['errorHandlerService','loginService','$state','configurationLoaderService','storageService','filterService'];
  function LoginController(errorHandlerService,loginService,$state,configurationLoaderService,storageService,filterService) {

    errorHandlerService.log('log','Enter login Controller');

    var vm = this;
    vm.login = login;
    vm.errorMessage = '';
    vm.loading= false;

    //forgot password url
    vm.config = configurationLoaderService.getConfig();
    vm.forgotpass = '../userManagement/?project='+vm.config.project+'&context='+vm.config.context+'&return=/';

    // login('total','odec');
    /** private methodes */
    function login(username,password) {
      vm.loading = true;

      // the same cleaning as in logout just in case 
      // the user arrives to login page without doing
      // logout
      storageService.clear();
      filterService.clearContext();

      // full login workflow
      return loginService.loginFullWorkflow(username,password)
              .then(moveOnLogin)
              .catch(onAuthenticationError)
              .finally(function(){
                vm.loading = false;
              });
    }

    function moveOnLogin() {
      $state.go.apply(null,[vm.config.onAuthenticationState.url,vm.config.onAuthenticationState.state]);
    }

    function onAuthenticationError(error) {
      errorHandlerService.log('error',error);
      if (error.status === 401) {
        vm.errorMessage = 'Usuario o password inválidos';
      } else {
        vm.errorMessage = error.data && error.data.error || error.data && error.data.message || '';
      }      
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .factory('landingpageService', landingpageService);

  /** @ngInject */
  function landingpageService(configurationLoaderService, $http, storageService, $q) {

    var publicationGroupCollection = {
      data: [],
      selected: null
    };
    /** methods exposed */
    var service = {
      getPublicaciones: getPublicaciones,
      preventNonAuthorizedProjects: preventNonAuthorizedProjects
    };

    return service;

    /** private methods */

    function getPublicaciones() {
      return fetchPublicaciones()
        .then(preventNonAuthorizedProjects)
        .then(preparePublicationData)
        .then(sortPublicationData);
    }

    function fetchPublicaciones() {
      return $http({
        method: 'GET',
        url: '/api/publicaciones'
      });
    }

    function preventNonAuthorizedProjects(publications) {
      var publicationsAvailable = publications.data.data;

      var validPubs = _.chain(publicationsAvailable)
        .filter(function (pub) {
          return _.chain(configurationLoaderService.getConfig().allowedProjectIds).some(function (el) { return el === pub.projectId; }).value();
        })
        .value();

      if (!validPubs || validPubs.length <= 0) {
        return $q.reject({ data: { "name": "NotAllowed", "message": "User not allowed", "code": 402, "className": "not-authenticated", "errors": {} } });
      }

      return validPubs;
    }

    function preparePublicationData(publications) {
      return _.reduce(publications, function (aggr, item) {
        // console.log("// ==================================== //");
        // console.log(item.publicacionId);
        var info = (item.publicacionId).match(/(.*):(.*)::(.*)/);
        if (!(info[0] && info[1] && info[2] && info[3])) {
          console.warn('Parece que hay una publicacion mal formateada');
          return aggr;
        }

        var obj = {
          year: info[2],
          pubURL: item.publicacionUrl,
          pubId: info[3],
          pubLabel: item.publicacionLabel
        };

        var pubId = item.projectId;

        if (!aggr[pubId]) { aggr[pubId] = []; }

        var _yearSearch = _.find(aggr[pubId], { year: obj.year });
        if (_yearSearch) {
          _yearSearch.publications.push(obj);
        } else {
          aggr[pubId].push({
            year: obj.year,
            publications: [].concat(obj)
          });
        }
        // console.log(aggr);
        // console.log(length);
        // console.log(_.chain(aggr).map('publications').flatten().value().length);
        return aggr;

      }, {});
    }

    function sortPublicationData(pubCollection) {      
      return _.chain(pubCollection).keys().reduce(function(aggr,key){ aggr[key]=sortCollection(pubCollection[key]);return aggr;},{}).value();
    }

    function sortCollection(pubCollection) {
      var lasts = _.find(pubCollection, { year: "ULTIMOS DATOS" });
      if (!lasts) {
        return _.chain(pubCollection).orderBy(function (item) { return parseInt(item.year); }, ['desc']).value();
      }
      var lastsIndex = _.findIndex(pubCollection, { year: "ULTIMOS DATOS" });
      var restCollection = _.filter(pubCollection, function (item) { return item.year !== 'ULTIMOS DATOS'; });
      var sortedRestCollection = _.chain(restCollection).orderBy(function (item) { return parseInt(item.year); }, ['desc']).value();
      return [].concat(lasts, sortedRestCollection);
    }


  }
})();
(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];  
  function routerConfig($stateProvider) {
    $stateProvider
      .state('main.landingpage', {
        url: '/landingpage',
        templateUrl: 'app/landingpage/landingpage.html',
        controller: 'LandingpageController',
        controllerAs: 'landingpage',
        resolve:{
          timing: timing
        }
      });
  }

  timing.$inject = ['publicaciones','configuration'];
  function timing(publicaciones,configuration) {
    return true;
  }


})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('LandingpageController', LandingpageController);

  LandingpageController.$inject = ['$state','stateManagerService', 'userHelperService'];
  function LandingpageController($state,stateManagerService,userHelperService) {
    var vm = this;
    vm.onClickRedirect = onClickRedirect;
    vm.onClickField = onClickField;
    vm.publications = [];
    vm.hasAimcCat = false;
    vm.hasAimc = false;
    vm.hasField = false;


    init();



    /** private methods */

    function init() {
      var publicaciones = stateManagerService.getState('publications');
      var publicacionesKeys = _.keys(publicaciones);
      vm.hasAimc = _.indexOf(publicacionesKeys,'AIMC') > -1;
      vm.hasAimcCat = _.indexOf(publicacionesKeys,'AIMCCAT') > -1;
      var roles = userHelperService.getUser().data.roles && userHelperService.getUser().data.roles.split(',') || [];
      vm.hasField = _.indexOf(roles,'SEGUIMIENTO_CAMPO') > -1;
    }

    function onClickRedirect(param) {
      $state.go('main.publicationpage',{publicationId:param});
    }

    function onClickField() {
      $state.go('main.fieldpage');
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('waveFilterService', waveFilterService);

    /** @ngInject */
    function waveFilterService($http, userHelperService, $translate, filterHelperService,$filter,$q) {
        var service = {
            getFilter: getFilter,
            getWave:getWave,
            changeListener:function() {alert('wave');}
        };

        var context;

        return service;

        /** private methods */

        function getFilter(options) {
            context = this;
            if (!context.project) {
                return $q.when(null);
            }
            return getWave(options);
        }

        function getWave(options) {
            var params = {
                token: userHelperService.getToken(),
                project: filterHelperService.projectCodeManager(context.project, 'ESTU_NETWORK', 'ESTU_FRONT')
            };
            return $http({
                method: 'GET',
                url: './api/Entrevistas/getWaves',
                params: params,
                transformResponse: $http.defaults.transformResponse.concat([transformData.bind(options)])
            });
        }

        function transformData(data) {
            return {
                type:'select2',
                name: 'Wave',
                label: 'Wave',
                viewLabel: 'FILTER_WAVE',
                datos: _.map(angular.fromJson(data).response, function (item) {
                    return {
                        id: item.toString(),
                        text: $filter('waveToDate')(item.toString())
                    };
                }),
                selectedNode: this && this.notPreselected && !context.wave? null :createPreselections(data, context.wave),
                notRemovable: true
            };
        }

        function createPreselections(data, preselection) {
            var lastItem;
            if (preselection) {
                return preselection;
            }

            lastItem = _.last(data.response).toString();
            context.wave = lastItem.toString();
            return lastItem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('questionFilterService', questionFilterService);

    /** @ngInject */
    function questionFilterService($http, $translate, filterHelperService) {
        var service = {
            getFilter: getFilter,
            generateSelections:generateSelections,
            generateFilterInfo:generateFilterInfo
        };

        var context;

        return service;

        /** private methods */

        function getFilter(options) {
            context = this;
            return getQuestion(options);
        }

        function getQuestion(options) {
            var file = (options && options.file) || 'questionFilter.json';
            return $http({
                method: 'GET',
                url:'./data/' + file,
                transformResponse: $http.defaults.transformResponse.concat([transformData])
            });
        }

        function transformData(data) {
                               
            return {
                type:'select2',
                name: 'Question',
                label: 'Question',
                viewLabel: 'FILTER_QUESTION',
                datos: getDataByCountryandSurvey(data),
                selectedNode: createPreselections(data, context.question)
            };
        }

        /**
        ** Questions are different by country and survey selected
        **/
       function getDataByCountryandSurvey(data){
            //survey selected
            var survey = filterHelperService.projectCodeManager(context.project, 'ESTU_NETWORK', 'ESTU_FRONT').toLowerCase();
            //country selected
            var country='';

           //if country or below is selected
            if(filterHelperService.isCountrySelected(context._tmp))
            {
                country = filterHelperService.getCountrySelectedExternalId(context._tmp);
            }
            

           var dataFiltered =
                _.chain(data)
                .map(function (item) {
                    var indexOfSurvey = _.chain(item.surveys).indexOf(survey).value();
                    var indexOfCountry = -1;
                    //if array of countries is greater than 0 is because this is a country specific question, other case is Global question
                    if(item.countries.length > 0) {
                       indexOfCountry = _.chain(item.countries).indexOf(country).value();
                    }
                    else
                    {
                        indexOfCountry = 0;
                    } 

                    //if the question exists for the survey, such as global or country specific, then, add item
                    if(indexOfSurvey >= 0 && indexOfCountry >= 0) {
                        return {
                            id: item.id,
                            text: $translate.instant(item.text+"_"+survey+"_"+"LABEL"),
                            visible:true
                        };
                    }
                    else {
                        return{
                            visible:false
                        };
                    }
                })
                .filter({visible: true}).value();
           
           //return only visible items
           return dataFiltered;
       }

        function createPreselections(data, preselection) {
            var first;
            if (preselection) {
                return preselection;
            }

            first = data[0].id;
            context.question = first;
            return first;
        }

        function generateSelections(data) {
            var selection = _.reduce(data.data,function(aggr,item){
                var nodeSelected = _.find(item.datos,{id:item.selectedNode});
                if(!nodeSelected) {
                    nodeSelected =  {
                        id:null,
                        text:null
                    };    
                }
                nodeSelected.label = item.label;
                nodeSelected.viewLabel = item.viewLabel;
                nodeSelected.eventId = item.eventId;
                aggr.push(nodeSelected);
                return aggr;
            },[]);

            data.selection = selection;
            return data;
        }

        function generateFilterInfo(data) {
            data.filterInfo = data.selection;
            return data;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('projectFilterService', projectFilterService);

    /** @ngInject */
    function projectFilterService($http, userHelperService,$translate,configurationLoaderService,filterHelperService) {
        var service = {
            getFilter: getFilter,
            generateSelections:generateSelections,
            generateFilterInfo:generateFilterInfo,
            changeListener:function() {alert('project');}
        };

        var context;

        return service;

        /** private methods */

        function getFilter(options) {
            context = this;
            return getProject(options);        
        }

        function getProject(options) {
            var params = {
                token: userHelperService.getToken(),
                context: context.context || configurationLoaderService.getConfig().context
            };
            return $http({
                method: 'GET',
                url: './api/Entrevistas/projectsByContext',
                params: params,
                transformResponse: $http.defaults.transformResponse.concat([transformData.bind(options)])
            });
        }

        function transformData(data) {
            var that = this;
            
            var filteredProjects = data.response;

            if(that && that.filter)
            {
                filteredProjects = filterProjects(data, that.filter);
            }

            return {
                type:'select2',
                name: 'Project',
                label: 'Survey',
                viewLabel: 'FILTER_SURVEY',
                allowClear: this && this.allowClear || false,
                datos: _.map(filteredProjects, function (item) {
                    return {
                        id: item.globalNetworkName,
                        text: $translate.instant(item.label)
                    };
                }),
                selectedNode: this && this.notPreselected && !context.project? null:createPreselections(data,context.project)
            };
        }

        function createPreselections(data,preselection) {
            if (preselection) {
                return preselection;
            }

            context.project = data.response[0].globalNetworkName;
            return data.response[0].globalNetworkName;
        }

        function generateSelections(data) {
            var selection = _.reduce(data.data,function(aggr,item){
                var nodeSelected;

                if (item.selectedNode) {
                    nodeSelected = _.find(item.datos,{id:item.selectedNode.toString()});    
                } else {
                    return aggr;
                }

                nodeSelected.label = item.label;
                nodeSelected.viewLabel = item.viewLabel;
                nodeSelected.eventId = item.eventId;
                aggr.push(nodeSelected);
                return aggr;
            },[]);

            data.selection = selection;
            return data;
        }

        function generateFilterInfo(data) {
            data.filterInfo = data.selection;
            return data;
        }

        function filterProjects(projects, filter) {
            var filteredProjects = projects;
            if(filteredProjects && filteredProjects.response){
               filteredProjects= 
               _.chain(filteredProjects.response)
                .filter(function (item) {
                    var isProjectVisible = filterHelperService.projectCodeManager(item.globalNetworkName, 'ESTU_NETWORK', filter);
                    if(isProjectVisible) {
                        return true;
                    }
                    return false;
                })
                .value();
            }
            return filteredProjects;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('periodFilterService', periodFilterService);

    /** @ngInject */
    function periodFilterService($http, filterHelperService) {
        var service = {
            getFilter: getFilter,
            generateSelections:generateSelections,
            generateFilterInfo:generateFilterInfo
        };

        var context;

        return service;

        /** private methods */

        function getFilter(options) {
            context = this;
            return getPeriod(options);
        }

        function getPeriod(options) {
            var file = (options && options.file) || 'periodFilter.json';
            return $http({
                method: 'GET',
                url:'./data/' + file,
                transformResponse: $http.defaults.transformResponse.concat([transformData])
            });
        }

        function transformData(data) {
            return {
                type:'select2',
                name: 'Period',
                label: 'Period',
                viewLabel: 'FILTER_Period',
                datos: data,
                selectedNode: createPreselections(data, context.period)
            };
        }

        function createPreselections(data, preselection) {
            var first;
            if (preselection) {
                return preselection;
            }

            var estuPeriod = filterHelperService.projectCodeManager(context.project, 'ESTU_NETWORK', 'ESTU_PERIOD');
            var periodPreselected = _.chain(data).filter({id: estuPeriod}).value();

            first = periodPreselected[0].id;
            context.period = first;
            return first;
        }

        function generateSelections(data) {
            var selection = _.reduce(data.data,function(aggr,item){
                var nodeSelected = _.find(item.datos,{id:item.selectedNode});
                if(!nodeSelected) {
                    nodeSelected =  {
                        id:null,
                        text:null
                    };    
                }
                nodeSelected.label = item.label;
                nodeSelected.viewLabel = item.viewLabel;
                nodeSelected.eventId = item.eventId;
                aggr.push(nodeSelected);
                return aggr;
            },[]);

            data.selection = selection;
            return data;
        }

        function generateFilterInfo(data) {
            data.filterInfo = data.selection;
            return data;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('networkFilterService', networkFilterService);

    /** @ngInject */
    function networkFilterService($http, userHelperService, $translate, filterHelperService, $filter, errorHandlerService,$q) {
        var service = {
            getFilter: getFilter,
            generateSelections:generateSelections,
            generateFilterInfo:generateFilterInfo,
            changeListener:function() {alert('network');}
        };

        var context;

        return service;

        /** private methods */

        /**
         * options
         * 
         * notPreselected: Avoid set a value by default
         * waveNullable: Allow to get data even when there is no wave selected
         */
        function getFilter(options) {
            context = this;
            return getNetwork(options);
        }

        function getNetwork(options) {
            var waveNullable =  options && options.waveNullable; 
            if (!context.project || (!context.wave && !waveNullable)) {
                return $q.when(null);
            }

            //If we have a context (user admin so far) we need to do an special 
            //call in order to get the data from other contexsts 
            var networkUrl = context.context ? './api/Entrevistas/getListContext/' : './api/Entrevistas/getList/'; 

            var params = {
                token: userHelperService.getToken(),
                referenceDate: context.wave && $filter('waveToFullDate')(context.wave.toString()),
                selectedIds: context.network,
                context: context.context ||  null 
            };
            
            return $http({
                method: 'GET',
                url: networkUrl + context.project,
                params: params,
                transformResponse: $http.defaults.transformResponse.concat([transformData.bind(options)])
            });
        }

        function transformData(data) {
            var selectedId;
            if (data.error || !data.response || data.response.length < 1) {
                errorHandlerService.log('error', 'networkFilterService::transformData -> no response');
                return null;
            }
            
            selectedId = getLastSelected(data.response);
            
            if (selectedId) {
                context.network = selectedId;
            }

            return _.map(data.response, fnTransformation);
        }

        function fnTransformation(networkItem) {
            return {
                type: 'select2',
                name: networkItem.name,
                label: networkItem.name.toUpperCase(),
                viewLabel: networkItem.name,
                allowClear: true,
                hide: false,
                datos: _.map(networkItem.nodes, function (comboItem) {
                    return {
                        id: comboItem.id,
                        text: comboItem.label,
                        externalId: comboItem.externalId,
                        selected: comboItem.selected
                    };
                }),
                selectedNode: networkItem.selectedNode
            };
        }

        function generateSelections(data) {
            var selection = _.reduce(data.data,function(aggr,item){
                var nodeSelected = _.find(item.datos,{id:item.selectedNode});
                if(!nodeSelected) {
                    nodeSelected =  {
                        id:null,
                        text:null
                    };    
                }
                nodeSelected.label = item.label;
                nodeSelected.viewLabel = item.viewLabel;
                nodeSelected.eventId = item.eventId;
                aggr.push(nodeSelected);
                return aggr;
            },[]);

            data.selection = selection;
            return data;
        }

        function generateFilterInfo(data) {
            data.filterInfo = _.chain(data.selection)
                .filter(function (item) {
                    return item.id !== null;
                })
                .last()
                .value();
            return data;
        }

        function getLastSelected(data) {
            return _.chain(data)
                .map('selectedNode')
                .filter(function(item){ return item !== null;})
                .last()
                .value();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('levelFilterService', levelFilterService);

    /** @ngInject */
    function levelFilterService($http, userHelperService, $translate, $q, filterHelperService) {
        var service = {
            getFilter: getFilter,
            generateSelections:generateSelections,
            generateFilterInfo:generateFilterInfo
        };

        var context;

        return service;

        /** private methods */

        /**
         * options
         * 
         * notPreselected: Avoid set a value by default
         * waveNullable: Allow to get data even when there is no wave selected
         */
        function getFilter(options) {
            context = this;
            return getLevels(options);
        }

        function getLevels(options) {
            var waveNullable =  options && options.waveNullable; 
            if (!context.project || !context.network || (!context.wave && !waveNullable)) {
                return $q.when(null);
            }

            //If we have a context (user admin so far) we need to do an special 
            //call in order to get the data from other contexsts 
            var networkUrl = context.context ? './api/Entrevistas/getOwnLevelsContext' : './api/Entrevistas/getOwnLevels'; 

            var params = {
                token: userHelperService.getToken(),
                nodeId: context.network,
                project: filterHelperService.projectCodeManager(context.project, 'ESTU_NETWORK', 'ESTU_FRONT'),
                wave: context.wave || null,
                elements: 1,
                includeOwn: true,
                context: context.context || null

            };
            
            return $http({
                method: 'GET',
                url: networkUrl,
                params: params,
                transformResponse: $http.defaults.transformResponse.concat([transformData.bind(options)])
            });
        }

        function transformData(data) {
            return {
                type:'select2',
                name: 'Level',
                label: 'Level',
                viewLabel: 'FILTER_LEVEL',
                allowClear: true,
                datos: _.map(data.response, function (item) {
                    return {
                        id: item.name,
                        text: item.name
                    };
                }),
                selectedNode: this && this.notPreselected && !context.level ? null : createPreselections(data, context.level)
            };
        }

        function createPreselections(data, preselection) {
            if (preselection) {
                return preselection;
            }

            //Save the selection
            context.level = data.response[0].name;
            //We do not want to be preselected by default
            return null;
        }

        function generateSelections(data) {
            var selection = _.reduce(data.data, function(aggr,item){
                var nodeSelected = _.find(item.datos,{id:item.selectedNode});
                if(!nodeSelected) {
                    nodeSelected =  {
                        id:null,
                        text:null
                    };    
                }
                nodeSelected.label = item.label;
                nodeSelected.viewLabel = item.viewLabel;
                nodeSelected.eventId = item.eventId;
                aggr.push(nodeSelected);
                return aggr;
            },[]);
            
            //If all selection values are null we do not want to display the pill
            data.selection = _.every(selection, {id: null}) ? null : selection;
            return data;
        }

        function generateFilterInfo(data) {
            data.filterInfo = data.selection;
            return data;
        }

    }
})();
(function () {
  'use strict';

  /** Module used to manage the configuration for the filter for each view */
  angular
    .module('app')
    .factory('filterViewConfigurationService', filterViewConfigurationService);

  filterViewConfigurationService.$inject = ['projectFilterService', 'waveFilterService', 'networkFilterService', 'contextFilterService', 'levelFilterService', 'periodFilterService','questionFilterService'];
  function filterViewConfigurationService (projectFilterService, waveFilterService, networkFilterService, contextFilterService, levelFilterService, periodFilterService, questionFilterService) {
    var service = {
      getFilterDefinition: getFilterDefinition
    };

    var configs = {
      interviewListFilter: [{
        group: { id: 'project', label: 'FILTER_SURVEY', viewLabel: 'FILTER_SURVEY_WAVE', setSelection: projectFilterService.generateSelections, setFilterInfo: projectFilterService.generateFilterInfo },
        sources: [
          { eventId: 'project', method: projectFilterService, args: [], deps: [], resetContext: ['wave','network'] },
          { eventId: 'wave', method: waveFilterService, args: [], deps: ['project'] }
        ]
      }, {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [], deps: ['project', 'wave'], alwaysReprocess: true }
        ]
      }],
      dashboardFilter: [{
        group: { id: 'project', label: 'FILTER_SURVEY', viewLabel: 'FILTER_SURVEY_WAVE', setSelection: projectFilterService.generateSelections, setFilterInfo: projectFilterService.generateFilterInfo },
        sources: [
          { eventId: 'project', method: projectFilterService, args: [], deps: [], resetContext: ['wave','network','period'] },
          { eventId: 'wave', method: waveFilterService, args: [], deps: ['project'] }
        ]
      }, {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [], deps: ['project', 'wave'], alwaysReprocess: true }
        ]
      }, {
        group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD_group', setSelection: periodFilterService.generateSelections, setFilterInfo: periodFilterService.generateFilterInfo },
        sources: [
          { eventId: 'period', method: periodFilterService, args: [], deps: ['project', 'wave','network']}
        ]
      }],      
      userManagementFilter: [{
        group: { id: 'context', label: 'FILTER_CONTEXT', viewLabel: 'FILTER_CONTEXT', setSelection: contextFilterService.generateSelections, setFilterInfo: contextFilterService.generateFilterInfo },
        sources: [
          { eventId: 'context', method: contextFilterService, args: [], deps: [], resetContext: ['project', 'network', 'level'] }
        ]
      },{
        group: { id: 'project', label: 'FILTER_SURVEY', viewLabel: 'FILTER_SURVEY', setSelection: projectFilterService.generateSelections, setFilterInfo: projectFilterService.generateFilterInfo },
        sources: [
          { eventId: 'project', method: projectFilterService, args: [{notPreselected:true, allowClear: true}], deps: ['context'] }
        ]
      }, {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [{notPreselected:true, waveNullable: true}], deps: ['context','project'], alwaysReprocess: true }
        ]
      }, {
        group: { id: 'level', label: 'FILTER_LEVEL', viewLabel: 'FILTER_LEVEL', setSelection: levelFilterService.generateSelections, setFilterInfo: levelFilterService.generateFilterInfo },
        sources: [
          { eventId: 'level', method: levelFilterService, args: [{notPreselected:true, waveNullable: true}], deps: ['context', 'project', 'network'] }
        ]
      }],
      networkFilter: [ {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [{waveNullable: true}], deps: [], alwaysReprocess: true }
        ]
      }],
      trendingTopicsFilter: [{
        group: { id: 'project', label: 'FILTER_SURVEY', viewLabel: 'FILTER_SURVEY_WAVE', setSelection: projectFilterService.generateSelections, setFilterInfo: projectFilterService.generateFilterInfo },
        sources: [
            { eventId: 'project', method: projectFilterService, args: [], deps: [], resetContext: ['wave','network','period'] },
            { eventId: 'wave', method: waveFilterService, args: [], deps: ['project'] }
        ]}, {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [], deps: ['project', 'wave'], alwaysReprocess: true }
        ]}, {
        group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD_group', setSelection: periodFilterService.generateSelections, setFilterInfo: periodFilterService.generateFilterInfo },
        sources: [
          { eventId: 'period', method: periodFilterService, args: [{file: 'periodFilter_TextAnalytics.json'}], deps: ['project'] }
        ]}
      ],
      searchVerbatimsFilter: [{
        group: { id: 'project', label: 'FILTER_SURVEY', viewLabel: 'FILTER_SURVEY_WAVE', setSelection: projectFilterService.generateSelections, setFilterInfo: projectFilterService.generateFilterInfo },
        sources: [
            { eventId: 'project', method: projectFilterService, args: [], deps: [], resetContext: ['wave','network','period','question'] },
            { eventId: 'wave', method: waveFilterService, args: [], deps: ['project'] }
        ]}, {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [], deps: ['project', 'wave'], resetContext: ['question'], alwaysReprocess: true }
        ]}, {
        group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD_group', setSelection: periodFilterService.generateSelections, setFilterInfo: periodFilterService.generateFilterInfo },
        sources: [
          { eventId: 'period', method: periodFilterService, args: [{file: 'periodFilter_TextAnalytics.json'}], deps: ['project'] }
        ]}, {
        group: { id: 'question', label: 'FILTER_QUESTION', viewLabel: 'FILTER_QUESTION', setSelection: questionFilterService.generateSelections, setFilterInfo: questionFilterService.generateFilterInfo },
        sources: [
          { eventId: 'question', method: questionFilterService, args: [{file: 'questionFilter.json'}], deps: ['project', 'network'] }
        ]}
      ],
      //We use it only to get information about the user when login (loginService --> 'getFilter')
      loginFilter: [{
        group: { id: 'project', label: 'FILTER_SURVEY', viewLabel: 'FILTER_SURVEY_WAVE', setSelection: projectFilterService.generateSelections, setFilterInfo: projectFilterService.generateFilterInfo },
        sources: [
            { eventId: 'project', method: projectFilterService, args: [], deps: [], resetContext: ['wave','network'] },
            { eventId: 'wave', method: waveFilterService, args: [], deps: ['project'] }
        ]}, {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [], deps: ['project', 'wave'], alwaysReprocess: true }
        ]}
      ],
      offlineReportsFilter: [{
        group: { id: 'project', label: 'FILTER_SURVEY', viewLabel: 'FILTER_SURVEY_WAVE', setSelection: projectFilterService.generateSelections, setFilterInfo: projectFilterService.generateFilterInfo },
        sources: [
            { eventId: 'project', method: projectFilterService, args: [{filter: 'ESTU_OFFLINE_REPORTS'}], deps: [], resetContext: ['wave','network'] },
            { eventId: 'wave', method: waveFilterService, args: [], deps: ['project'] }
        ]}, {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [], deps: ['project', 'wave'], alwaysReprocess: true }
        ]}
      ]
    };

    return service;

    /** private function */

    function getFilterDefinition(id) { 
        return configs[id];
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('contextFilterService', contextFilterService);

    /** @ngInject */
    function contextFilterService($http, userHelperService, $translate, configurationLoaderService) {
        var service = {
            getFilter: getFilter,
            generateSelections:generateSelections,
            generateFilterInfo:generateFilterInfo
        };

        var context;

        return service;

        /** private methods */

        function getFilter() {
            context = this;
            return getContext();
        }

        function getContext() {
            var params = {
                token: userHelperService.getToken()
            };
            return $http({
                method: 'GET',
                url:'./api/users/contextsListByAdmin',
                params: params,
                transformResponse: $http.defaults.transformResponse.concat([transformData])
            });
        }

        function transformData(data) {
            return {
                type:'select2',
                name: 'Context',
                label: 'Context',
                viewLabel: 'FILTER_CONTEXT',
                datos: _.map(data, function (item) {
                    return {
                        id: item.code,
                        text: $translate.instant(item.name)
                    };
                }),
                selectedNode: createPreselections(data, context.context)
            };
        }

        function createPreselections(data, preselection) {
            var first;
            if (preselection) {
                return preselection;
            }

            //We select by default the active context in the config.json
            context.context = configurationLoaderService.getConfig().context || data[0].code;

            return context.context;
        }

        function generateSelections(data) {
            var selection = _.reduce(data.data, function(aggr,item){
                var nodeSelected = _.find(item.datos,{id:item.selectedNode.toString()});
                nodeSelected.label = item.label;
                nodeSelected.viewLabel = item.viewLabel;
                nodeSelected.eventId = item.eventId;
                aggr.push(nodeSelected);
                return aggr;
            },[]);

            data.selection = selection;
            return data;
        }

        function generateFilterInfo(data) {
            data.filterInfo = data.selection;
            return data;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('windowResizeManagerService', windowResizeManagerService);

    windowResizeManagerService.$inject = ['$window','lodash','$rootScope','$log'];
    function windowResizeManagerService($window,lodash,$rootScope,$log) {
        var size = [];
        var service = {
            startListening: startListening,
            getWindowSize: getWindowSize
        };

        return service;

        /** private methods */
        function getWindowSize() {
            return size;
        }

        function onResize(event) {
            size[0] = $window.innerWidth;
            size[1] = $window.innerHeight;
            $log.log('resize',size);
            $rootScope.$emit('window.resize',{size:size});
        }

        function startListening() {
            size[0] = $window.innerWidth;
            size[1] = $window.innerHeight;

            angular.element($window).bind('resize', lodash.debounce(onResize,600));
            $log.log(size);
            return size;
        }


    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('widgetLoaderService', widgetLoaderService);

    widgetLoaderService.$inject = ['$http', '$q', 'propertybagHandlerService', 'errorHandlerService', 'stateManagerService', 'configurationLoaderService', 'alertshelperService'];
    function widgetLoaderService($http, $q, propertybagHandlerService, errorHandlerService, stateManagerService, configurationLoaderService, alertshelperService) {
        var service = {
            getData: getData,
            getDataSettings:getDataSettings
        };

        return service;

        // private methods

        // main entrance point
        function getData() {
            return $q.all([getWidgetDefinition(), getPropertyBag()])
                .then(spread)
                .then(setNodes)
                .then(postOperations)
                .then(resolveBodyRequest)
                .catch(errorHandlerService.callbackError);

        }

        function getDataSettings() {
            return $q.all([getWidgetDefinition(), getPropertyBag()])
                .then(spread)
                .then(setNodes)
                .then(postOperations)
                .then(resolveSettingsData)
                .catch(errorHandlerService.callbackError);
        }

        // get widget configuration
        function getWidgetDefinition() {
            return $http({
                method: 'GET',
                url: './data/widgetDefinition.json'
            })
                .then(function (data) {
                    return data && data.data;
                });
        }

        function postOperations(data) {
              data.widgetDefinition = _
              .chain(data.widgetDefinition)
              .map(function (item){
                if (item && item.type && item.type === 'odec-widget-alerts') {
                  item.widgetAvailable = alertshelperService.allowed(item.project);
                }
                return item;
              })
              .value();

              return data;
        }

        // get propertyBag
        function getPropertyBag() {
            return propertybagHandlerService.getData('widgetConfig')
                .then(function (data) {
                    return data && data.data;
                });
        }

        function spread(data) {
            return _.zipObject(['widgetDefinition', 'propertyBag'], data);
        }

        // add node information to payload
        function setNodes(data) {
            var settingsNodes;

            settingsNodes = _.chain(stateManagerService.getState('userInfo'))
                .extend()
                .reduce(nodesReducer, {})
                .value();

            data.widgetDefinition = _.chain(data.widgetDefinition)
                .map(function (item) {

                    if (!settingsNodes[item.project.toUpperCase()]){
                        return item;
                    }

                    if (data.propertyBag) {
                        item.attributes.visible =_.isUndefined(data.propertyBag[item.id])? item.attributes.visible : data.propertyBag[item.id];
                    }

                    // if widgetdefinition has concept level (HQ/COUNTRY) verify charge property on nodes in
                    // settings. Only if both are the same add node definition to the widget
                    if (item.level) {
                        if (item.level.toUpperCase() === settingsNodes[item.project.toUpperCase()].charge.toUpperCase()) {
                            item.nodeId = settingsNodes[item.project.toUpperCase()].id;
                            item.attributes.node = settingsNodes[item.project.toUpperCase()].code;
                        }
                        return item;
                    }


                    // if no level defined add node definition
                    item.nodeId = settingsNodes[item.project.toUpperCase()].id;
                    item.attributes.node = settingsNodes[item.project.toUpperCase()].externalID;
                    
                    return item;
                })
                .value();

            return data;
        }

        function nodesReducer(aggr, item, index) {

            if (!item.selectedNode) {
                throw ('widgetLoaderService::nodesReducer -> No selected Node');
            }

            // get all node info
            var info = _.chain(item.nodes)
                .find({ externalID: item.selectedNode })
                .value();

            if (!info) {
                throw ('widgetLoaderService::nodesReducer -> Selectedid not found in nodes');
            }

            // add HQ or COUNTRY
            info.charge = _.chain(configurationLoaderService.getConfig().HQLevels)
                .intersection([info.level.toUpperCase()])
                .some()
                .value() ?
                'HQ' :
                'COUNTRY';

            // add project
            aggr[item.project] = info;

            return aggr;
        }

        function resolveBodyRequest(data) {
            return _.chain(data.widgetDefinition)
                .filter(function (item) {
                    return item.nodeId && item.widgetAvailable && item.attributes.visible;
                })
                .value();
        }

        function resolveSettingsData(data) {
            return _.chain(data.widgetDefinition)
                .filter(function (item) {
                    return item.nodeId && item.widgetAvailable;
                })
                .value();
        }

    }
})();
(function() {
'use strict';

    angular
        .module('app')
        .factory('userHelperService', userHelperService);

     /** @ngInject */
    function userHelperService(storageService) {
        var user;
        var service = {
            getToken: getToken,
            getUserLanguage: getUserLanguage,
            getUser: getUser
        };
        
        return service;

        ////////////////
        /**
         * Getting the user context
         */
        function getToken() {
            return service.getUser().value;
        }   

        /**
         * Gettint the user lenguage
         */
        function getUserLanguage() {
            return service.getUser().profile.language;
        }

        function getUser(){
            return storageService.retrieve('user');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('translationManagerService', translationManagerService);

    /* @ngInject */
    function translationManagerService() {
        var modules;
        
        var service = {
            getModules: getModules
        };

        modules = [
            { project: 'CEMAUDI', module: 'WEB_INTERVIEWLIST' },            
            { project: 'CEMAUDI', module: 'WEB_MAIN' },
            { project: 'CEMAUDI', module: 'WEB_INTERVIEW' },
            { project: 'CEMAUDI', module: 'WEB_FILTER' },
            { project: 'CEMAUDI', module: 'WEB_COCKPIT' },
            { project: 'CEMAUDI', module: 'WEB_SETTINGS' },
            { project: 'CEMAUDI', module: 'WEB_ADMIN' },
            { project: 'CEMAUDI', module: 'WEB_STANDARD_REPOSITORY' },
            { project: 'CEMAUDI', module: 'WEB_TEXT_ANALYTICS' },
            { project: 'CEMAUDI', module: 'WEB_DASHBOARD' },
            { project: 'CEMAUDI', module: 'WEB_SNAPSHOTS' },
            { project: 'CEMAUDI', module: 'WEB_NEWS' },
            { project: 'CEMAUDI', module: 'WEB_OFFLINE_REPORTS'},
            { project: 'CEMAUDI', module: 'WEB_ALERTS'},
            { project: 'CEMAUDI', module: 'WEB_HOTLINE'}
        ];

        return service;

        /* private methods */

        function getModules() { 
            return modules;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .service('storageService', storageService);

    storageService.$inject = ['$cookies'];
    function storageService($cookies) {
        
        /** public methods */

        this.save = save;
        this.retrieve = retrieve;
        this.remove = remove;
        this.clear = clear;

        /** private methods */

        function save(property, data) {
            if (localStorage) {
                localStorage.setItem(property, angular.toJson(data));
            } else {
                $cookies.put(property, angular.toJson(data));
            }
        }

        function retrieve(property) {
            if (localStorage) {
                return angular.fromJson(localStorage.getItem(property));
            } else {
                return angular.fromJson($cookies.get(property));
            }
        }

        function remove(property) {
            if (localStorage) {
                localStorage.removeItem(property);
            } else {
                $cookies.remove(property);
            }
        }

        function clear() {
            if (localStorage) {
                localStorage.clear();
            } else {
                var cookies = $cookies.getAll();
                angular.forEach(cookies, function (v, k) {
                    $cookies.remove(k);
                });
            }
        }

    }
})();
(function() {
'use strict';

    angular
        .module('app.core')
        .factory('stateManagerService', stateManagerService);

    //stateManagerService.$inject = [''];
    function stateManagerService() {
        var service = {
            getState:getState,
            setState:setState
        };

        var atomicState = {};
        
        return service;

        /** private methods */
        function getState(key) { 
            if (!key) {
                throw('stateManagerService::setState -> No key provided');
            }

            return angular.copy(atomicState[key]); 
        }

        function setState(key,state) {
            var _key,_state;
            // context parameters (state)
            if (this && this.prop) {
                _key = this.prop;
                _state = key;
            } else {
                _key = key;
                _state = state;
            }

            if (!_key) {
                throw('stateManagerService::setState -> No key provided');
            }

            return atomicState[_key] = _state;
        }
    }
})();
/*eslint angular/on-watch:0 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .service('routingService', routingService);

    routingService.$inject = ['$rootScope', '$log', 'storageService', 'loginService', '$state', '$window', '$q', '$urlRouter'];
    function routingService($rootScope, $log, storageService, loginService, $state, $window, $q, $urlRouter) {

        this.registerCallbacks = registerCallbacks;
        this.startTransitionHook = startTransitionHook;
        this.getLastState = getLastState;

        var lastState = null;
            

        /** private methods */

        function registerCallbacks() {
            $rootScope.$on('$stateChangeStart', startTransitionHook);
            $rootScope.$on('$stateChangeSuccess', successTransitionHook);
            $rootScope.$on('$stateChangeError', changeErroTransitionHook);
            $rootScope.$on('$stateNotFound', stateNotFoundTransitionHook);
        }

        function startTransitionHook(event, toState, toParams, fromState, fromParams) {
            $rootScope.$emit('transition:start');


            var urlHash = $window.location.hash.match(/[\?\&]token.*$/);
            var token, tokenInspection;
            var destinyUrl;


            var user, userStored;

            // there are two posibilities:
            // - has a token at the end of the urls -> means it's a loginByToken
            // - has no token at the end of the urls -> it's a refresh or an url change
            if (!urlHash) {
                // has no token, try to retrieve user info from localstorage
                user = loginService.getUser();

                // login state is always public...
                if (toState.public || toState.name === 'login') {
                    return;
                }

                if (!user) {
                    // if not auth restore from localstorage
                    userStored = storageService.retrieve('user');
                } else {
                    // if is authenticated then go on
                    return;
                }

                if (userStored) {
                    loginService.setUser(userStored);
                    loginService.setMomentLocale(userStored.profile.language);
                    // proceed
                } else {
                    // go to login
                    if (fromState.name === 'login') {
                        // do nothing, let it go...
                    } else {
                        event.preventDefault();
                        $state.go('login');
                    }

                    
                }
            } else {
                event.preventDefault();

                destinyUrl = $window.location.hash.replace(/[\?\&]token.*$/, '');
                tokenInspection = urlHash[0].match(/\=.*$/);

                if (!tokenInspection || tokenInspection.length === 0) {
                    $state.go('login');
                    return;
                }

                token = tokenInspection[0].replace('=', '');

                return loginService.loginFullWorkflowWithToken(token)
                    .then(function () {
                        setTimeout(function() {
                            $window.location.replace(destinyUrl);    
                        }, 0);
                        
                    })
                    .catch(function () {
                        console.error('User invalid');
                        setTimeout(function() {
                            $window.location.replace('#/login');    
                            $window.location.reload();
                        }, 0);
                    });
            }





        }
        function successTransitionHook(event, toState, toParams, fromState, fromParams) {
            $rootScope.$emit('transition:end');
            
            $rootScope.$emit('breadcrumb:toState', { toState: toState, toParams: toParams });
            if(fromState.name && fromState.name.length >0){
                lastState = { state: fromState, params: fromParams };
                storageService.save('lastState', lastState);
            }
            //$log.warn('Succeded transitioning to:', event, toState, toParams, fromState, fromParams);
        }
        function changeErroTransitionHook(event, toState, toParams, fromState, fromParams, error) {
            $rootScope.$emit('transition:end');
            $log.warn('Error transitioning to:', event, toState, toParams, fromState, fromParams, error);
        }
        function stateNotFoundTransitionHook(event, unfoundState, fromState, fromParams) {
            $rootScope.$emit('transition:end');
            $log.warn('State not found:', event, unfoundState, fromState, fromParams);
        }

        function getLastState() {
            if (!lastState) {
                lastState = storageService.retrieve('lastState');
            }

            if (!lastState || !lastState.state.name) {
                return { state: 'login', params: null };
            }

            return lastState;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('propertybagHandlerService', propertybagHandlerService);

    propertybagHandlerService.$inject = ['loginService', 'configurationLoaderService', '$http', 'errorHandlerService', '$q', 'globalHelpersService'];
    function propertybagHandlerService(loginService, configurationLoaderService, $http, errorHandlerService, $q, globalHelpersService) {
        var service = {
            getData: getData,
            setData: setData,
            restoreDefault:restoreDefault
        };

        return service;

        // private methodes

        function getData(storeName) {
            return $http({
                method: 'GET',
                url: './api/propertiesBag',
                params: {
                    token: loginService.getToken(),
                    project: configurationLoaderService.getConfig().project,
                    storeName: storeName,
                    date: new Date()
                },
                transformResponse: [transformProperties].concat($http.defaults.transformResponse)
            })
                .then(fnAccept)
                .catch(fnError);
        }

        function setData(store, value) {
            return $http({
                method: 'POST',
                url: './api/propertiesBag',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                params: {
                    token: loginService.getToken(),
                    project: configurationLoaderService.getConfig().project,
                    storeName: store
                },
                data: {
                    content:angular.toJson(value)
                },
                transformRequest: globalHelpersService.httpPostParamsPrepare
            });
        }

        function restoreDefault(store) {
            return $http({
                method: 'DELETE',
                url: './api/propertiesBag',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                params: {
                    token: loginService.getToken(),
                    project: configurationLoaderService.getConfig().project,
                    storeName: store
                }
            });
        }

        function fnAccept(data) {
            return $q.resolve(data);
        }

        function fnError(error) {
            //errorHandlerService.warn(error);
            return $q.resolve(null);
        }

        function transformProperties(data, header, status) {
            if (status >= 400) {
                return { error: data };
            }

            return data;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('i18nService', i18nService);

    i18nService.inject = ['loginService', '$http', '$q', 'translationManagerService'];

    function i18nService(loginService, $http, $q, translationManagerService) {
        var lang, variante;
        return translationHelper;

        function translationHelper(options) {
            var deferred = $q.defer();

            /* Obtenemos la lista de modulos a cargar */
            var seccion =translationManagerService.getModules();

            if (options.key.indexOf('_') !== -1) {
                lang = options.key.split('_')[0];
                variante = options.key.split('_')[1];
            } else {
                lang = options.key;
                variante = null;
            }

            $http({
                method: 'POST',
                url: './api/msgs2/messages/multipleModuleRequest',
                params: { token: loginService.getToken() },
                data: { modules: seccion, languageCode: lang, countryCode: variante, prefixType: 'None' }
            }).success(function (data) {
                deferred.resolve(data);
            }).error(function () {
                deferred.reject(options.key);
            });

            return deferred.promise;
        }
    }
} ());
/*global window*/ 
;(function() {
    'use strict';

    angular.module('app')
        .provider('tokenInterceptor', [function() {

            var config = this;
            config.idleTimeout = 1800;

            this.$get = ['$injector', '$q', 'storageService', '$rootScope',
                function($injector, $q, storageService, $rootScope) {
                return {
                    request: function(request) {
                        // if not rest resources go on
                        if (!(/\/api\//).test(request.url)) {
                            return request;
                        }

                        /*var actualTimeStamp,
                            timeDiff;
                        // podemos añadir un parametro mas a la configuracion del $http para que no pase por aqui
                        if (request.skipAuthorization) {
                            return request;
                        }

                        // vamos a guardar una fecha en el localstorage
                        var lastResource = storageService.retrieve('lastResource');
                        if (!lastResource) {
                          actualTimeStamp = new Date();
                            storageService.save('lastResource', actualTimeStamp.valueOf());
                        } else {
                            // verificamos que el tiempo pasado desde la ultima peticion no supera el tiempo del idle
                            actualTimeStamp = new Date();
                            timeDiff = (actualTimeStamp.valueOf() - lastResource)/1000;
                            if ( timeDiff > config.idleTimeout) {
                                //console.log('core:timeIdleError::',timeDiff);
                                $rootScope.$emit('core:timeIdleError');
                                return $q.reject();
                            }
                            storageService.save('lastResource', actualTimeStamp.valueOf());
                        }*/

                        // manage idle
                        var actualTimeStamp;
                        actualTimeStamp = new Date();
                        storageService.save('lastResource', actualTimeStamp.valueOf());

                        //obtenemos el token
                        var _usuario = storageService.retrieve('user');
                        if (_usuario && _usuario.token) {
                            request.headers = request.headers || {};
                            request.headers['Authorization'] = _usuario.token;
                        }

                        return request;
                    },
                    requestError: function(error) {
                        return $q.reject(error);
                    },
                    response: function(response) {
                        return response;
                    },
                    responseError: function(error) {
                        return $q.reject(error);
                    }
                };
            }];
        }]);
}());

(function () {
    'use strict';

    angular
        .module('app')
        .factory('globalHelpersService', globalHelpersService);

    globalHelpersService.$inject = ['errorHandlerService','exportService'];
    function globalHelpersService(errorHandlerService,exportService) {
        var service = {
            httpPostParamsPrepare: httpPostParamsPrepare,
            exportXLSCallback:exportXLSCallback,
            exportPDFCallback:exportPDFCallback,
            getFileExtension:getFileExtension
        };

        return service;

        // private methods
        function httpPostParamsPrepare(obj) {
            var str = [];
            for (var p in obj) {
                if (obj[p]) {
                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
                }
            }
            return str.join('&');
        }

        function exportXLSCallback(data) {
            if (!data.data.response || data.data.error) {
                errorHandlerService.callbackError('SERVICE_UNAVAILABLE');
            }
            exportService.downloadUrl('./api/xlsx/res/' + data.data.response);
        }

        function exportPDFCallback(data) {
            if (!data.data.response || data.data.error) {
                errorHandlerService.callbackError('SERVICE_UNAVAILABLE');
            }
            exportService.downloadUrl('./api/pdf/res/' + data.data.response);
        }

        function getFileExtension(file) {
            var extensionMatch = file.match(/\.[^\.]+$/g);

            if (extensionMatch.length !== 1) {
                return null;
            }
            
            return extensionMatch[0];
        }

        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('filterHelperService', filterHelperService);

    /* ngInject */
    function filterHelperService($q, configurationLoaderService, errorHandlerService, $translate) {
        var service = {
            projectCodeManager: projectCodeManager,
            getFilterElementSelected: getFilterElementSelected,
            getFilterElementSelectedExternalId:getFilterElementSelectedExternalId,
            getPillsToArray: getPillsToArray,
            getProjectFrontEnd: getProjectFrontEnd,
            isCountrySelected: isCountrySelected,
            projectsAllowed: projectsAllowed,
            getComboElements: getComboElements,
            getLevelSelected: getLevelSelected,
            getOwnLevels: getOwnLevels,
            isHQ: isHQ,
            isBelowCountry: isBelowCountry,
            getFilterElementSelectedText: getFilterElementSelectedText,
            getCountrySelected: getCountrySelected,
            getCountrySelectedExternalId: getCountrySelectedExternalId,
            isDealerSelected: isDealerSelected
        };

        return service;

        /** private method */
        function projectCodeManager(value, origin, target) {
            var targetValue = _.chain(configurationLoaderService.getConfig().studyDefinition)
                .find(function (item) {
                    return item[origin] === value;
                })
                .value();

            if (!targetValue) {
                errorHandlerService.log('error', 'filterHelperService::projectCodeManager -> value not in origin');
                return null;
            }

            if (!targetValue[target]) {
                errorHandlerService.log('error', 'filterHelperService::projectCodeManager -> target invalid');
                return null;
            }

            return targetValue[target];
        }

        function getProjectFrontEnd(filterCollection) {
            return projectCodeManager(getFilterElementSelected(filterCollection, 'project'), 'ESTU_NETWORK', 'ESTU_FRONT').toLowerCase();
        }

        function getFilterElementSelected(filterCollection, eventId) {
            var item = getFilterElement(filterCollection, eventId);

            if (!item) { return null; }

            return item.id;
        }

        function getFilterElementSelectedExternalId(filterCollection, eventId) {
            var item = getFilterElement(filterCollection, eventId);

            if (!item) { return null; }

            return item.externalId;
        }

        function getFilterElementSelectedText(filterCollection, eventId) {
            var item = getFilterElement(filterCollection, eventId);

            if (!item) { return null; }

            return item.text;
        }

        function getComboElements(filterCollection, eventId) {
            return _.chain(filterCollection)
                .flatMap('data')
                .filter({ eventId: eventId })
                .value();
        }

        function getFilterElement(filterCollection, eventId) {
            return _.chain(filterCollection)
                .map('filterInfo')
                .flatten()
                .find({ eventId: eventId })
                .value();
        }

        function getPillsToArray(filterCollection) {
            return _.chain(filterCollection)
                .flatMap('filterInfo')
                .omitBy(_.isNil)
                .map(function (item) {
                    return $translate.instant(item.viewLabel) + ': ' + $translate.instant(item.text);
                })
                .value();
        }

        function projectsAllowed(sessionNetworkLinks) {
            return _.chain(sessionNetworkLinks)
                .map('project')
                .value();
        }


        /**
        * Check if node of country is selected in filters
        *
        * @param {array} filterCollection
        */
        function isCountrySelected(filterCollection) {

            var countryNode = _.chain(filterCollection).flatMap('data').filter({ 'name': 'COUNTRY' }).value();

            if (countryNode && countryNode.length > 0 && countryNode[0].selectedNode) {
                return true;
            }
            else {
                return false;
            }
        }

        function getLevels(filterCollection) {
            return _.chain(getComboElements(filterCollection, 'network'))
                .map('name')
                .value();
        }

        function getOwnLevels(filterCollection, includeOwn) {
            var levels = getLevels(filterCollection);
            var activeLevel = getLevelSelected(filterCollection);
            var indexActiveLevel = _.chain(levels).indexOf(activeLevel).value();

            if (indexActiveLevel < 0) {
                errorHandlerService.log('error', 'getOwnLevel::Level not found');
                return 0;
            }

            if (angular.isDefined(includeOwn) && !includeOwn) {
                if (indexActiveLevel === levels.length) {
                    return [activeLevel];
                }
                return _.slice(levels, indexActiveLevel + 1);
            }

            return _.slice(levels, indexActiveLevel);
        }

        function getLevelSelected(filterCollection) {
            var elementSelected = getFilterElement(filterCollection, 'network');
            return elementSelected ? elementSelected.label : null;
        }

        function isHQ(filterCollection) {
            return _.chain(configurationLoaderService.getConfig().HQLevels)
                .intersection([].concat(getLevelSelected((filterCollection))))
                .some()
                .value();
        }

        function isBelowCountry(filterCollection) {
            return !_.chain([].concat(configurationLoaderService.getConfig().HQLevels, configurationLoaderService.getConfig().countryName))
                .intersection([].concat(getLevelSelected((filterCollection))))
                .some()
                .value();
        }

        function getCountrySelected(filterCollection) {
            var countrySelected = _.chain(filterCollection).flatMap('selection').filter({ 'label': 'COUNTRY' }).value();
            
            return countrySelected ? countrySelected[0].id : null;
        }

        function getCountrySelectedExternalId(filterCollection) {
            var countrySelected = _.chain(filterCollection).flatMap('selection').filter({ 'label': 'COUNTRY' }).value();
            
            return countrySelected ? countrySelected[0].externalId : null;
        }

        function isDealerSelected(filterCollection) {
            var levelSelected = getLevelSelected(filterCollection);
            if(levelSelected == 'DEALER') {
                return true;
            }
            else {
                return false;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('filterService', filterService);

    /* @ngInject */
    function filterService($rootScope, $http, $q, storageService, $filter) {
        var mainDeferred,
            mainFilters = [],
            waterfallResponse = [],
            processing = false,
            DEFAULT_PERSISTENT = true,
            DEFAULT_USE_CACHE = true;

        var waterfallContext = {
            _tmp:[],
            filterCache: []
        };

        /** public methods */

        var service = {
            getData: getData,
            onChangeCallback: onChangeCallback,
            clearContext: clearContext,
            getContext: getContext,
            setContext: setContext,
            getFromCache:getFromCache,
            saveToLocalstorage:saveToLocalstorage
        };



        return service;

        /** private methods */

        function clearContext() {
            waterfallContext = {
                _tmp:[],
                filterCache: []
            };
        }

        function getContext() {
            return waterfallContext;
        }

        function setContext(obj) {
            return angular.extend(waterfallContext,obj);
        }

        // main entrance point
        // cancelable (return null on cancel)
        // waterfall register
        function getData(filterDefinition, useCache, persistent, clearContext) {
            if (processing) {
                console.error('Multiple filter processes running is not permited');
                return $q.reject('Multiple filter processes running is not permited');
            }

            processing = true;

            if(angular.isDefined(clearContext) && clearContext){ 
                service.clearContext(); 
            }

            mainFilters = filterDefinition;
            waterfallContext.persistent = angular.isDefined(persistent)? persistent : DEFAULT_PERSISTENT;
            mainDeferred = $q.defer();
            // storageService.save('filter', waterfallContext);
            waterfallResponse = [];
            getFromCache(useCache)
                .then(function () {
                    return getFilterGroupMultiple(mainFilters);
                })
                .then(persistFilter)
                .then(function (response) {
                    return mainDeferred.resolve(response);
                })
                .catch(function (error) {
                    return mainDeferred.reject('filterService::getData ->', error);
                })
                .finally(function(){
                    processing = false;
                });


            return mainDeferred.promise;
        }

        function persistFilter(filter) {
            // as tmp is temporal during tree computations, on end of all computations clean update
            waterfallContext._tmp = [];            
            waterfallContext.filterCache = filter;

            if (waterfallContext.persistent) {
                storageService.save('filter', waterfallContext);
            }

            return filter;
        }

        function saveToLocalstorage() {
            storageService.save('filter', waterfallContext);
        }

        // main entry point to interpret json statement
        // first part is for each group make all request and 
        // wrap them within the gruop
        function getFilterGroupMultiple(itemCollection) {
            return _.reduce(itemCollection, function (aggr, item) {
                return aggr
                    .then(function (o) {
                        var acumula = o || [];
                        return getFilterGroup.apply(waterfallContext, [item])
                            .then(function (response) {
                                if (!response) { return acumula; }
                                acumula.push(response);
                                // add to tmp so it can be accesible from other sources
                                waterfallContext._tmp.push(response);
                                return acumula;
                            });
                    });
            }, $q.when(null));
        }

        // foe each group make requests and extend info from command tree for
        // that group with the info returned by request
        function getFilterGroup(item) {
            return getMainFilters(item.sources)
                .then(function (response) {
                    // one request can return an array, but at the end 
                    // we want it to be flat
                    // add requests to group data
                    return _.extend({}, item.group, { data: _.flatten(response) });
                })
                .then(item.group.setSelection)
                .then(item.group.setFilterInfo);
        }

        // main entry point to make an array of requests
        function getMainFilters(filters) {
            return _.reduce(filters, filterWaterfallReducer, $q.when(null));
        }

        // reducer used to make sequencial requests
        // each request is called using as a context 
        // waterfallContext. We assume each filter logic
        // has access to this context and can be modified
        // from within them. So if we need to share info between
        // filters this context can be used.
        // ex: we update the context with the info of project and
        // wave so we can use it to get the right network
        // ex: we use it in case we want to get the filter from 
        // cache/localStorage, to pass this args to the filters contructor        
        function filterWaterfallReducer(aggr, item) {
            return aggr
                .then(function (o) {
                    var acumula = o || [];
                    return getMethod(item)
                        .then(function (response) {
                            if (!response) { return acumula; }
                            // each filter can return an array or a unic element
                            // we need to inject the eventId to the data structure
                            // as we use it to emit events from within the component
                            // in case it's an array we pass the same event to each
                            // element.
                            // ex: network has one only method but it return an array
                            // of elements, all will have the same eventId as this eventId
                            // is linked to the method used to request data
                            // ex: in case of project and wave each method returns one element
                            // each, so each one has its own event.
                            if (_.isArray(response.data)) {
                                response.data = _.map(response.data, function (subitem) {
                                    subitem.eventId = item.eventId;
                                    return subitem;
                                });
                            } else {
                                response.data.eventId = item.eventId;
                            }

                            acumula.push(response.data);
                            return acumula;
                        });
                });
        }

        function getMethod(item) {
            if (item.state === 'cache') {
                return $q.when(getComboData(item.eventId));
            } else {
                return item.method['getFilter'].apply(waterfallContext, item.args);
            }
        }

        function getComboData(eventId) {
            var combo;
            combo = _.chain(waterfallContext.filterCache)
                .map('data')
                .flatten()
                .filter({ eventId: eventId })
                .value();

            return { data: combo };
        }

        // method used to restore filters from localStorage, it should only update 
        // waterfallContext each filter will make use of it as needed
        function getFromCache(useCache) {
            var storedFilter = storageService.retrieve('filter');
            if (angular.isUndefined(useCache)) {
                useCache = DEFAULT_USE_CACHE;
            }
            
            if (!useCache || !storedFilter) { 
                return $q.resolve(null); 
            } else {
                waterfallContext = storedFilter;
                return $q.resolve(null);
            }


            /*return decodeSelectedId(storedFilter.selectedId, storedFilter.wave)
                .then(function (data) {
                    return data.data.response;
                });
            */
        }

        // transform id to hash
        /*function decodeSelectedId(node, wave) {
            var params = {
                token: loginService.getToken(),
                networkName: node.network,
                nodeExternalId: node.node,
                referenceDate: $filter('waveToFullDate')(wave)
            };

            return $http({
                method: 'GET',
                url: './api/networks/networkLinkToNodeId',
                params: params
            });
        }*/

        function onChangeCallback(event, object, eventId,emit) {
            
            if (!emit) {emit = true;}

            return $q.when(updateChangedItem(eventId, object))
                .then(function (nodes) {
                    return resolveDependencies(nodes, eventId);
                })
                .then(updateNodeTree)
                .then(persistFilter)
                .then(function (data) {
                    if (emit) {
                        $rootScope.$emit('filter:update', { data: data });
                    }
                    return data;
                });

        }

        function updateChangedItem(eventId, object) {
            var event = _.chain(mainFilters).flatMap('sources').find({eventId:eventId}).value();
            var resetEventObj;

            // when updating by an event could happen need to clear some selections from context, 
            // that can be done using resetContext in sources (it's an array with the names of the
            // eventids to clear')
            if (event && event.resetContext) {
                
                resetEventObj = _.reduce(event.resetContext,function(aggr,item) { 
                    aggr[item]=null;return aggr;}
                ,{})

                waterfallContext = _.extend({},waterfallContext,resetEventObj);
            }

            var nodes = _.map(waterfallContext['filterCache'], function (node) {
                var datos = _.map(node.data, function (subnode) {
                    if (subnode.eventId === eventId) {
                        subnode.selectedNode = object.id;
                    }
                    return subnode;
                });

                node.data = datos;
                return node;
            });

            if (!nodes) {
                throw ('filterService::updateChangedItem -> On update node does not exist');
            }

            waterfallContext[eventId] = object.id;
            return nodes;
        }

        function resolveDependencies(nodes, eventId) {
            var actionTree = angular.copy(mainFilters);

            actionTree = _.map(actionTree, function (parent) {
                parent.sources = _.map(parent.sources, function (child) {
                    if (child.deps && child.deps.indexOf(eventId) != -1) {
                        if (child.alwaysReprocess) {
                            waterfallContext[child.eventId] = null;
                        }
                        child.state = 'pending';
                    } else {
                        child.state = 'cache';
                    }

                    if (child.alwaysReprocess && child.eventId === eventId) {
                        child.state = 'pending';
                    }

                    return child;
                });

                return parent;
            });

            return actionTree;
        }

        function updateNodeTree(actionTree) {
            return getFilterGroupMultiple(actionTree);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('exportService', exportService);

    exportService.$inject = ['$q','$timeout'];
    function exportService($q,$timeout) {
        var service = {
            downloadUrl: downloadUrl
        };

        return service;

        /** private methods */
        function downloadUrl(url) {
            var deferred = $q.defer();

            console.log('downloading', url);

            var hiddenIFrameID = 'hiddenDownloader';
            var iframe = document.createElement('iframe');
            iframe.id = hiddenIFrameID;
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            iframe.src = url;
            $timeout(function () {
                if (iframe.remove) {
                    iframe.remove();
                } else {
                    iframe.removeNode(true);
                }
                console.log('download succesful');
                deferred.resolve();
            }, 3000);

            return deferred.promise;

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('errorHandlerService', errorHandlerService);

    errorHandlerService.$inject = ['$log', 'toastr', '$translate','$state'];
    function errorHandlerService($log, toastr, $translate,$state) {
        var service = {};
        service.log = log;
        service.callbackError = callbackError;
        service.callbackSuccess = callbackSuccess;
        service.callbackWarning = callbackWarning;

        return service;

        /** private methods */

        function log(type, message) {
            if (type === 'log') {
                $log.log(message);
            }
            else if (type === 'warn') {
                $log.warn(message);
            }
            else if (type === 'error') {
                $log.error(message);
            }
        }

        function callbackSuccess() {
            var text = this && this.text;
            var options = this && this.options;
            toastr.success($translate.instant(text),null,options);
        }

        function callbackWarning() {
            var text = this && this.text;
            var options = this && this.options; 
            toastr.warning($translate.instant(text),null,options);
        }

        function callbackError(error) {
            var _error;

            var options = this && this.options;

            if (error.data && error.data.error) {
                _error = error.data.error;
            } else if (error.data === null) {
                throw (_error);
            }  else if (error.data && error.data.name !== null) {
                if (error.data.code === 401 || error.data.code === 403) {
                    $state.go('login');
                }
                _error = error.data.message;
            }
            else {
                _error = error;
            }

            toastr.error($translate.instant(_error), options);
            throw (_error);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('waveToFullDate', waveToFullDate)
        .filter('waveToDate', waveToDate)
        .filter('waveToOla', waveToOla)
        .filter('lodashRange', lodashRange)
        .filter('trustAsHTML', trustAsHTML)
        .filter('projectFormat', projectFormat)
        .filter('decodeUri',decodeUri)
        .filter('toLocaleDate',toLocaleDate)
        .filter('calcTo100',calcTo100)
        .filter('nullToString',nullToString)
        .filter('htmlToString',htmlToString)
        .filter('cubeTitleGetTranslation',cubeTitleGetTranslation)
        .filter('quarterWave', quarterWave)
        .filter('separateCamelCase', separateCamelCase)
        .filter('fixedDecimal', fixedDecimal)
        .filter('filterToString', filterToString)
        .filter('formatThousands', formatThousands)
        .filter('boldWords',boldWords)
        .filter('projectIdToLabel',projectIdToLabel);


    /* @ngInject */
    function waveToFullDate() {
        return function (wave) {

            var year = wave.substr(0, 4),
                month = wave.substr(4, 2),
                day = '02';

            return year + '-' + month + '-' + day;

        };
    }

    /* @ngInject */
    function waveToDate($translate) {
        return function (wave) {
            if (!wave) { return 'NO WAVE'; }
            // la idea es del formato 201501 -> Jan 2015
            var year = wave.toString().substr(0, 4);
            var month = wave.toString().substr(4, 2);

            switch (month) {
                case '01':
                    return $translate.instant('JAN') + ' ' + year;
                case '02':
                    return $translate.instant('FEB') + ' ' + year;
                case '03':
                    return $translate.instant('MAR') + ' ' + year;
                case '04':
                    return $translate.instant('APR') + ' ' + year;
                case '05':
                    return $translate.instant('MAY') + ' ' + year;
                case '06':
                    return $translate.instant('JUN') + ' ' + year;
                case '07':
                    return $translate.instant('JUL') + ' ' + year;
                case '08':
                    return $translate.instant('AUG') + ' ' + year;
                case '09':
                    return $translate.instant('SEP') + ' ' + year;
                case '10':
                    return $translate.instant('OCT') + ' ' + year;
                case '11':
                    return $translate.instant('NOV') + ' ' + year;
                case '12':
                    return $translate.instant('DEC') + ' ' + year;
            }

            return 'NO WAVE';
        };
    }

    /* @ngInject */
    function waveToOla() {
        return function (wave) {

            switch (wave) {
                case '01':
                    return '1ª Ola';
                case '02':
                    return '2ª Ola';
                case '03':
                    return '3ª Ola';
            }
        };
    }

    lodashRange.$inject = ['errorHandlerService'];
    function lodashRange(errorHandlerService) {
        return function(value) {
            try {
                if (!value) {return [];}
                
                var num = parseInt(value);
                
                return _.range(num);    
            } catch (error) {
                errorHandlerService.log('error','lodashRange --> Not valid number');
                return [];
            }
        };
    }

    trustAsHTML.$inject = ['$sce'];
    function trustAsHTML($sce) {
        return function(value) {
            return $sce.trustAsHtml(value);
        };
    }

    projectFormat.$inject = ['filterHelperService'];
    function projectFormat(filterHelperService) {
        return function(value, origin, target) {
            return filterHelperService.projectCodeManager(value, origin, target);
        };
    }

    function decodeUri() {
        return function(value) {
            return decodeURIComponent(value); 
        };
    }

    toLocaleDate.$inject = ['moment'];
    function toLocaleDate(moment) {
        return function(value) {
            return moment(value).format('lll'); 
        };
    }
    
    function htmlToString() {
        return function(value) {
            // clone element so the mutations don't affect the element origin
            var width = value.clientWidth;
            var _element = angular.element(value).clone();
            // remove elements specified with no-snapshot 
            _element.find('.no-snapshot').remove();
            //also the highcharts tooltips
            _element.find('.highcharts-tooltip').remove();

            // put it on the middle
            _element = _element.css({'width': width+'px'});

            // return the node stringified             
            return _element.get(0).outerHTML;
        };
    }

    calcTo100.$inject = ['errorHandlerService'];
    function calcTo100(errorHandlerService) {
        return function(value,max,min) {
            var _total,_value;

            _total = max-min;
            _value = value-min;

            if (_value > 0 && min < 0) {
                _value -= min;
            }

            if (_total === 0) {
                errorHandlerService.log('error','calcTo100::Error 0 divisor');
                return 0;
            }
            
            return  (_value*100)/_total;
        };
    }

    function nullToString() {
        return function(value,outputString) {
            return  angular.isUndefined(value) || value === null || value === ''? outputString:value;
        };
    }

    function cubeTitleGetTranslation() {
        return function(value) {
            var output;
            if (angular.isUndefined(value) || value === null) {
                return '';
            }

            output = value.match(/\^.*$/);

            if (!output) {
                return '';
            }

            return output[0].replace('^','');
        };
    }

    function quarterWave(){
        return function(value) {
            var year = value.toString().substring(0, 4);
            var quarter = parseInt(value.toString().substring(4, 6));

            return quarter + 'ª Ola ' + (year === 'xxxx' ? '' : year);
        };
    }

    function separateCamelCase(){
        return function(value){
            return value
            // insert a space before all caps
            .replace(/([A-Z])/g, ' $1')
            // uppercase the first character
            .replace(/^./, function(str){ return str.toUpperCase(); });
        };
    }

    fixedDecimal.$inject = ['globalHelpersService'];
    function fixedDecimal(globalHelpersService){
        return function(value){
            return globalHelpersService.frontFixedDecimal(value);
        };
    }

    function filterToString(){
        return function(wave, station, program){
            var newWave = quarterWave()(wave);
            var newStation = station.label;
            var newProgram = program && program.id !== 'TOTAL' ? ', ' + program.label : '';

            return newWave + ', ' + newStation + newProgram;
        };
    }

    /**
     * Ponemos los puntos a los miles.
     * Ej: 25000 --> 25.000
     */
    function formatThousands(){
        return function(value){
            return parseInt(value).toLocaleString('es');
        };
    }

    function boldWords(){
        return function(value, wordsToBold){
            var input = value.split(' ');
            var finalTexT = '<p>';
            _.chain(input).each(function(item,index){
                if(_.includes(wordsToBold, input[index])){
                    finalTexT += ' <span class="bold--700"> '+ (item && item.toUpperCase()) +' </span> ';
                }
                else{
                    finalTexT += ' '+(item && item.toUpperCase()) +' ';
                }
            }).value();
            finalTexT += '</p>';
            return finalTexT;
        };
    }

    projectIdToLabel.$inject = ['configurationLoaderService'];
    function projectIdToLabel(configurationLoaderService) {
        return function(value){
            var projectObj = _.chain(configurationLoaderService.getConfig().projectLabels)
                .find({id:value})
                .value();
            
            if (!projectObj) {
                return '-';
            }

            return projectObj.label;
        };
    }

})();
(function() {
'use strict';

  angular
    .module('app.core')
    .factory('configurationLoaderService', configurationLoaderService);

  /* ngInject */
  function configurationLoaderService($http,errorHandlerService) {
    var service = {
      getRemoteConfig:getRemoteConfig,
      getConfig:getConfig,
      getMenu: getMenu
    };

    var config;
    
    return service;

    /** private methods */
    function getRemoteConfig() {
      return $http({
        method:'GET',
        url:'./data/config.json'
      })
      .then(function(data) {
        config = data.data;
        errorHandlerService.log('log','configurationLoaderService OK');
      });
    }

    function getConfig() {
      return config;
    }

    function getMenu(menuCollection, roles){
      var visibleMenuCollection = _.map(menuCollection, function(item){
        if(!item.visible) { 
          return item;
        }
        else {
          item.visible = item.allowedRoles && item.allowedRoles.length > 0 && _.intersection(item.allowedRoles, roles).length === 0 ? false : true;
          return item; 
        }
      });
      
      return angular.copy(visibleMenuCollection);
    }
  }
})();
(function () {
    'use strict';
  
    angular
      .module('app')
      .factory('fieldpageService', fieldpageService);
  
    fieldpageService.inject = ['$http', '$q', 'errorHandlerService' ];
  
    function fieldpageService($http, $q, errorHandlerService ) {
      
      var service = {
        getData: getData
      };
  
      return service;
  
      ////////////////
      function getData(mst, cmd) {

        return $q.all([getTeorica(mst, cmd), getReal(mst, cmd), getProyeccion(mst, cmd)])
        .then( function(res) {
          return res;
        })
        .catch(errorHandlerService.callbackError);
      }

      function getProyeccion(mst, cmd){
        return $http({
          method:'GET',
          url:'./data/PROYECCION.json'
        })
        .then( function(response) {
          if ( response && response.data ){

            var selected = _.filter( response.data, { 'filter': mst, 'header': cmd} );
            var series = _.map(selected[0].datos, function(item){
              return item.abs
            });
            var date = _.chain(selected).find('date').result('date').value();
            var serieProyeccion = {
              name: "MUESTRA PROYECCION",
              color: "#F7D3CB",
              data: series,
              zIndex: 1,
              date:date
            };
            return serieProyeccion;
          }
        })
        .catch(function(){
            return $q.when(null);
        });  
      }

      function getTeorica(mst, cmd) {

        return $http({
          method:'GET',
          url:'./data/TEORICA.json'
        })
        .then( function(response) {
          if ( response && response.data ){

            var selected = _.filter( response.data, { 'filter': mst, 'header': cmd} );
            var series = _.map(selected[0].datos, function(item){
              return item.abs
            });
            var categorias = _.map(selected[0].datos, function(item){
              return item.item
            }); 
            var serieTeorica = {
              name: "MUESTRA TEÓRICA",
              color: "#6FC6DA",
              data: series,
              zIndex: 2,
              categorias: categorias

            };
            return serieTeorica;
          }
        })
        .catch(function(){
            return $q.when(null);
        });  

      }

      function getReal(mst, cmd) {
        return $http({
          method:'GET',
          url:'./data/REAL.json'
        })
        .then( function(response) {
          if ( response && response.data ){

            // var comunidades = response.data.map( function(item){return  item.header});
            // var listaCombo = _.uniqWith(comunidades, _.isEqual);
            var selected = _.filter( response.data, { 'filter': mst, 'header': cmd} );
            var series = _.map(selected[0].datos, function(item){
              return item.abs
            });
            var serieReal = {
              name: "MUESTRA REAL",
              color: "#ED937D",
              data: series,
              zIndex: 2
              
            };
            return serieReal;
          }
        })
        .catch(function(){
            return $q.when(null);
        });  
      }
    }
  })();
  
(function() {
    'use strict';
  
    angular
      .module('app')
      .config(routerConfig);
  
    routerConfig.$inject = ['$stateProvider'];  
    function routerConfig($stateProvider) {
      $stateProvider
        .state('main.fieldpage', {
          url: '/fieldpage',
          templateUrl: 'app/fieldpage/fieldpage.html',
          controller: 'FieldPageController',
          controllerAs: 'fieldpage',
          resolve:{
            timing: timing
          }
        });
    }
  
    timing.$inject = ['publicaciones','configuration'];
    function timing(publicaciones,configuration) {
      return true;
    }
  
  
  })();
  
(function () {
    'use strict';
  
    angular
      .module('app')
      .controller('FieldPageController', FieldPageController);
  
      FieldPageController.$inject = ['$rootScope','$scope', 'errorHandlerService', 'fieldpageService', 'userHelperService', 'configurationLoaderService'];
    function FieldPageController($rootScope, $scope, errorHandlerService, fieldpageService, userHelperService, configurationLoaderService ) {
        var vm = this;

        vm.muestras = ['Multimedia F2F','Multimedia Online','Radio Telefónico','Prensa Telefónico','Televisión Telefónico','Revistas F2F','Revistas Online'];
        vm.comunidades = ['TOTAL','Andalucía','Aragón','Asturias','Baleares','Cantabria','Castilla/León', 'Castilla/Mancha','Cataluña','Extremadura','Galicia','Madrid','Murcia','Navarra','C.Valenciana','País Vasco','La Rioja','Canarias'];
        vm.widgetField = {
            data: null,
            loading: false
        }

        /** TABLE info */
        vm.table = {
            data: [],
            columnsDef: [],
            columns: [],
            paginate: true,
            showLengthMenu: true
        };

        /* COLUMNS_DEF default */
        var columnsDef = [
            {
            targets: '_all',
            className: 'text-center'
            }];

        vm.changeSelected = changeSelected;
        var updateMuestra = vm.muestras[0];
        var updateComunidad = vm.comunidades[0];

      init();
  
      /** listeners */
        var displayerChangeListenerMuestra = $rootScope.$on('select2:changeSelection:muestra', changeSelected);
        var displayerChangeListenerComunidad = $rootScope.$on('select2:changeSelection:comunidad', changeSelected);
    
        $scope.$on('$destroy', function () { 
            displayerChangeListenerMuestra();
            displayerChangeListenerComunidad();
        });

      /** private methods */
  
        function init() {

            vm.widgetField.data = null;
            vm.widgetField.loading = true;
            if ( angular.isUndefined(updateMuestra) || angular.isUndefined(updateComunidad)){
                return;
                // errorHandlerService.callbackWarning.bind({ text: 'Seleccione ambos campos', options: { closeButton: true } })();    
            }
            vm.table.languageUrl = configurationLoaderService.getConfig().datatablesLanguageUrl['es_ES'];
            getField(updateMuestra, updateComunidad);

        }

        function getField(mtr, cmd) {
            fieldpageService.getData(mtr, cmd)
            .then(function(data) {
                if(data) {

                    //Recuperamos la fecha de carga de PROYECCION
                    var dateLoad = _.chain(data).find( {'name': 'MUESTRA PROYECCION'}).result('date').value();
                    vm.dateLoad = !angular.isUndefined(dateLoad) ? dateLoad : 'Error al recuperar la fecha';
                    vm.widgetField.data = _.filter(data, function(item)
                    {
                     if ( item !== null){
                         return item;
                     }
                    });
                    transformTable(vm.widgetField.data);
                }
                else {
                    vm.widgetField.data = null;
                }
            })
            .catch(fieldError)
            .finally(
                function() {
                    vm.widgetField.loading = false;
                }  
            )
        }

        function fieldError(error){
            errorHandlerService.callbackError('Error recuperando los datos');
        }

        function changeSelected(event, args) {

            var index = event.name.split(':')[2];
            if ( index === 'muestra' ) {
                updateMuestra = args.id;    
            }else if ( index === 'comunidad' ) {
                updateComunidad = args.id; 
            }
            return init();

        }

        function transformTable(data) {

            var totalCategories = data[0].categorias;

            var columns = _.reduce(data, function(aggr, item){
                var column = {
                    name: item.name,
                    title: item.name,
                    searchable: false,
                    visible: true,
                    orderable: false,
                    width: '10%',
                    id: item.name,
                    className: null,
                    metadata: null
                }
                aggr.push(column);
                return aggr;
            },[]);

            columns.unshift({
                name: "DIA",
                title: "Día",
                searchable: false,
                visible: true,
                orderable: false,
                width: '2%',
                id: "DIA",
                className: null,
                metadata: null
            })

            var totalDatosDias = [];
            
            _.forEach( totalCategories, function(value) {
                var totalDataDia = _.reduce( data, function(aggr, item){
                    var dataDia;
                    if ( angular.isUndefined(item.data[value-1]) ){
                        dataDia = "-";
                        aggr.push(dataDia);
                    }
                    else{
                        dataDia = item.data[value-1];
                        aggr.push(dataDia);
                    }
                    return aggr;
                },[])
                totalDataDia.unshift(value);
                totalDatosDias.push(totalDataDia);
            })
     
            vm.table.columns = columns;
            vm.table.columnsDef = columnsDef;
            vm.table.data = totalDatosDias;
             
        }
            
    }
  })();
  
(function () {
  'use strict';

  angular
    .module('app')
    .run(runBlock);

  /** @ngInject */
  function runBlock($state, errorHandlerService, configurationLoaderService, routingService, $rootScope, $window, storageService) {
    errorHandlerService.log('log', 'Enter run block');

    // register callbacks on route change
    routingService.registerCallbacks();

    $rootScope.$on('core:timeIdleError',function(){
      console.error('TIMED_OUT');
      storageService.clear();  
      $state.go('login');  
      $window.location.reload();           
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/home',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      });

    $urlRouterProvider.otherwise('/login');
  }

})();

/* global moment:false, _:false */
(function() {
  'use strict';

  angular
    .module('app')
    .constant('moment', moment)
    .constant('lodash', _);
})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig,$translateProvider,$httpProvider, tokenInterceptorProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // translations
    $translateProvider.useLoader('i18nService', {});
    //$translateProvider.preferredLanguage('en');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-bottom-full-width';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = false;    

    $httpProvider.interceptors.push('tokenInterceptor');

    
  }

})();
